<template>
    <div id="app1" class="min-w-[1400px]">
        <div id="container" style="height: 750px;" >

        </div>
        <div id="initLoader" v-if="loading" class="loader"></div>
        <div v-if="local" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 1)">
            <div class="item period customerlogo">
                <img :src="logo" alt="" style="height: 40px;">
            </div>
            <div class="item period list selected">{{ local.public.product_list }}</div>
            <div class="item period selected order">{{ local.public.submit_order }}</div>

            <!-- 左邊 -->
            <div class="box-shadow ml-10 rounded-10 min-w-350 w-350 leftbox" style="flex-basis: 350px;">
                <div class="p-10 flex">
                    <div class="base-input w-full"><i class="el-icon ml-16 mr-10" style="font-size: 20px;"><svg
                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                <path fill="currentColor"
                                    d="m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704z">
                                </path>
                            </svg></i><input v-model="search.string" @input="changeType()" class="pr-20"></div>
                    <el-select class="el-select trade-type ml-10" v-model="search.type" clearable
                        @change="changeType()">
                        <el-option v-for="item in CategoriesList" :key="item.categoryName"
                            :label="item.categoryName" :value="item.categoryName"></el-option>
                    </el-select>
                </div>
                <div class="h-700 overflow-auto element infinite-list" ref="infinite-list" style="overflow:auto">
                    <div class="symbol-contain" v-show="marketList.length > 0">
                        <div @click="clickMarket(item)" v-for="item in marketList" :key="item.symbol"
                            class="flex py-14 cursor-pointer items-center symbol-item hover:bg-gray-100 px-10 bottom-border"
                            :class="{ 'bg-active': market.symbol == item.symbol }">
                            <div class="flex-1 flex items-center">
                                <img class="w-36 h-36" :src="item.symbolLogo" v-if="item.type != 'US Stock'">
                                <span class="pl-10">{{ item.name }}</span>
                            </div>
                            <div class="flex-1 " :class="item.netChanges > 0 ? 'text-kline-up' : 'text-kline-down'">
                                {{ item.close }}</div>
                            <span v-if="item?.item?.marketStatus"
                                class="rounded-8 text-white w-80 text-center py-6 text-12 "
                                :class="item.netChanges > 0 ? 'bg-kline-up' : 'bg-kline-down'">{{
                                    item.netChanges > 0 ? "+" : ""
                                }}{{ item.netChanges }}% </span>
                            <span v-else
                                class="bg-main-gray text-12 w-80 py-4 rounded-8 text-center text-white">Closed</span>
                        </div>
                    </div>
                    <div v-if="listLoading"
                        style="height:30px;z-index:999;display: flex;justify-content: center;align-items: center;">
                        loading.....
                    </div>

                    <div class="el-empty" v-show="!marketList.length">
                        <el-empty :description="local.public.no_data"></el-empty>
                    </div>
                </div>
            </div>
            <!-- 右邊 -->
            <div class="w-324 min-w-324 ml-10 mr-20 rightbox" style="flex-basis: 324px;">
                <div v-if="loginStaus" class="assets-card p-20 bg-primary rounded-10 text-white flex flex-col mb-18">
                    <div class="text-14 py-6">UID : {{ userInfo.user && userInfo.user.uid }}</div>
                    <div class="text-14">{{ local.user.useful_balance }}</div>
                    <div class="text-lg font-bold">{{ user_balance }}</div>
                </div>
                <div v-else class="assets-card p-20 bg-primary rounded-10 text-white flex flex-col mb-18">
                    <!---->
                    <div class="text-14">{{local.user.useful_balance }}</div>
                    <div class="text-base font-semibold mt-10">$0</div>
                    <div class="text-black flex mt-10 text-12">
                        <div class="flex items-center px-20 rounded-xl bg-white">{{ local.public.today }} 
                            <i class="van-badge__wrapper van-icon van-icon-play ml-10 -rotate-90" style="color: rgb(133, 189, 0);"><!----><!----><!----></i>
                            <span class="text-kline-up">0%</span>
                        </div>
                    </div>
                </div>
                <div class="box-shadow rounded-10 p-20 box-border bg-white" >
                    <div class="flex bg-[#EEEEEE] dark:bg-[#171e28] p-[5px] rounded-4 text-center text-18">
                        <div  class="flex-1 py-6 cursor-pointer"
                            :class="activeTab === 'contract' ? 'bg-kline-up text-white rounded-4' : 'text-[#999999] dark:text-[#C5C5C5]'"
                            @click="switchTab('contract')"
                        >{{local.func.contract}}</div>
                        <div  class="flex-1 py-6 cursor-pointer"
                            :class="activeTab === 'future' ? 'bg-kline-up text-white rounded-4' : 'text-[#999999] dark:text-[#C5C5C5]'"
                            @click="switchTab('future')"
                        >{{local.func.future}}</div>

                    </div>

                    <div style="" v-show="activeTab === 'contract'">
                        <div class="flex items-center justify-between mt-10">
                            <div class="text-18">{{ market.name }}</div>
                            <div class="text-xs text-kline-up">{{ market.close }}</div>
                        </div>
                        <el-select size="medium" class="el-select w-full mt-4 selectlanguage"
                            v-model="order.market_price">
                            <el-option :label="local.order.market_price" value="1"></el-option>
                            <el-option :label="local.order.un_deal_order" value="2"></el-option>
                        </el-select>
                        <div v-if="order.market_price == 2">
                            <div class="text-18 mt-10 flex items-center justify-between">
                                <div>{{ local.trade.buy_price }} </div>
                            </div>
                            <el-input size="medium" v-model="order.target_price" class="w-full mt-4">
                            </el-input>

                        </div>
                        <div class="text-18 mt-10">{{ local.order.times }} </div>
                        <el-select size="medium" class="el-select w-full mt-4 selectlanguage" v-model="order.times">
                            <el-option v-for="item in market?.leverList" :label="item.times" :value="item.times"
                                :key="item.id"></el-option>
                        </el-select>

                        <div>
                            <div class="text-18 mt-10 flex items-center justify-between">
                                <div>{{ local.order.stop_loss }} </div>
                                <el-switch v-model="order.stop_loss_status" size="small"
                                    @change="order.stop_loss = (market.close).toFixed(5) * 1"></el-switch>

                            </div>
                            <el-input-number size="medium" :disabled="!order.stop_loss_status" v-model="order.stop_loss"
                                class="w-full mt-4">
                            </el-input-number>

                        </div>
                        <div>
                            <div class="text-18 mt-10 flex items-center justify-between">
                                <div>{{ local.order.stop_profit }}</div>
                                <el-switch v-model="order.stop_profit_status" size="small"
                                    @change="order.stop_profit = (market.close).toFixed(5) * 1"></el-switch>
                            </div>
                            <el-input-number size="medium" :disabled="!order.stop_profit_status"
                                v-model="order.stop_profit" class="w-full mt-4"></el-input-number>
                        </div>
                        <div>
                            <div class="text-18 mt-10">{{ local.order.trade_amount }}(Step:{{ market?.item?.step }})
                            </div>
                            <el-input-number size="medium" :step="market?.item?.step || 0.1" class="w-full mt-4"
                                v-model="order.trade_amount">
                            </el-input-number>

                        </div>
                        <div class="text-12 py-16">
                            <!-- <div class="flex items-center justify-between mt-8">
                                <div>{{ local.order.unit }} </div>
                                <div> 1 {{ local.order.trade_amount }} = {{ market?.item?.unitAmount }} {{
                                    market?.name
                                }}
                                </div>
                            </div> -->
                            <div class="flex items-center justify-between mt-8">
                                <div>{{ local.order.calc_handle_fee }}</div>
                                <div>{{ (market?.item?.unitFee * order.trade_amount).toFixed(5) }} </div>
                            </div>
                            <div class="flex items-center justify-between mt-8">
                                <div>{{ local.order.calc_bond_fee }} </div>
                                <!-- <div v-if="order.market_price == 1">{{ market?.item?.modelStatus == 1
                            ? (market?.item?.unitAmount * order.trade_amount *
                                market.close / order.times).toFixed(5) || 0 : market?.item?.pointValue || 0}}</div>
                                <div v-if="order.market_price == 2">{{ market?.item?.modelStatus ==
                                    1 ? (market?.item?.unitAmount * order.trade_amount *
                                        Number(order.target_price) / order.times).toFixed(5) || 0 : market?.item?.pointValue
                                || 0}}</div> -->
                                <div>{{ market?.item?.modelStatus == 1
                                ? (1000 * order.trade_amount).toFixed(5) || 0 : market?.item?.pointValue || 0}}
                                </div>
                            </div>
                        </div>
                        <!-- v-if="market.MarketStatus==1" -->
                        <div class="flex" v-if="market?.item?.marketStatus"><button aria-disabled="false"
                                @click="submitOrder(1)" type="button"
                                class="el-button el-button--primary is-round bg-kline-up flex-1 border-0 h-36 bg-kline-up">
                                <span class="">{{ local.trade.buy }}</span></button><button aria-disabled="false"
                                type="button" @click="submitOrder(2)"
                                class="el-button el-button--danger is-round flex-1 border-0 h-36 bg-kline-down">
                                <span class="">{{ local.trade.sell }}</span></button></div>

                        <div v-else class="flex"><button aria-disabled="true" type="button"
                                class="el-button el-button--primary is-disabled is-round bg-kline-up flex-1 border-0 h-36 bg-main-gray"
                                disabled=""><span class="">Buy</span></button><button aria-disabled="true" type="button"
                                class="el-button el-button--primary is-disabled is-round flex-1 border-0 h-36 bg-main-gray"
                                disabled=""><span class="">Sell</span></button></div>
                    </div>

                    <div v-show="activeTab === 'future'">
                        <div class="bg-[#E9F3E6] dark:bg-[#171e28] rounded-8 mt-12">
                            <div class="bg-[#f8f8f8] dark:bg-[#171e28] px-20 pt-14 pb-10 rounded-8">
                                <div class="flex items-center justify-between">
                                    <div class="text-[#666] dark:text-white"> {{ market.name }} </div>
                                    <div class="text-kline-up"> {{ market.close }} </div>
                                </div>
                            </div>
                            <div class="p-12 px-20">
                                <div class="text-[#111111] dark:text-white font-medium">
                                {{local.micro.select_trade_time}}
                                </div>
                                <div class="flex items-center flex-wrap">
                                    <div class="w-50 text-center rounded-4 mr-8 mt-10" 
                                    :class="{'bg-kline-up text-white': selectedMarketIndex === index, 'bg-white text-black': selectedMarketIndex !== index }"
                                    v-for="(marketTerm, index) in marketTermList" :key="marketTerm.id"
                                    @click="selectedMarketIndex = index,selectedPush(marketTerm)">
                                    {{ marketTerm.expirationDate }} 
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center justify-between mt-12">
                            <span class="text-[#999] dark:text-white">{{local.micro.calc_profit_rate}}</span>
                            <span>{{selectedMarketTerm.estimatedRevenueRate}}%</span>
                        </div>
                        <div class="bg-[#f8f8f8] dark:bg-[#171e28] rounded-8 mt-12 p-12">
                            <div>
                            {{local.micro.trade_num}}
                            <span>（&gt;={{selectedMarketTerm.minTransactionQuantity}}）</span>
                            </div>
                            <div class="base-input bg-[#f8f8f8] dark:bg-[#313F53] w-full bg-transparent border-0 text-16 mt-10" style="padding-left: 10px !important; padding-right: 10px !important;">
                            <span></span>
                            <input class="text-[#333] dark:text-white" :placeholder="local.micro.input_trade_num" @keyup="calcIncome()" v-model="userTerm.transactionQuantity" type="number"/>
                            <div class="el-dropdown">
                            <i class="van-badge__wrapper van-icon van-icon-arrow p-4 el-tooltip__trigger el-tooltip__trigger" id="el-id-8449-46" role="button" tabindex="0" aria-controls="el-id-8449-47" aria-expanded="false" aria-haspopup="menu" style="color: rgb(50, 50, 51); font-size: 1.2rem;">
                            <!---->
                            <!---->
                            <!----></i>
                            <!--v-if-->
                            </div>
                            </div>
                            <div class="flex items-center justify-between text-[#999] mt-4">
                            <span>{{local.micro.calc_income}}</span>
                            <span>{{userTerm.expectedRevenue}} USD</span>
                            </div>
                        </div>
                        <div class="flex justify-between items-center mt-10">
                            <button type="button" @click="userTermAdd(0)" class="van-button van-button--default van-button--normal w-[48%] rounded-8 h-36" style="color: white; background: rgb(133, 189, 0); border-color: rgb(133, 189, 0);">
                                <div class="van-button__content">
                                <!---->
                                <span class="van-button__text">{{local.micro.buy_up}}</span>
                                <!---->
                                </div>
                            </button>
                            <button type="button" @click="userTermAdd(1)" class="van-button van-button--default van-button--normal w-[48%] rounded-8 h-36" style="color: white; background: rgb(246, 84, 62); border-color: rgb(246, 84, 62);">
                                <div class="van-button__content">
                                <!---->
                                <span class="van-button__text">{{local.micro.buy_down}}</span>
                                <!---->
                                </div>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <!-- 未登录 -->

            <div class="rightfixed">

                <button aria-disabled="false" @click="loan" type="button" class="el-button text-main-black dark:text-white">
                    <span style="align-items: center;display: inline-flex;margin-right: 20px;margin-left: 20px;">
                        <i class="el-icon" style="--color: #1a222b;"><img src="../assets/DEMO_files/loan818e7595.png" class="w-14 h-14"></i>
                        <span style="color: #000;" >{{ local.func.loan }}</span>
                    </span>
                </button>

                <button aria-disabled="false"  @click="mining" type="button" class="el-button text-main-black dark:text-white">
                    <span style="align-items: center;display: inline-flex;margin-right: 20px;margin-left: 20px;">
                        <i class="el-icon" style="--color: #1a222b;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M926.784 480H701.312A192.512 192.512 0 0 0 544 322.688V97.216A416.064 416.064 0 0 1 926.784 480m0 64A416.064 416.064 0 0 1 544 926.784V701.312A192.512 192.512 0 0 0 701.312 544zM97.28 544h225.472A192.512 192.512 0 0 0 480 701.312v225.472A416.064 416.064 0 0 1 97.216 544zm0-64A416.064 416.064 0 0 1 480 97.216v225.472A192.512 192.512 0 0 0 322.688 480H97.216z"></path></svg></i>
                        <span style="color: #000;">{{ local.mining.mining }}</span>
                    </span>
                </button>
                <button aria-disabled="false" @click="follow" type="button" class="el-button text-main-black dark:text-white">
                    <span style="align-items: center;display: inline-flex;margin-right: 20px;margin-left: 20px;">
                        <i class="el-icon" style="--color: #1a222b;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M128 320v576h576V320zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32M960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32M256 672h320v64H256zm0-192h320v64H256z"></path></svg></i>
                        <span style="color: #000;" >{{ local.follow.follow }}</span>
                    </span>
                </button>

                <div v-if="!loginStaus" class="flex items-center justify-end ">

                    
                
                    <el-select style="margin-right: 20px;margin-left: 20px;" @change="changeCountry" v-model="conturyValue"
                        class="mr-10 selectlanguage">
                        <el-option v-for="item in contury" :key="item.label" :label="item.label"
                            :value="item.value">
                            <div style="display: flex;align-items: center;">
                                <img style="width: 40px;height: 20px;" :src="item.imgUrl" />
                                <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 20px;">{{
                                    item.label
                                }}</span>
                            </div>

                        </el-option>
                    </el-select>

                    <div class="flex items-center text-main-black">
                        <el-button @click="active = 12" type="text" style="color: #000;">{{
                            local.user.login
                        }}</el-button>
                        <span>｜</span>
                        <el-button @click="active = 13" type="text" style="color: #000;">{{
                            local.user.register
                        }}</el-button>
                        <span>｜</span>
                        
                        <el-switch v-model="isDark" text="深色模式" e-text="浅色模式" @change="toggleTheme">
                            <i class="el-icon" style="--color: #606266;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M512 704a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m0-704a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 768a32 32 0 0 1 32 32v64a32 32 0 1 1-64 0v-64a32 32 0 0 1 32-32M195.2 195.2a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 1 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm543.104 543.104a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 0 1-45.248 45.248l-45.248-45.248a32 32 0 0 1 0-45.248M64 512a32 32 0 0 1 32-32h64a32 32 0 0 1 0 64H96a32 32 0 0 1-32-32m768 0a32 32 0 0 1 32-32h64a32 32 0 1 1 0 64h-64a32 32 0 0 1-32-32M195.2 828.8a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248L240.448 828.8a32 32 0 0 1-45.248 0zm543.104-543.104a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248l-45.248 45.248a32 32 0 0 1-45.248 0"></path></svg></i>
                        </el-switch>
                    </div>
                </div>
                <div v-if="loginStaus" class="flex items-center justify-end ">
                    <el-select class="selectlanguage mr-10" @change="changeCountry" v-model="conturyValue"
                        style="margin-right: 20px;">
                        <el-option v-for="item in contury" :key="item.label" :label="item.label"
                            :value="item.value">
                            <div style="display: flex;align-items: center;">
                                <img style="width: 40px;height: 20px;" :src="item.imgUrl"></img>
                                <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 20px;">{{
                                    item.label
                                }}</span>
                            </div>

                        </el-option>
                    </el-select>
                    <el-button @click="active = 1; dialogShow = true" style="color: #000;" type="text">{{
                        userInfo?.user?.email
                    }}
                    </el-button>
                    <el-switch  v-model="isDark" text="深色模式" e-text="浅色模式" @change="toggleTheme"</el-switch>
                </div>
            </div>

            <!-- 跟随div -->
            <div v-if="active == 19"></div>

            <!-- 理财div -->
            <div v-if="active == 18">

                <div  class="el-overlay" style="z-index: 2012;--el-dialog-width: 1440px;">
                    <div role="dialog" aria-modal="true" aria-labelledby="el-id-7467-98" aria-describedby="el-id-7467-99" class="el-overlay-dialog">
                        <div class="el-dialog mt-30 rounded-10 box-shadow min-h-500" tabindex="-1" style="--el-dialog-width: 1440px;" >
                            <header class="el-dialog__header show-close">
                                <div class="text-center text-black text-xs">{{ local.mining.mining }}</div>
                                <button  aria-label="關閉此對話框"  class="el-dialog__headerbtn" type="button" @click="closeMiningDialog" >
                                <i class="el-icon el-dialog__close">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                    <path fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path>
                                    </svg>
                                </i>
                                </button>
                            </header>
                        
                            <div v-if="showfinancialProducts" id="el-id-7467-99" class="el-dialog__body">
                                <div>
                                <div class="max-w-[1200px] mx-auto w-full flex flex-col">
                                    <div class="el-card is-always-shadow w-full">
                                    <div class="el-card__body">
                                        <div class="flex items-center justify-between">
                                        <span class="text-18">{{local.mining.machine_list}}</span>
                                        <button 
                                            aria-disabled="false" 
                                            type="button" 
                                            class="el-button is-link"
                                            @click="goToPurchaseList"
                                        >
                                            <span class="">{{local.mining.subscribe_list}}</span>
                                        </button>
                                        </div>
                                    </div>
                                    </div>
                                    
                                    <div class="el-card is-always-shadow w-full mt-10 max-h-[600px] overflow-y-auto">
                                    <div class="el-card__body">
                                        <!-- 矿机项目列表 -->
                                        <div  v-for="(item, index) in financialProducts" :key="index"
                                        class="bg-[#f8f8f8] dark:bg-[#313F53] rounded-16 p-12 text-12 mb-18"
                                        >
                                        <div class="text-center text-18">{{ item.productNo }}</div>
                                        <div class="el-divider el-divider--horizontal mt-10" role="separator" style="--el-border-style: solid;"></div>
                                        
                                        <div class="flex items-center justify-between p-20 pt-0">
                                            <img class="w-60 h-60" src="../assets/DEMO_files/47dc2c9f62dbbd2ad064b2af61b8f8a0.png">
                                            <div class="flex-1 ml-10">
                                            <div class="text-18">{{ item.itemName }}</div>
                                            <div>
                                                <div class="text-14">{{local.mining.expected_profit}}: {{ item.expectedNissan }} </div>
                                                <div class="text-12">{{local.mining.machine_rent}} {{ item.miningMachineRental }}</div>
                                            </div>
                                            </div>
                                            
                                            <button type="button" class="el-button rounded-4 h-40 text-14 px-20 text-white" block=""
                                            style="--el-button-bg-color: #85BD00; --el-button-text-color: var(--el-color-black); --el-button-border-color: #85BD00; --el-button-hover-bg-color: rgb(170, 209, 77); --el-button-hover-text-color: var(--el-color-black); --el-button-hover-border-color: rgb(170, 209, 77); --el-button-active-bg-color: rgb(110, 155, 4); --el-button-active-border-color: rgb(110, 155, 4);"
                                            @click="handleSubscribe(item)"
                                            >
                                            <span class="">{{ local.mining.subscribe }}</span>
                                            </button>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div v-if="showUserProducts" class="max-w-[1200px] mx-auto w-full flex flex-col mining-submit-order-page">
                                <!-- 面包屑导航 -->
                                <div class="el-card is-always-shadow w-full">
                                    <div class="el-card__body">
                                        <div class="el-breadcrumb" aria-label="面包屑" role="navigation">
                                        <span class="el-breadcrumb__item cursor-pointer" @click="goBack">
                                            <span class="el-breadcrumb__inner" role="link" @click="mining" >{{local.mining.mining}}</span>
                                            <i class="el-icon el-breadcrumb__separator">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                                <path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path>
                                            </svg>
                                            </i>
                                        </span>
                                        <span class="el-breadcrumb__item" aria-current="page">
                                            <span class="el-breadcrumb__inner" role="link">{{local.mining.subscribe}}</span>
                                            <i class="el-icon el-breadcrumb__separator">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                                <path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path>
                                            </svg>
                                            </i>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 产品信息卡片 -->
                                <div class="el-card is-always-shadow w-full mt-10">
                                    <div class="el-card__body">
                                        <div class="p-12">
                                        <!-- 产品基本信息 -->
                                        <div class="flex items-center">
                                            <img class="w-60 h-60 ml-10" src="../assets/DEMO_files/47dc2c9f62dbbd2ad064b2af61b8f8a0.png" :alt="userProducts.productNo">
                                            <div class="ml-20">
                                            <div class="text-18">{{ userProducts.productNo }}</div>
                                            <div class="text-14">
                                                <span class="pr-10 text-16">{{ userProducts.itemName }}</span>
                                                <span class="bg-up rounded-8 px-10 text-white">{{local.mining.expected_profit}}:{{ userProducts.expectedNissan }}%</span>
                                            </div>
                                            </div>
                                        </div>

                                        <!-- 申购表单 -->
                                        <div class="box-shadow rounded-16 p-18 text-16 mt-20">
                                            <!-- 矿机租金 -->
                                            <div class="flex items-center justify-between">
                                            <div>{{local.mining.machine_rent}}</div>
                                            <div>{{ userProducts.miningMachineRental }}</div>
                                            </div>
                                            <div class="el-divider el-divider--horizontal mt-12" role="separator" style="--el-border-style: solid;"></div>
                                            
                                            <!-- 挖矿期限 -->
                                            <div class="flex items-center justify-between mt-12">
                                            <div>{{local.mining.mining_time}}</div>
                                            <div>{{ userProducts.miningPeriod }}{{ local.loan.day }}</div>
                                            </div>
                                            <div class="el-divider el-divider--horizontal mt-12" role="separator" style="--el-border-style: solid;"></div>
                                            
                                            <!-- 最大申购 -->
                                            <div class="flex items-center justify-between mt-12">
                                            <div>{{local.mining.max_subscribe}}</div>
                                            <div>{{ userProducts.maximumApplication }}</div>
                                            </div>
                                            <div class="el-divider el-divider--horizontal my-10" role="separator" style="--el-border-style: solid;"></div>
                                            
                                            <!-- 输入框 -->
                                            <div class="el-input text-16 mt-12 w-full">
                                            <div class="el-input__wrapper" tabindex="-1" style="width: 100%;">
                                                <input 
                                                v-model="quantity"
                                                class="el-input__inner" 
                                                style="width: 100%;"
                                                type="number" 
                                                autocomplete="off" 
                                                tabindex="0" 
                                                :placeholder="local.mining.input_lock_num"
                                                id="el-id-568-68"
                                                >
                                            </div>
                                            </div>
                                            
                                            <div class="el-divider el-divider--horizontal my-20" role="separator" style="--el-border-style: solid;"></div>
                                            
                                            <!-- 申购按钮 -->
                                            <button 
                                            aria-disabled="false" 
                                            type="button" 
                                            class="el-button rounded-4 h-40 text-14 w-full text-white" 
                                            block=""
                                            style="
                                                --el-button-bg-color: #85BD00;
                                                --el-button-text-color: var(--el-color-black);
                                                --el-button-border-color: #85BD00;
                                                --el-button-hover-bg-color: rgb(170, 209, 77);
                                                --el-button-hover-text-color: var(--el-color-black);
                                                --el-button-hover-border-color: rgb(170, 209, 77);
                                                --el-button-active-bg-color: rgb(110, 155, 4);
                                                --el-button-active-border-color: rgb(110, 155, 4);
                                            "
                                            @click="handleApplySubmit"
                                            >
                                            <span class="">{{local.mining.subscribe}}</span>
                                            </button>

                                            <!-- 产品介绍 -->
                                            <div class="mt-20" v-if="selectedProducts.productIntroduction !=null">{{local.mining.product_desc}}</div>
                                            <div v-if="selectedProducts.productIntroduction !=null">
                                            {{selectedProducts.productIntroduction}}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showMyProducts" class="max-w-[1240px] mx-auto py-20 w-full flex flex-col">
                                <!-- 面包屑导航 -->
                                <div class="el-card is-hover-shadow w-full">
                                    <div class="el-card__body">
                                        <div class="el-breadcrumb" aria-label="面包屑" role="navigation">
                                        <span class="el-breadcrumb__item cursor-pointer" @click="goBack">
                                            <span class="el-breadcrumb__inner" role="link" @click="mining" >{{local.mining.mining}}</span>
                                            <i class="el-icon el-breadcrumb__separator">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                                <path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path>
                                            </svg>
                                            </i>
                                        </span>
                                        <span class="el-breadcrumb__item" aria-current="page">
                                            <span class="el-breadcrumb__inner" role="link">{{local.mining.my_subscribe}}</span>
                                            <i class="el-icon el-breadcrumb__separator">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                                <path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path>
                                            </svg>
                                            </i>
                                        </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- 申购列表表格 -->
                                <div class="el-card is-hover-shadow w-full mt-20">
                                    <div class="el-card__body">
                                        <div class="pro-table">
                                        <el-table
                                            :data="purchaseList"
                                            style="width: 100%"
                                            class="el-table--fit el-table--enable-row-hover el-table--enable-row-transition el-table el-table--layout-fixed w-full is-scrolling-none"
                                        >
                                            <el-table-column
                                            prop="name"
                                            :label="local.mining.name"
                                            width="117"
                                            class-name="el-table_3_column_17"
                                            >
                                            <template #default="scope">
                                                <div class="cell">{{ scope.row.productNo }}</div>
                                            </template>
                                            </el-table-column>
                                            
                                            <el-table-column
                                            prop="currency"
                                            :label="local.mining.coin_type"
                                            width="115"
                                            class-name="el-table_3_column_18"
                                            >
                                            <template #default="scope">
                                                <div class="cell">{{ scope.row.itemName }}</div>
                                            </template>
                                            </el-table-column>
                                            
                                            <el-table-column
                                            prop="quantity"
                                            :label="local.mining.subscribe_num"
                                            width="115"
                                            class-name="el-table_3_column_19"
                                            >
                                            <template #default="scope">
                                                <div class="cell">{{ scope.row.quantity }}</div>
                                            </template>
                                            </el-table-column>
                                            
                                            <el-table-column
                                            prop="dailyYield"
                                            :label="local.mining.expected_profit"
                                            width="115"
                                            class-name="el-table_3_column_20"
                                            >
                                            <template #default="scope">
                                                <div class="cell">{{ scope.row.expectedNissan }}</div>
                                            </template>
                                            </el-table-column>
                                            
                                            <el-table-column
                                            prop="totalRevenue"
                                            :label="local.mining.sum_profit"
                                            width="115"
                                            class-name="el-table_3_column_21"
                                            >
                                            <template #default="scope">
                                                <div class="cell">{{ scope.row.expectedTotalRevenue }}</div>
                                            </template>
                                            </el-table-column>
                                            
                                            <el-table-column
                                            prop="status"
                                            :label="local.public.status"
                                            width="115"
                                            class-name="el-table_3_column_22"
                                            >
                                            <template #default="scope">
                                                <div class="cell"><span>{{ scope.row.status }}</span></div>
                                            </template>
                                            </el-table-column>
                                            
                                            <el-table-column
                                            prop="purchaseTime"
                                            :label="local.mining.subscribe_time"
                                            width="115"
                                            class-name="el-table_3_column_23"
                                            >
                                            <template #default="scope">
                                                <div class="cell">{{ scope.row.createTime }}</div>
                                            </template>
                                            </el-table-column>
                                            
                                            <el-table-column
                                            :label="local.mining.operate"
                                            width="360"
                                            class-name="el-table_3_column_24"
                                            >
                                            <template #default="scope">
                                                <div class="cell">
                                                <div class="flex items-center">
                                                    <el-button
                                                    class="rounded-4 h-40 text-14 text-white"
                                                    style="
                                                        --el-button-bg-color: #85BD00;
                                                        --el-button-text-color: var(--el-color-black);
                                                        --el-button-border-color: #85BD00;
                                                        --el-button-hover-bg-color: rgb(170, 209, 77);
                                                        --el-button-hover-text-color: var(--el-color-black);
                                                        --el-button-hover-border-color: rgb(170, 209, 77);
                                                        --el-button-active-bg-color: rgb(110, 155, 4);
                                                        --el-button-active-border-color: rgb(110, 155, 4);
                                                    "
                                                    @click="viewProfitList(scope.row)"
                                                    >
                                                    {{local.mining.watch_profit_list}}
                                                    </el-button>
                                                    <el-button
                                                    class="rounded-4 h-40 text-14 text-white ml-10"
                                                    style="
                                                        --el-button-bg-color: #85BD00;
                                                        --el-button-text-color: var(--el-color-black);
                                                        --el-button-border-color: #85BD00;
                                                        --el-button-hover-bg-color: rgb(170, 209, 77);
                                                        --el-button-hover-text-color: var(--el-color-black);
                                                        --el-button-hover-border-color: rgb(170, 209, 77);
                                                        --el-button-active-bg-color: rgb(110, 155, 4);
                                                        --el-button-active-border-color: rgb(110, 155, 4);
                                                    "
                                                    @click="handleEarlyRedemption(scope.row)"
                                                    >
                                                    {{local.mining.redemption}}
                                                    </el-button>
                                                </div>
                                                </div>
                                            </template>
                                            </el-table-column>
                                        </el-table>

                                        <!-- 分页 -->
                                        <div class="flex justify-center mt-20">
                                            <el-pagination
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :current-page="pagination.currentPage"
                                            :page-sizes="[10, 20, 30, 50]"
                                            :page-size="pagination.pageSize"
                                            layout="prev, pager, next"
                                            :total="pagination.total"
                                            class="el-pagination is-background"
                                            >
                                            </el-pagination>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- 信用借款div -->
            <div v-if="active == 17">
                <div class="el-overlay" style="z-index: 1019;">
                    <div role="dialog" aria-modal="true" aria-labelledby="el-id-4264-6"
                        aria-describedby="el-id-4264-7" class="el-overlay-dialog">
                        <div class="el-dialog login-dialog rounded-10 box-shadow" tabindex="-1"
                            style="width: 900px;margin-top: 10vh;">
                            <header class="el-dialog__header">
                                <div class="text-center text-main-gray text-xs">{{ local.func.loan }}</div>
                                <button aria-label="關閉此對話框" class="el-dialog__headerbtn closedialog"
                                    @click="closeLoanDialog" type="button"><i
                                        class="el-icon el-dialog__close"><svg xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1024 1024">
                                            <path fill="currentColor"
                                                d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z">
                                            </path>
                                        </svg></i></button>
                            </header>
                            <div id="el-id-4264-7" class="el-dialog__body">
                                <div class="loan-submit">
                                    <div class="flex items-center justify-between px-20 -mt-20 mb-10">
                                        <div >
                                            <span v-if="goBakBtnShow" @click="goBakBtn">
                                                <el-icon :size="30" class="cursor-pointer">
                                                    <arrow-left />
                                                </el-icon>
                                            </span>
                                        </div>
                                        <div @click="goMyLoanShow">
                                            <img v-if="goMyLoanBtnShow" id="el-id-4264-17-2" class="w-40 h-40 ml-12 cursor-pointer" src="data:image/png;base64,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" />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="verify-result m-20 p-20 flex flex-col justify-center items-center" v-if="startLoanShow">
                                            <div class="text-center text-black font-medium text-14">
                                                {{local.loan.start_loan}}
                                            </div>
                                            <button aria-disabled="false" type="button" class="el-button mx-auto bg-kline-up border-0 rounded-8 text-white mt-20">
                                            <!--v-if--><span class=""><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAxlJREFUWEfVmUGITVEYx///srC0sLCgTCiKsqCUWVCKJbGYMmUWFEVYyEyUUWQWisnClFEUpRBLykIZUSwUZYqizMJCmaWF+tz/657nzHv3vXvOu/e+y9m9977znd893z3n+77/I3oYZrYIwEYAOwFsArAWwDIAS1J38wC+A/gA4C2AGZIve1gKjJlkZquShQ8DGAKwPGYugDkAdwBMkhR80AgCNLOlAC4BGAGg3SsyfiUPNw3gYghoLqCZHUhCd9ULXxE4f+4PACdI3u3msCOgmS0GcC0JzcGyiDr4mQJwkqR2tm1kAqZwjwDsqhjOuX8CYE8WZBtgDXBdIbMAr6cntU+bt2CZaZKH/G8WAJrZ/vQqqAPOrTlC8rb70AQ0M1207wHoSqlz6JJfQ1Kn/O9FbWY6sUfrJPPWboa6sYPp7n0BoKvlXxi/Aawj+dkBKkuM9oHsdZq7Q7LRZZKnHOC3HnJr7POMkzxvZnuT4uJeQMpU7h6gmQ0CeBG7WqR9A87NMbNXALYE+NgswNPJuzcRYNyrSSvcucTReKCzswK8n9Rt+wInxJoVgdNajwX4MS04YxfPsy8KJ/+zAvxZQSlVBpwA5wVoeVvR8vtXACu7zCkLrrFELKAKzEkzu6JiMwOyVDgHGBri5yS3e1dFK2TpcC7EoYdE6WeI5MMMyCrgmodElfPuwPcwC3IHyWcedMw9l7fsA72DZ5K0cyHP0vu9DbIiOLkdFaAa7zcRgDLN2skyd87hDApQlYVKrdhGvAmZXFVVwM2RXFG03BLkDIBtkREIMZ8gOeYAVwPQaQ6p00KcF7VRjzwg5cHvSW70oUkPBZ8ieaRxUXsnUM3SpwryciiUs1OztMHpNq1tp3SYW7EeS7Yf9vWarMa9zlA3Q+se+v+TPkRegz4TLh55h0Y9sioWKapVDomZx6LkN58m1WskYJYtiUjiUH3Z1GGydiFXYU1DLt1GRYXEzKLqg7KPbooxp790C08QoBd2gR4HMNxD7nYi+k1JGqHvTBRgS+jV8G9NpYz1Hf6GmE3/hnia1JzvSGr3osYfNhpBWkYgqZ0AAAAASUVORK5CYII=" class="w-20 h-20" alt="" srcset="" /><span class="pl-10">已驗證</span></span></button>
                                        </div>
                                        <div class="px-20" v-if="loanNowShow">
                                            <form class="el-form el-form--default el-form--label-right">
                                                <div class="el-form-item asterisk-left el-form-item--label-right">
                                                <label id="el-id-689-86" for="el-id-689-90" class="el-form-item__label" style="width: 120px;">{{local.loan.amount}}</label>
                                                <div class="el-form-item__content">
                                                    <div class="el-input el-input-group el-input-group--append">
                                                    <!-- input -->
                                                    <!-- prepend slot -->
                                                    <!--v-if-->
                                                        <div class="el-input__wrapper" tabindex="-1" style="width: 100%;">
                                                            <!-- prefix slot -->
                                                            <!--v-if-->
                                                            <input v-model = "loanTermUser.amount" class="el-input__inner" type="text" autocomplete="off" tabindex="0" :placeholder="local.loan.input_amount" id="el-id-689-90" 
                                                            style="--el-input-inner-height: calc(var(--el-input-height, 32px) - 2px); -webkit-appearance: none;
                                                                background: none;border: none; box-sizing: border-box; color: var(--el-input-text-color, var(--el-text-color-regular));
                                                                flex-grow: 1; font-size: inherit; height: var(--el-input-inner-height); line-height: var(--el-input-inner-height);
                                                                outline: none; padding: 0; width: 100%;"/>
                                                            <!-- suffix slot -->
                                                            <!--v-if-->
                                                        </div>
                                                        <!-- append slot -->
                                                        <div class="el-input-group__append" @click="loanMaxAmount">
                                                            <button aria-disabled="false" type="button" class="el-button bg-kline-up border-0 rounded-8 text-white">
                                                            <!--v-if--><span class="">{{local.loan.max}}</span></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                                <div class="el-form-item asterisk-left el-form-item--label-right">
                                                <label id="el-id-689-87" for="el-id-689-91" class="el-form-item__label" style="width: 120px;">{{local.loan.loan_time}}</label>
                                                <el-select value-key="id" v-model="loanTermUser.loanTermId"
                                                    @change="loanTermChange">
                                                    <el-option v-for="item in loanTermList"
                                                        :key="item.id"
                                                        :label="item.loanTermDays + ' ' + `${local.loan.day}`"
                                                        :value="item"></el-option>
                                                </el-select>
                                                </div>
                                            </form>
                                            <div class="mt-12 bg-[#F8F8F8] dark:bg-[#313F53] rounded-8 p-20">
                                                <div class="flex items-center justify-between">
                                                    <div class="text-[#999999]"> {{local.loan.day_rate}} </div>
                                                    <div> {{loanTerm.dailyInterestRate}}% </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-6">
                                                    <div class="text-[#999999]"> {{local.loan.free_day}} </div>
                                                    <div> {{loanTerm.interestFreeDays}} </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-6">
                                                    <div class="text-[#999999]"> {{local.loan.total_profit}} </div>
                                                    <div> {{loanTermUser.totalInterest}} </div>
                                                </div>
                                            </div>
                                            <button @click="loanNow" aria-disabled="false" type="button" class="el-button border-0 bg-kline-up rounded-8 text-white h-40 my-10 w-full" block="">
                                                <!--v-if--><span class="">{{local.loan.loan_now}}</span></button>
                                        </div>
                                        <div class="px-20 pb-20" v-if="loanSgreementShow">
                                            <div id="agreement">
                                                <div>
                                                Loan Agreement(
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">&quot;测试&quot;</span>) dated 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">2025-06-22 09:42:35 UTC</span> (&quot;EffectiveDate&quot;) entered into by the following parties: 
                                                </div>
                                                <div>
                                                Borrower： 
                                                </div>
                                                <div>
                                                First name： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">测试</span>
                                                </div>
                                                <div>
                                                Last name： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">老</span>
                                                </div>
                                                <div>
                                                Address： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">USA</span>
                                                </div>
                                                <div>
                                                Phone： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">1-1231231231</span>
                                                </div>
                                                <div>
                                                Name： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">测试</span>
                                                </div>
                                                <div>
                                                Together referred to as the &quot;Parties&quot;. 
                                                </div>
                                                <div>
                                                Repayment Terms：
                                                </div>
                                                <div>
                                                Loan Amount： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">100000</span>
                                                </div>
                                                <div>
                                                Borrower agrees to repay 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">100000</span> (&quot;Loan&quot;). 
                                                </div>
                                                <div>
                                                ite 
                                                </div>
                                                <div>
                                                Interest Rate：
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">0.010000%</span>
                                                </div>
                                                <div>
                                                The agreed-upon interest rate is 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">0.010000%</span> (calculated on a daily basis).Loan Term： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">30</span> The term of this loan is 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">30</span> days.Repayment Method：The loan needs to be repaid first before cash can be withdrawn， and the money cannot be directly deducted from the account.Borrower agrees to repay Lender 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">100000</span> principal and 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">23000</span> interest upon maturity. 
                                                </div>
                                                <div>
                                                Repayment Applicability： 
                                                </div>
                                                <div>
                                                Late Payment Fee： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">0.002500%</span>
                                                </div>
                                                <div>
                                                If Borrower fails to repay on time, Borrower shall pay a late fee of 0.25% (calculated on a daily basis), which shall be considered a penalty rather than a fine. 
                                                </div>
                                                <div>
                                                Early Repayment:
                                                </div>
                                                <div>
                                                No penalty shall be imposed on Borrower for early repayment.
                                                </div>
                                                <div>
                                                Default: 
                                                </div>
                                                <div>
                                                If Borrower fails to repay on time, Borrower shall immediately pay all outstanding principal and interest without the need for notice or demand.
                                                </div>
                                                <div>
                                                Fees:
                                                </div>
                                                <div>
                                                If Borrower fails to fulfill the repayment obligation on time, Borrower agrees to bear all costs incurred by Lender in the collection process, including but not limited to attorney's fees.
                                                </div>
                                                <div>
                                                Severability:
                                                </div>
                                                <div>
                                                If any provision of this Agreement is found to be invalid or unenforceable, such provision shall be voided, but all other provisions shall remain valid and binding.
                                                </div>
                                                <div>
                                                Legal Effect:
                                                </div>
                                                <div>
                                                This Agreement is legally binding on both parties and may be signed and executed within the United States and Europe. Both parties declare that they have the authority to sign this Agreement.
                                                </div>
                                                <div>
                                                Miscellaneous:
                                                </div>
                                                <div>
                                                According to the terms of this Agreement, the company shall pay in the form of currency in the account balance. Both parties have the right to sign this Agreement. Neither party shall infringe upon the rights of third parties or violate any other agreements between the parties.
                                                </div>
                                                <div>
                                                Applicable Law:
                                                </div>
                                                <div>
                                                This Agreement shall be interpreted and enforced in accordance with the laws of the country in which the borrower is located.
                                                </div>
                                                <div>
                                                Entire Agreement:
                                                </div>
                                                <div>
                                                Both parties confirm and agree that this Agreement constitutes the entire agreement between the parties. If either party wishes to change, add, or modify any provision, it must be done in writing and signed by both parties.
                                                </div>
                                                <div>
                                                Both parties agree to the above terms and conditions and sign as follows:
                                                </div>
                                                <div>
                                                Name： 
                                                <span style="color: rgb(133, 189, 0); text-decoration: underline;">测试</span>
                                                </div>
                                                <div>
                                                Borrower 
                                                </div>
                                                <div>
                                                Borrower Signature: 
                                                <span>______</span>
                                                </div>
                                                <div>
                                                Signature Date: 2025-06-22 09:42:35 UTC
                                                </div>
                                            </div>
                                            <button @click="goLoanSign" aria-disabled="false" type="button" class="el-button border-0 bg-kline-up rounded-8 text-white h-40 my-10 w-full">
                                                <!--v-if--><span class="">{{local.loan.sign}}</span></button>
                                        </div>
                                        
                                        <div class="loan-submit-page" v-show="loanSignShow">
                                            <div class="px-20">
                                                <div class="mb-10 font-medium">
                                                {{local.loan.please_sign}}
                                                </div>
                                                <div class="van-signature">
                                                    <div class="van-signature__content">
                                                        <canvas ref="loanCanvas" width="100%" height="600" style="border: 1px solid #000; background: white;"
                                                            @mousedown="startDrawing"
                                                            @mousemove="draw"
                                                            @mouseup="endDrawing"
                                                            @mouseleave="endDrawing"
                                                            @touchstart="startDrawing"
                                                            @touchmove="draw"
                                                            @touchend="endDrawing"
                                                            >
                                                        </canvas>
                                                        <!-- <img v-if="signatureImage" :src="signatureImage" alt="签名预览" class="preview"> -->
                                                    </div>
                                                    <div class="van-signature__footer">
                                                        <button @click="clearCanvas" type="button" class="el-button el-button--primary is-round bg-kline-up flex-1 border-0 h-36 bg-kline-up">
                                                            <div class="van-button__content">
                                                                <!---->
                                                                <span class="van-button__text">{{local.loan.resign}}</span>
                                                                <!---->
                                                            </div>
                                                        </button>
                                                        <button @click="loanOrderSave" aria-disabled="false" type="button" class="el-button el-button--primary is-round bg-kline-up flex-1 border-0 h-36 bg-kline-up">
                                                            <span class="">{{local.loan.sign}}</span>
                                                        </button>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                        <div v-if="myLoanShow" class="max-h-450 overflow-auto text-main-black dark:text-white" 
                                            v-infinite-scroll="loadMore" 
                                            infinite-scroll-distance="50" 
                                            infinite-scroll-immediate="true" 
                                            :infinite-scroll-disabled="loadingLoan || noMore"
                                            :infinite-scroll-delay="200">
                                            <div class="el-empty"  v-if="myLoanList.length === 0 && !loadingLoan">
                                                <div class="el-empty__image" style="width: 200px;">
                                                <svg viewbox="0 0 79 86" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <defs>
                                                <lineargradient id="linearGradient-1-el-id-9162-90" x1="38.8503086%" y1="0%" x2="61.1496914%" y2="100%">
                                                    <stop stop-color="var(--el-empty-fill-color-1)" offset="0%"></stop>
                                                    <stop stop-color="var(--el-empty-fill-color-4)" offset="100%"></stop>
                                                </lineargradient>
                                                <lineargradient id="linearGradient-2-el-id-9162-90" x1="0%" y1="9.5%" x2="100%" y2="90.5%">
                                                    <stop stop-color="var(--el-empty-fill-color-1)" offset="0%"></stop>
                                                    <stop stop-color="var(--el-empty-fill-color-6)" offset="100%"></stop>
                                                </lineargradient>
                                                <rect id="path-3-el-id-9162-90" x="0" y="0" width="17" height="36"></rect>
                                                </defs>
                                                <g id="Illustrations" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="B-type" transform="translate(-1268.000000, -535.000000)">
                                                    <g id="Group-2" transform="translate(1268.000000, 535.000000)">
                                                    <path id="Oval-Copy-2" d="M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z" fill="var(--el-empty-fill-color-3)"></path>
                                                    <polygon id="Rectangle-Copy-14" fill="var(--el-empty-fill-color-7)" transform="translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) " points="13 58 53 58 42 45 2 45"></polygon>
                                                    <g id="Group-Copy" transform="translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)">
                                                    <polygon id="Rectangle-Copy-10" fill="var(--el-empty-fill-color-7)" transform="translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) " points="2.84078316e-14 3 18 3 23 7 5 7"></polygon>
                                                    <polygon id="Rectangle-Copy-11" fill="var(--el-empty-fill-color-5)" points="-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43"></polygon>
                                                    <rect id="Rectangle-Copy-12" fill="url(#linearGradient-1-el-id-9162-90)" transform="translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) " x="38" y="7" width="17" height="36"></rect>
                                                    <polygon id="Rectangle-Copy-13" fill="var(--el-empty-fill-color-2)" transform="translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) " points="24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12"></polygon>
                                                    </g>
                                                    <rect id="Rectangle-Copy-15" fill="url(#linearGradient-2-el-id-9162-90)" x="13" y="45" width="40" height="36"></rect>
                                                    <g id="Rectangle-Copy-17" transform="translate(53.000000, 45.000000)">
                                                    <use id="Mask" fill="var(--el-empty-fill-color-8)" transform="translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) " xlink:href="#path-3-el-id-9162-90"></use>
                                                    <polygon id="Rectangle-Copy" fill="var(--el-empty-fill-color-9)" mask="url(#mask-4-el-id-9162-90)" transform="translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) " points="7 0 24 0 20 18 7 16.5"></polygon>
                                                    </g>
                                                    <polygon id="Rectangle-Copy-18" fill="var(--el-empty-fill-color-2)" transform="translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) " points="62 45 79 45 70 58 53 58"></polygon>
                                                    </g>
                                                </g>
                                                </g>
                                                </svg>
                                                </div>
                                                <div class="el-empty__description">
                                                <p>{{local.public.no_data}}</p>
                                                </div>
                                                <!--v-if-->
                                            </div>
                                            <div class="bg-[#f8f8f8] dark:bg-[#313F53] rounded-8 mt-12 p-20" v-for="item in myLoanList">
                                                <div class="flex items-center justify-between">
                                                    <div class="flex items-center">
                                                        <div class="h-14 w-[5px] rounded-4 bg-kline-up"></div>
                                                        <div class="ml-8"> # {{item.id}} </div>
                                                    </div>
                                                    <div> {{item.createTime}} </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-16">
                                                    <div class="text-[#999] dark:text-[#9DA3B7]"> {{local.loan.amount}} </div>
                                                    <div> {{item.amount}} </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-16">
                                                    <div class="text-[#999] dark:text-[#9DA3B7]"> {{local.loan.loan_time}} </div>
                                                    <div> {{item.loanTermDays}} </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-16">
                                                    <div class="text-[#999] dark:text-[#9DA3B7]"> {{local.loan.total_profit}} </div>
                                                    <div> {{item.totalInterest}} </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-16">
                                                    <div class="text-[#999] dark:text-[#9DA3B7]"> {{local.loan.day_rate}} </div>
                                                    <div> {{ item.dailyInterestRate }} </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-16">
                                                    <div class="text-[#999] dark:text-[#9DA3B7]"> {{local.loan.need_repay}} </div>
                                                    <div> {{item.remainingRepayment}} </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-16">
                                                    <div class="text-[#999] dark:text-[#9DA3B7]"> {{local.loan.penalty_amount}} </div>
                                                    <div> {{item.repaymenAmount}} </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-16">
                                                    <div class="text-[#999] dark:text-[#9DA3B7]"> {{local.loan.reviewed_at}} </div>
                                                    <div v-if="item.auditStatus==2"> {{item.auditTime}} </div>
                                                    <div v-else>  </div>
                                                </div>
                                                <div class="flex items-center justify-between mt-16">
                                                    <div class="text-[#999] dark:text-[#9DA3B7]"> {{local.loan.repayment_time}} </div>
                                                    <div> {{item.repaymentTime}} </div>
                                                </div>
                                                <div class="flex items-center justify-end mt-16">
                                                <button type="button" class="van-button van-button--default van-button--normal border-0 bg-kline-up rounded-8 text-white h-40 my-10">
                                                <div class="van-button__content">
                                                <!---->
                                                <span class="van-button__text">{{local.loan.agreement}}</span>
                                                <!---->
                                                </div></button>
                                                    <button v-if="item.auditStatus!=2" type="button" class="van-button van-button--default van-button--normal van-button--disabled border-0 bg-kline-up rounded-8 text-white ml-10" disabled="">
                                                        <div class="van-button__content">
                                                            <span class="van-button__text" >
                                                                {{ getStatusText(item.auditStatus) }}
                                                            </span>
                                                        </div>
                                                    </button>
                                                    <button v-if="item.auditStatus==2" type="button" class="van-button van-button--default van-button--normal border-0 bg-kline-up rounded-8 text-white ml-10" @click="toRepayment(item)">
                                                        <div class="van-button__content">
                                                            <span class="van-button__text" >
                                                                {{local.loan.to_repayment}}
                                                            </span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <div v-if="loadingLoan" class="text-center py-20">
                                                <i class="el-icon-loading"></i>
                                                加载中...
                                            </div>
                                            
                                            <div v-if="noMore" class="text-center py-20 text-[#999]">
                                                没有更多数据了
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="active == 16">
                <div class="el-overlay" style="z-index: 1041;">
                    <div role="dialog" aria-modal="true" aria-label="TP/SL" aria-describedby="el-id-4579-77"
                        class="el-overlay-dialog" style="display: flex;">
                        <div class="el-dialog is-align-center login-dialog rounded-10 box-shadow" tabindex="-1"
                            style="margin-top: 30vh; width:480px">
                            <header class="el-dialog__header"><span role="heading"
                                    class="el-dialog__title">TP/SL</span><button aria-label="關閉此對話框"
                                    class="el-dialog__headerbtn" type="button"><i
                                        @click="active = -1; dialogShow = false"
                                        class="el-icon el-dialog__close"><svg xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1024 1024">
                                            <path fill="currentColor"
                                                d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z">
                                            </path>
                                        </svg></i></button></header>
                            <div id="el-id-4579-77" class="el-dialog__body">
                                <div class="flex flex-col items-center">
                                    <div class="flex items-center"><span class="pr-10">{{
                                        local.order.stop_profit
                                    }}</span>
                                        <el-input-number v-model="stop.target_profit_price"
                                            class="el-input-number w-[80%]"></el-input-number>
                                    </div>
                                    <div class="flex items-center mt-20"><span class="pr-10">{{
                                        local.order.stop_loss
                                    }}</span>
                                        <el-input-number v-model="stop.stop_loss_price"
                                            class="el-input-number w-[80%]"></el-input-number>
                                    </div>
                                    <el-button style="background: #409EFF !important;" @click="set_stop_price"
                                        class="el-button el-button--primary w-[50%] mt-20" type="primary">{{
                                            local.public.set
                                        }} TP/SL
                                    </el-button>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div v-if="active == 15">
                <div class="el-overlay" style="z-index: 1024;">
                    <div role="dialog" aria-modal="true" aria-labelledby="el-id-4264-10"
                        aria-describedby="el-id-4264-11" class="el-overlay-dialog">
                        <div class="el-dialog rounded-10 box-shadow" tabindex="-1"
                            style="margin-top: 10vh; width:480px">
                            <header class="el-dialog__header">
                                <div class="text-center text-main-gray text-xs">{{ local.user.forgot_password }}
                                </div>
                                <button aria-label="關閉此對話框" class="el-dialog__headerbtn closedialog"
                                    @click="active = -1; dialogShow = false" type="button"><i
                                        class="el-icon el-dialog__close"><svg xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1024 1024">
                                            <path fill="currentColor"
                                                d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z">
                                            </path>
                                        </svg></i></button>
                            </header>
                            <div id="el-id-4264-11" class="el-dialog__body">
                                <div class="px-24">
                                    <div class="flex items-end">
                                        <div class="mr-30 text-16 text-primary font-bold">{{
                                            local.user.login_email
                                        }}</div>
                                    </div>
                                    <div class="base-input w-full mt-14">
                                        <input :placeholder="local.user.input_email" class="pr-20 pl-20"
                                            v-model="forgot.userName">
                                    </div>
                                    <div class="text-black text-12 mt-20">{{ local.user.password }}</div>
                                    <div class="base-input w-full mt-16">
                                        <input :placeholder="local.user.input_password" type="password"
                                            class="pr-20 pl-20" v-model="forgot.password">
                                    </div>
                                    <div class="text-black text-12 mt-20">{{ local.user.re_input_pass }}</div>
                                    <div class="base-input w-full mt-16">
                                        <input :placeholder="local.user.input_password" type="password"
                                            class="pr-20 pl-20" v-model="forgot.confirmPassword">
                                    </div>
                                    <div class="text-black text-12 mt-20">{{ local.forgot.sms_code }}</div>
                                    <div class="base-input w-full mt-16 pr-0">
                                        <input :placeholder="local.forgot.validCode" class="pl-20"
                                            v-model="forgot.validCode">
                                        <el-button class="sms_code_btn" v-if="!flag" type="primary"
                                            @click="send(forgot.userName)">{{
                                                local.forgot.send
                                            }}{{
local.forgot.sms_code
}}</el-button>
                                        <el-button class="sms_code_btn" v-else type="primary" disabled>{{
                                            time
                                        }}</el-button>
                                    </div>
                                    <button aria-disabled="false" type="button" @click="forgetPassWord"
                                        class="el-button w-full mt-40 bg-primary border-0 text-white h-40 rounded-xl">
                                        <span class="">{{ local.forgot.reset }}</span>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div v-if="active == 13">
                <div class="el-overlay" style="z-index: 1020;">
                    <div role="dialog" aria-modal="true" aria-labelledby="el-id-4264-8"
                        aria-describedby="el-id-4264-9" class="el-overlay-dialog">
                        <div class="el-dialog login-dialog rounded-10 box-shadow" tabindex="-1"
                            style="margin-top: 10vh; width:480px">
                            <header class="el-dialog__header">
                                <div class="text-center text-main-gray text-xs">
                                    {{ local.user.welcome_register }}</div><button aria-label="關閉此對話框"
                                    class="el-dialog__headerbtn closedialog"
                                    @click="active = -1; dialogShow = false" type="button"><i
                                        class="el-icon el-dialog__close"><svg xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1024 1024">
                                            <path fill="currentColor"
                                                d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z">
                                            </path>
                                        </svg></i></button>
                            </header>
                            <div id="el-id-4264-9" class="el-dialog__body">
                                <div>
                                    <div class="flex items-end">
                                        <div class="mr-30 text-16 text-primary font-bold">
                                            {{ local.user.register_email }}
                                        </div>
                                    </div>
                                    <div class="base-input w-full mt-14"><input v-model="user.input_email"
                                            :placeholder="local.user.input_email" class="pr-20 pl-20"></div>
                                    <!---->
                                    <!---->
                                    <div class="text-second-black text-18 pl-10 mt-28">
                                        {{ local.user.password }} </div>
                                    <div class="base-input w-full mt-14"><input v-model="user.input_password"
                                            :placeholder="local.user.input_password" type="password"
                                            class="pr-20 pl-20"></div>
                                    <div class="text-second-black text-18 pl-10 mt-28">
                                        {{ local.user.re_input_pass }}</div>
                                    <div class="base-input w-full mt-14"><input v-model="user.re_input_pass"
                                            :placeholder="local.user.input_password" type="password"
                                            class="pr-20 pl-20"></div>
                                    <!-- <div class="text-second-black text-18 pl-10 mt-28">
                                        {{ local.user.invite_code }}</div>
                                    <div class="base-input w-full mt-14"><input v-model="user.invite_code"
                                            :placeholder="local.user.input_invite_code" class="pr-20 pl-20"></div> -->
                                    <!-- <div class="text-second-black text-18 pl-10 mt-28">
                                        {{ local.forgot.sms_code }}</div>
                                    <div class="base-input w-full mt-14 sms_code"><input v-model="user.validCode"
                                            :placeholder="local.forgot.input_sms_code" class="pl-20 sms_code_input">
                                        <div class="el-image h-30">
                                            <el-button class="sms_code_btn" v-if="!flag" type="primary"
                                                @click="send(user.input_email)">{{ local.forgot.send }}{{
                                                    local.forgot.sms_code
                                                }}</el-button>
                                            <el-button class="sms_code_btn" v-else type="primary" disabled>{{
                                                time
                                            }}</el-button>
                                        </div>
                                    </div> -->
                                    <button @click="register" aria-disabled="false" type="button"
                                        class="el-button el-button--primary is-round bg-primary w-full border-0 mt-20 py-20">
                                        <span class="">{{ local.user.register }} </span></button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div v-if="active == 12">
                <div class="el-overlay" style="z-index: 1019;">
                    <div role="dialog" aria-modal="true" aria-labelledby="el-id-4264-6"
                        aria-describedby="el-id-4264-7" class="el-overlay-dialog">
                        <div class="el-dialog login-dialog rounded-10 box-shadow" tabindex="-1"
                            style="width: 480px;margin-top: 10vh;">
                            <header class="el-dialog__header">
                                <div class="text-center text-main-gray text-xs">{{ local.user.welcome_login }}</div>
                                <button aria-label="關閉此對話框" class="el-dialog__headerbtn closedialog"
                                    @click="active = -1; dialogShow = false" type="button"><i
                                        class="el-icon el-dialog__close"><svg xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1024 1024">
                                            <path fill="currentColor"
                                                d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z">
                                            </path>
                                        </svg></i></button>
                            </header>
                            <div id="el-id-4264-7" class="el-dialog__body">
                                <div>
                                    <div class="flex items-end">
                                        <div class="mr-30 text-16 text-primary font-bold">{{
                                            local.user.login_email
                                        }}
                                        </div>
                                    </div>
                                    <div class="base-input w-full mt-14"><input v-model="user.input_email"
                                            :placeholder="local.user.input_email" class="pr-20 pl-20">
                                    </div>
                                    <div class="text-second-black text-18 pl-10 mt-28">{{ local.user.password }}
                                    </div>
                                    <div class="base-input w-full mt-14"><input v-model="user.input_password"
                                            :placeholder="local.user.input_password" type="password"
                                            class="pr-20 pl-20">
                                    </div>
                                    <div class="flex justify-between text-12 text-[#cbcbcb] mt-22">
                                        <div><span>{{ local.user.new_user }} </span><span
                                                class="text-primary cursor-pointer" @click="active = 13">{{
                                                    local.user.join_us
                                                }}</span></div>
                                        <div class="cursor-pointer" @click="active = 15">
                                            {{ local.user.forgot_password }}</div>
                                    </div>
                                    <div><button aria-disabled="false" @click="login" type="button"
                                            class="el-button el-button--primary is-round bg-primary w-full border-0 mt-20 py-20 whitespace-break-spaces">
                                            <span class="">{{ local.user.login }} </span></button>
                                    </div>
                                    <div><button aria-disabled="false" type="button" @click="mockLogin"
                                            class="el-button el-button--primary is-round bg-primary w-full border-0 mt-20 py-20 whitespace-break-spaces">
                                            <span class="">{{ local.user.mock_login }}</span></button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="el-overlay" v-if="dialogShow" style="z-index: 1012;">
                    <div role="dialog" aria-modal="true" aria-label="個人中心" aria-describedby="el-id-1087-10"
                        class="el-overlay-dialog" style="display: flex;">
                        <div class="el-dialog is-align-center rounded-10 box-shadow" tabindex="-1"
                            style="width: 749px;">
                            <header class="el-dialog__header"><span role="heading" class="el-dialog__title">{{
                                local.user.user_center
                            }}</span><button aria-label="關閉此對話框" class="el-dialog__headerbtn closedialog"
                                    @click="; dialogShow = false" type="button"><i
                                        class="el-icon el-dialog__close"><svg xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1024 1024">
                                            <path fill="currentColor"
                                                d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z">
                                            </path>
                                        </svg></i></button></header>
                            <div id="el-id-1087-10" class="el-dialog__body">
                                <div class="flex items-start justify-between">
                                    <div>
                                        <div class="func-option" :class="active == 1 ? 'bg-primary text-white' : ''"
                                            @click="active = 1">{{ local.func.billing_detail }}</div>
                                        <div class="func-option" @click="operateClick(2)"
                                            :class="active == 2 || active == 3 ? 'bg-primary text-white' : ''">
                                            {{ local.func.charge_coin }}</div>
                                        <div @click="operateClick(4)"
                                            :class="active == 4 || active == 5 ? 'bg-primary text-white' : ''"
                                            class="func-option">{{ local.func.withdraw_coin }}</div>
                                        <div @click="operateClick(6)"
                                            :class="active == 6 || active == 21 || active == 22 ? 'bg-primary text-white' : ''"
                                            class="func-option">{{ local.func.wallet }}</div>
                                        <div @click="operateClick(7)"
                                            :class="active == 7 ? 'bg-primary text-white' : ''" class="func-option">
                                            {{ local.func.real_auth }}</div>
                                        <div @click="operateClick(8)"
                                            :class="active == 8 ? 'bg-primary text-white' : ''" class="func-option">
                                            {{ local.func.invite_friend }}</div>
                                        <div @click="operateClick(9)"
                                            :class="active == 9 ? 'bg-primary text-white' : ''" class="func-option">
                                            {{ local.func.reset_password }}</div>
                                        <!-- <div @click="operateClick(10)"
                                            :class="active == 10 ? 'bg-primary text-white' : ''"
                                            class="func-option">{{ local.user.com_email }}</div> -->
                                        <div @click="operateClick(11)"
                                            :class="active == 11 ? 'bg-primary text-white' : ''"
                                            class="func-option">{{ local.user.announ }}</div>
                                        <div @click="operateClick(100)"
                                            :class="active == 100 ? 'bg-primary text-white' : ''"
                                            class="func-option">{{ local.public.chat }}</div>
                                        <div v-if="is_mock" @click="resetMock" class="func-option">{{
                                            local.user.reset_mock_account
                                        }}</div>
                                        <div @click="loginOut" class="func-option">{{ local.user.logout }}</div>
                                    </div>
                                    <div v-if="active == 1" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <div class="rounded-10 p-10"
                                                style="box-shadow: rgba(161, 161, 161, 0.09) 0px 0px 24px 0px;">
                                                <div class="font-bold text-[20px] mb-10">USD</div>
                                                <div class="flex items-center">
                                                    <div class="flex-1">

                                                        <div class="text-main-gray text-12">{{ local.public.use }}
                                                        </div>
                                                        <div class="text-kline-up text-16">{{ user_balance }}</div>
                                                    </div>
                                                    <div class="flex-1">
                                                        <div class="text-main-gray text-12">{{
                                                            local.public.freeze
                                                        }}
                                                        </div>
                                                        <div class="text-main-black text-16">
                                                            {{ userInfo.asset.lockBalance }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="my-20 text-main-black text-18 pl-10">
                                                {{ local.financial.financial_records }}</div>
                                            <div class="">
                                                <div class="h-400 overflow-auto" infinite-scroll-distance="50"
                                                    infinite-scroll-immediate="false"
                                                    infinite-scroll-disabled="false">
                                                    <div v-if="billList.length > 0"
                                                        class="text-main-gray text-12 m-8">
                                                        <div v-for="item in billList"
                                                            class="p-10 mb-8 bg-white rounded-8">
                                                            <div class="flex items-center justify-between">
                                                                <div><span class="pr-10">{{
                                                                    local.order.balance
                                                                }}</span><span class="text-main-black">{{
item.amountBefore
}}</span>
                                                                </div>

                                                            </div>
                                                            <div class="mt-8"><span class="pr-10">{{
                                                                local.public.history
                                                            }}</span><span class="text-main-black">{{
item.log
}}</span>
                                                            </div>
                                                            <div class="mt-8"><span class="pr-10">{{
                                                                local.trade.time
                                                            }}</span><span class="text-main-black">{{
item.createTime
}}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="el-empty" v-else>
                                                        <div class="el-empty__image" style="width: 200px;"><svg
                                                                viewBox="0 0 79 86" version="1.1"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                                <defs>
                                                                    <linearGradient
                                                                        id="linearGradient-1-el-id-1087-76"
                                                                        x1="38.8503086%" y1="0%" x2="61.1496914%"
                                                                        y2="100%">
                                                                        <stop
                                                                            stop-color="var(--el-empty-fill-color-1)"
                                                                            offset="0%"></stop>
                                                                        <stop
                                                                            stop-color="var(--el-empty-fill-color-4)"
                                                                            offset="100%"></stop>
                                                                    </linearGradient>
                                                                    <linearGradient
                                                                        id="linearGradient-2-el-id-1087-76" x1="0%"
                                                                        y1="9.5%" x2="100%" y2="90.5%">
                                                                        <stop
                                                                            stop-color="var(--el-empty-fill-color-1)"
                                                                            offset="0%"></stop>
                                                                        <stop
                                                                            stop-color="var(--el-empty-fill-color-6)"
                                                                            offset="100%"></stop>
                                                                    </linearGradient>
                                                                    <rect id="path-3-el-id-1087-76" x="0" y="0"
                                                                        width="17" height="36"></rect>
                                                                </defs>
                                                                <g id="Illustrations" stroke="none" stroke-width="1"
                                                                    fill="none" fill-rule="evenodd">
                                                                    <g id="B-type"
                                                                        transform="translate(-1268.000000, -535.000000)">
                                                                        <g id="Group-2"
                                                                            transform="translate(1268.000000, 535.000000)">
                                                                            <path id="Oval-Copy-2"
                                                                                d="M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z"
                                                                                fill="var(--el-empty-fill-color-3)">
                                                                            </path>
                                                                            <polygon id="Rectangle-Copy-14"
                                                                                fill="var(--el-empty-fill-color-7)"
                                                                                transform="translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) "
                                                                                points="13 58 53 58 42 45 2 45">
                                                                            </polygon>
                                                                            <g id="Group-Copy"
                                                                                transform="translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)">
                                                                                <polygon id="Rectangle-Copy-10"
                                                                                    fill="var(--el-empty-fill-color-7)"
                                                                                    transform="translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) "
                                                                                    points="2.84078316e-14 3 18 3 23 7 5 7">
                                                                                </polygon>
                                                                                <polygon id="Rectangle-Copy-11"
                                                                                    fill="var(--el-empty-fill-color-5)"
                                                                                    points="-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43">
                                                                                </polygon>
                                                                                <rect id="Rectangle-Copy-12"
                                                                                    fill="url(#linearGradient-1-el-id-1087-76)"
                                                                                    transform="translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) "
                                                                                    x="38" y="7" width="17"
                                                                                    height="36">
                                                                                </rect>
                                                                                <polygon id="Rectangle-Copy-13"
                                                                                    fill="var(--el-empty-fill-color-2)"
                                                                                    transform="translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) "
                                                                                    points="24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12">
                                                                                </polygon>
                                                                            </g>
                                                                            <rect id="Rectangle-Copy-15"
                                                                                fill="url(#linearGradient-2-el-id-1087-76)"
                                                                                x="13" y="45" width="40"
                                                                                height="36"></rect>
                                                                            <g id="Rectangle-Copy-17"
                                                                                transform="translate(53.000000, 45.000000)">
                                                                                <use id="Mask"
                                                                                    fill="var(--el-empty-fill-color-8)"
                                                                                    transform="translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) "
                                                                                    xlink:href="#path-3-el-id-1087-76">
                                                                                </use>
                                                                                <polygon id="Rectangle-Copy"
                                                                                    fill="var(--el-empty-fill-color-9)"
                                                                                    mask="url(#mask-4-el-id-1087-76)"
                                                                                    transform="translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) "
                                                                                    points="7 0 24 0 20 18 7 16.5">
                                                                                </polygon>
                                                                            </g>
                                                                            <polygon id="Rectangle-Copy-18"
                                                                                fill="var(--el-empty-fill-color-2)"
                                                                                transform="translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) "
                                                                                points="62 45 79 45 70 58 53 58">
                                                                            </polygon>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg></div>
                                                        <div class="el-empty__description">
                                                            <p>{{ local.public.no_data }}</p>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 2" class="box-shadow w-500 rounded-10 p-10">
                                        <div data-v-28012f00="" class="charge_age">
                                            <div data-v-28012f00="" class="flex text-center text-white p-6 mb-10">
                                                <div class="flex-1 rounded-xl py-10 mr-1 bg-kline-up"
                                                    @click="active = 2">
                                                    {{ local.financial.coin }}
                                                </div>
                                                <div class="flex-1 rounded-xl py-10 ml-1 bg-main-gray"
                                                    @click="active = 3">
                                                    {{ local.financial.bank }}
                                                </div>
                                            </div>
                                            <div data-v-28012f00="" modelvalue="[object Object]">
                                                <form class="el-form el-form--default el-form--label-left">
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-1087-77" for="el-id-1087-83"
                                                            class="el-form-item__label" style="width: 30%;">{{
                                                                local.financial.select_network
                                                            }}</label>
                                                        <div class="el-form-item__content">
                                                            {{ financial.select_network }}
                                                            <el-select value-key="id" v-model="financial"
                                                                @change="netWorkChange">
                                                                <el-option v-for="item in NetworkList"
                                                                    :key="item.id"
                                                                    :label="item.currencyType + '-' + item.protocol"
                                                                    :value="item"></el-option>
                                                            </el-select>

                                                        </div>
                                                    </div>
                                                    <div class="el-form-item asterisk-left" role="group"
                                                        aria-labelledby="el-id-1087-86"
                                                        v-if="financial.num && financial.address">
                                                        <div id="el-id-1087-86" class="el-form-item__label"
                                                            style="width: 30%;">{{ local.financial.wallet_address }}
                                                        </div>
                                                        <div class="el-form-item__content">
                                                            <div class="flex flex-col">
                                                                <img id="qrcode" :src="ewmImg"
                                                                    style="width:100px; height:100px; margin-top:15px;" />
                                                                <div class="flex items-center"><span
                                                                        class="w-full break-words">{{
                                                                            financial.address
                                                                        }}</span><svg class="svg-icon w-18 h-18 p-8"
                                                                        aria-hidden="true">
                                                                        <use xlink:href="#icon-copy" fill="#333">
                                                                        </use>
                                                                    </svg></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div data-v-110a66b8="" data-v-28012f00="" class="bank_charge"
                                                style="display: none;">
                                                <form data-v-110a66b8=""
                                                    class="el-form el-form--default el-form--label-left">
                                                    <div data-v-110a66b8="" class="el-form-item asterisk-left">
                                                        <label id="el-id-1087-79" for="el-id-1087-84"
                                                            class="el-form-item__label" style="width: 30%;">{{
                                                                local.financial.collect_coin_type
                                                            }}:</label>
                                                        <div class="el-form-item__content">
                                                            <div data-v-110a66b8="" class="el-select">
                                                                <div
                                                                    class="select-trigger el-tooltip__trigger el-tooltip__trigger">

                                                                    <!-- fix: https://github.com/element-plus/element-plus/issues/11415 -->

                                                                    <div class="el-input el-input--suffix">
                                                                        <!-- input -->
                                                                        <!-- prepend slot -->

                                                                        <div class="el-input__wrapper" role="button"
                                                                            tabindex="-1">
                                                                            <!-- prefix slot -->
                                                                            <input class="el-input__inner"
                                                                                type="text" readonly=""
                                                                                autocomplete="off" tabindex="0"
                                                                                placeholder="請選擇"
                                                                                id="el-id-1087-84"><!-- suffix slot --><span
                                                                                class="el-input__suffix"><span
                                                                                    class="el-input__suffix-inner"><i
                                                                                        class="el-icon el-select__caret el-select__icon"><svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            viewBox="0 0 1024 1024">
                                                                                            <path
                                                                                                fill="currentColor"
                                                                                                d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
                                                                                            </path>
                                                                                        </svg></i>





                                                                                </span></span>
                                                                        </div>
                                                                        <!-- append slot -->

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                                <div data-v-110a66b8=""
                                                    class="flex flex-nowrap overflow-auto mb-10">
                                                    <div data-v-110a66b8=""
                                                        class="w-full min-w-200 border-0 border-solid border-gray-100 border-r-[1px]">
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="">{{
                                                                local.bank.name
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">Swissquote Bank
                                                                Ltd</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.address
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">Chemin de la
                                                                Cretaux
                                                                33, 1196 GLAND, SWITZERLAND</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.SWIFT
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">SWQBCHZZXXX</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.username
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">Maimaitijiang
                                                                KERANMU</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.account
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">CH1208781000236881000</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.remark
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item"></span>
                                                        </div>
                                                        <div data-v-110a66b8="" class="flex justify-end"><label
                                                                data-v-110a66b8=""
                                                                class="el-checkbox is-checked"><span
                                                                    class="el-checkbox__input is-checked"><input
                                                                        class="el-checkbox__original"
                                                                        type="checkbox" aria-hidden="false"
                                                                        true-value="25" id="el-id-1087-87"><span
                                                                        class="el-checkbox__inner"></span></span>
                                                            </label></div>
                                                    </div>
                                                    <div data-v-110a66b8=""
                                                        class="w-full min-w-200 border-0 border-solid border-gray-100">
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="">{{
                                                                local.bank.name
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item"></span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.address
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item"></span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.SWIFT
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item"></span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.username
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item"></span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.account
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item"></span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.remark
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item"></span>
                                                        </div>
                                                        <div data-v-110a66b8="" class="flex justify-end"><label
                                                                data-v-110a66b8="" class="el-checkbox"><span
                                                                    class="el-checkbox__input"><input
                                                                        class="el-checkbox__original"
                                                                        type="checkbox" aria-hidden="false"
                                                                        true-value="27" id="el-id-1087-88"><span
                                                                        class="el-checkbox__inner"></span></span>
                                                            </label></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <form data-v-28012f00=""
                                                class="el-form el-form--default el-form--label-left">
                                                <div data-v-28012f00="" class="el-form-item asterisk-left"><label
                                                        id="el-id-1087-81" for="el-id-1087-85"
                                                        class="el-form-item__label" style="width: 30%;">{{
                                                            local.financial.charge_amount
                                                        }}</label>
                                                    <div class="el-form-item__content">
                                                        <div data-v-28012f00="" class="el-input">
                                                            <div class="el-input__wrapper" role="button"
                                                                tabindex="-1"><input class="el-input__inner"
                                                                    type="text" autocomplete="off" tabindex="0"
                                                                    v-model="financial.num"
                                                                    :placeholder="local.financial.input_charge_amount"
                                                                    @input="numChange" id="el-id-1087-85">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-v-28012f00="" class="el-form-item asterisk-left"
                                                    role="group" aria-labelledby="el-id-1087-82">
                                                    <div id="el-id-1087-82" class="el-form-item__label"
                                                        style="width: 30%;">
                                                        {{ local.public.upload_pic }}</div>
                                                    <div class="el-form-item__content">
                                                        <div data-v-28012f00="" class="w-full">

                                                            <el-upload class="upload-demo"
                                                                :on-success="res => financial.proofImg = res.data.fileUrl"
                                                                drag :headers="headers" :action="upload_url">
                                                                <img v-if="financial.proofImg"
                                                                    :src="financial.proofImg" alt="">
                                                                <i v-else class="el-icon-upload"></i>
                                                            </el-upload>

                                                        </div>
                                                    </div>
                                                </div>
                                            </form><button data-v-28012f00="" @click="submitDeposit()"
                                                aria-disabled="false" type="button"
                                                class="el-button el-button--primary w-full border-0 bg-kline-up rounded-xl text-white h-40">
                                                <span class="">{{ local.public.submit }}</span></button>
                                            <div data-v-28012f00="" class="mt-10 mx-10 text-18 font-bold">
                                                {{ local.financial.charge_history }}</div>
                                            <div v-for="(item, index) in depositList" v-if="depositList.length > 0"
                                                :key="index" data-v-28012f00=""
                                                class="px-10 pt-10 max-h-150 overflow-auto"
                                                infinite-scroll-distance="50" infinite-scroll-immediate="false"
                                                infinite-scroll-disabled="false">
                                                <div>
                                                    <div class="flex justify-between">
                                                        <div class="flex-1">
                                                            <div class="text-main-gray">
                                                                {{ local.financial.charge_num }}</div>
                                                            <div>{{ item.count }}</div>
                                                        </div>
                                                        <div class="flex-1 text-center">
                                                            <div class="text-main-gray">{{ local.trade.type }}</div>
                                                            <div>{{ local.financial.coin }}</div>
                                                        </div>
                                                        <div class="flex-1 text-right">
                                                            <div class="text-main-gray">{{ local.withdraw.unit }}
                                                            </div>
                                                            <div>{{ item.unit }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="flex justify-between mt-4">
                                                        <div class="flex-1">
                                                            <div class="text-main-gray">{{ local.public.status }}
                                                            </div>
                                                            <div v-if="item.status == 3">{{
                                                                local.financial.unuseful
                                                            }}
                                                            </div>
                                                            <div v-if="item.status == 1">{{
                                                                local.financial.isfinish
                                                            }}
                                                            </div>
                                                            <div v-if="item.status == 0">{{
                                                                local.financial.uncheck
                                                            }}
                                                            </div>
                                                            <div v-if="item.status == 2">{{
                                                                local.financial.isreject
                                                            }}
                                                            </div>
                                                        </div>
                                                        <div class="flex-1 text-right">
                                                            <div class="text-main-gray">{{ local.trade.time }}</div>
                                                            <div>{{ item.createTime }}</div>
                                                        </div>
                                                    </div>
                                                    <!---->
                                                </div>

                                            </div>
                                            <div class="el-empty" v-else>
                                                <el-empty :description="local.public.no_data"></el-empty>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 3" class="box-shadow w-500 rounded-10 p-10">
                                        <div data-v-28012f00="" class="charge_age">
                                            <div data-v-28012f00="" class="flex text-center text-white p-6 mb-10">
                                                <div class="flex-1 rounded-xl py-10 mr-1 bg-main-gray"
                                                    @click="active = 2">
                                                    {{ local.financial.coin }}</div>
                                                <div class="flex-1 rounded-xl py-10 ml-1 bg-kline-up"
                                                    @click="active = 3">
                                                    {{ local.financial.bank }}
                                                </div>
                                            </div>
                                            <div data-v-28012f00="" modelvalue="[object Object]"
                                                style="display: none;">
                                                <form class="el-form el-form--default el-form--label-left">
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-1087-161" for="el-id-1087-167"
                                                            class="el-form-item__label" style="width: 30%;">{{
                                                                local.financial.select_network
                                                            }}</label>
                                                        <div class="el-form-item__content">
                                                            <div class="el-select">
                                                                <div
                                                                    class="select-trigger el-tooltip__trigger el-tooltip__trigger">

                                                                    <!-- fix: https://github.com/element-plus/element-plus/issues/11415 -->

                                                                    <div class="el-input el-input--suffix">
                                                                        <!-- input -->
                                                                        <!-- prepend slot -->

                                                                        <div class="el-input__wrapper" role="button"
                                                                            tabindex="-1">
                                                                            <!-- prefix slot -->
                                                                            <input class="el-input__inner"
                                                                                type="text" readonly=""
                                                                                autocomplete="off" tabindex="0"
                                                                                placeholder="請選擇"
                                                                                id="el-id-1087-167">
                                                                            <!-- suffix slot --><span
                                                                                class="el-input__suffix"><span
                                                                                    class="el-input__suffix-inner"><i
                                                                                        class="el-icon el-select__caret el-select__icon"><svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            viewBox="0 0 1024 1024">
                                                                                            <path
                                                                                                fill="currentColor"
                                                                                                d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
                                                                                            </path>
                                                                                        </svg></i>





                                                                                </span></span>
                                                                        </div>
                                                                        <!-- append slot -->

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="el-form-item asterisk-left" role="group"
                                                        aria-labelledby="el-id-1087-170">
                                                        <div id="el-id-1087-170" class="el-form-item__label"
                                                            style="width: 30%;">{{ local.financial.wallet_address }}
                                                        </div>
                                                        <div class="el-form-item__content">
                                                            <div class="flex flex-col"><canvas width="100"
                                                                    height="100"
                                                                    style="width: 100px; height: 100px;"></canvas>
                                                                <div class="flex items-center"><span
                                                                        class="w-full break-words">56</span><svg
                                                                        class="svg-icon w-18 h-18 p-8"
                                                                        aria-hidden="true">
                                                                        <use xlink:href="#icon-copy" fill="#333">
                                                                        </use>
                                                                    </svg></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div data-v-110a66b8="" data-v-28012f00="" class="bank_charge" style="">
                                                <form data-v-110a66b8=""
                                                    class="el-form el-form--default el-form--label-left">
                                                    <div data-v-110a66b8="" class="el-form-item asterisk-left">
                                                        <label id="el-id-1087-163" for="el-id-1087-168"
                                                            class="el-form-item__label" style="width: 30%;">{{
                                                                local.financial.collect_coin_type
                                                            }}:</label>
                                                        <div class="el-form-item__content">
                                                            <!-- currencyName -->
                                                            <el-select v-model="currencyRight.id">
                                                                <el-option v-for="(item, index) in bankcardList "
                                                                    @click="get_wire_info(index)" :key="item.id"
                                                                    :label="item.currencyName"
                                                                    :value="item.id"></el-option>

                                                            </el-select>
                                                        </div>
                                                    </div>
                                                </form>
                                                <div data-v-110a66b8=""
                                                    class="flex flex-nowrap overflow-auto mb-10">
                                                    <div data-v-110a66b8="" v-for="item in wireList" :key="item.id"
                                                        class="w-full min-w-200 border-0 border-solid border-gray-100 border-r-[1px]">
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="">{{
                                                                local.bank.name
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">{{ item.bankName }}</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.address
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">{{
                                                                    item.bankAddress
                                                                }}</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.SWIFT
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">{{ item.swift }}</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.username
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">{{
                                                                    item.collectionName
                                                                }}</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.account
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">{{
                                                                    item.account
                                                                }}</span>
                                                        </div>
                                                        <div data-v-110a66b8=""
                                                            class="flex flex-col justify-between mt-6">
                                                            <span data-v-110a66b8="" class="pr-10">{{
                                                                local.bank.remark
                                                            }}:</span><span data-v-110a66b8=""
                                                                class="flex-item">{{ item.remark }}</span>
                                                        </div>

                                                        <div data-v-110a66b8="" @click="setWireid(item)"
                                                            class="flex justify-end">
                                                            <span style="color: #fff;">{{
                                                                currencyRight.aaa
                                                            }}</span>
                                                            <label data-v-110a66b8=""
                                                                class="el-checkbox is-checked"><span
                                                                    class="el-checkbox__input"
                                                                    :class="item.id == currencyRight.wire_id ? ' is-checked' : ''"><input
                                                                        class="el-checkbox__original"
                                                                        type="checkbox" id="el-id-7636-51"><span
                                                                        class="el-checkbox__inner"></span></span>

                                                            </label>


                                                            <!-- <el-checkbox  checked="item.id==currencyRight.wire_id"></el-checkbox>
                                                    {{item.id}}{{currencyRight.wire_id}} -->

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <form data-v-28012f00=""
                                                class="el-form el-form--default el-form--label-left">
                                                <div data-v-28012f00="" class="el-form-item asterisk-left"><label
                                                        id="el-id-1087-165" for="el-id-1087-169"
                                                        class="el-form-item__label" style="width: 30%;">{{
                                                            local.financial.charge_num
                                                        }}</label>
                                                    <div class="el-form-item__content">
                                                        <div data-v-28012f00="" class="el-input">
                                                            <!-- input -->
                                                            <!-- prepend slot -->

                                                            <div class="el-input__wrapper" role="button"
                                                                tabindex="-1">
                                                                <!-- prefix slot -->
                                                                <input class="el-input__inner" type="text"
                                                                    v-model="currencyRight.number"
                                                                    autocomplete="off" tabindex="0"
                                                                    :placeholder="local.financial.input_charge_num"
                                                                    id="el-id-1087-169">
                                                                <!-- suffix slot -->

                                                            </div><!-- append slot -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-v-28012f00="" class="el-form-item asterisk-left"
                                                    role="group" aria-labelledby="el-id-1087-166">
                                                    <div id="el-id-1087-166" class="el-form-item__label"
                                                        style="width: 30%;">{{ local.public.upload_pic }}</div>
                                                    <div class="el-form-item__content">
                                                        <div data-v-28012f00="" class="w-full">
                                                            <el-upload class="upload-demo"
                                                                :on-success="res => currencyRight.proofImg = res.data.fileUrl"
                                                                drag :headers="headers" :action="upload_url">
                                                                <img v-if="currencyRight.proofImg"
                                                                    :src="currencyRight.proofImg" alt="">
                                                                <i v-else class="el-icon-upload"></i>
                                                            </el-upload>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form><button @click="writeSubmit()" data-v-28012f00=""
                                                aria-disabled="false" type="button"
                                                class="el-button el-button--primary w-full border-0 bg-kline-up rounded-xl text-white h-40">
                                                <span class="">{{ local.public.submit }}</span></button>
                                            <div data-v-28012f00="" class="mt-10 mx-10 text-18 font-bold">
                                                {{ local.financial.charge_history }}</div>
                                            <div v-if="depositList.length > 0" data-v-28012f00=""
                                                class="px-10 pt-10 max-h-150 overflow-auto"
                                                infinite-scroll-distance="50" infinite-scroll-immediate="false"
                                                infinite-scroll-disabled="false">
                                                <div v-for="item in depositList" :key="item.id">
                                                    <div class="flex justify-between">
                                                        <div class="flex-1">
                                                            <div class="text-main-gray">
                                                                {{ local.financial.charge_num }}</div>
                                                            <div>{{ item.count }}</div>
                                                        </div>
                                                        <div class="flex-1 text-center">
                                                            <div class="text-main-gray">{{ local.trade.type }}</div>
                                                            <div>{{ local.financial.bank }}</div>
                                                        </div>
                                                        <div class="flex-1 text-right">
                                                            <div class="text-main-gray">{{ local.withdraw.unit }}
                                                            </div>
                                                            <div>{{ item.unit }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="flex justify-between mt-4">
                                                        <div class="flex-1">
                                                            <div class="text-main-gray">{{ local.public.status }}
                                                            </div>
                                                            <div>{{ item.status }}</div>
                                                        </div>
                                                        <div class="flex-1 text-right">
                                                            <div class="text-main-gray">{{ local.trade.time }}</div>
                                                            <div>{{ item.createTime }}</div>
                                                        </div>
                                                    </div>
                                                    <!---->
                                                </div>

                                            </div>
                                            <div class="el-empty" v-else>
                                                <el-empty :description="local.public.no_data"></el-empty>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 4" class="box-shadow w-500 rounded-10 p-10">
                                        <div class="">
                                            <div class="flex text-center text-white p-6 mb-10">
                                                <div class="flex-1 rounded-xl py-10 mr-1 bg-kline-up"
                                                    @click="active = 4">
                                                    {{ local.financial.coin }}
                                                </div>
                                                <div class="flex-1 rounded-xl py-10 ml-1 bg-main-gray"
                                                    @click="active = 5">
                                                    {{ local.financial.bank }}
                                                </div>
                                            </div>
                                            <form class="el-form el-form--default el-form--label-right">
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-173"
                                                        for="el-id-1087-184" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.withdraw.symbol }}</label>
                                                    <div class="el-form-item__content">
                                                        <el-select v-model="Wthdrawal" value-key="id"
                                                            class="el-select w-full" @change="wthdrawalChage">

                                                            <el-option v-for="item in digitalList" :key="item.id"
                                                                :label="item.currencyType + '-' + item.protocol"
                                                                :value="item">
                                                            </el-option>

                                                        </el-select>
                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-175"
                                                        for="el-id-1087-185" class="el-form-item__label"
                                                        style="width: 120px;">{{
                                                            local.withdraw.withdraw_address
                                                        }}</label>
                                                    <div class="el-form-item__content">
                                                        <el-select v-model="Wthdrawal.draw_method_id"
                                                            class="el-select w-full">

                                                            <el-option v-for="item in walletListBottom"
                                                                :key="item.id" :label="item.address"
                                                                :value="item.id">
                                                            </el-option>

                                                        </el-select>
                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left" style="display: none;">
                                                    <label id="el-id-1087-177" for="el-id-1087-186"
                                                        class="el-form-item__label" style="width: 120px;">{{
                                                            local.bank.account
                                                        }}</label>
                                                    <div class="el-form-item__content">
                                                        <div class="el-select w-full">
                                                            <div
                                                                class="select-trigger el-tooltip__trigger el-tooltip__trigger">

                                                                <!-- fix: https://github.com/element-plus/element-plus/issues/11415 -->

                                                                <div class="el-input el-input--suffix">
                                                                    <!-- input -->
                                                                    <!-- prepend slot -->

                                                                    <div class="el-input__wrapper" role="button"
                                                                        tabindex="-1">
                                                                        <!-- prefix slot -->
                                                                        <input class="el-input__inner" type="text"
                                                                            readonly="" autocomplete="off"
                                                                            tabindex="0"
                                                                            :placeholder="local.bank.account"
                                                                            id="el-id-1087-186"><!-- suffix slot --><span
                                                                            class="el-input__suffix"><span
                                                                                class="el-input__suffix-inner"><i
                                                                                    class="el-icon el-select__caret el-select__icon"><svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        viewBox="0 0 1024 1024">
                                                                                        <path fill="currentColor"
                                                                                            d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
                                                                                        </path>
                                                                                    </svg></i>
                                                                            </span></span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-179"
                                                        for="el-id-1087-187" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.public.number }}(USD)</label>
                                                    <div class="el-form-item__content">
                                                        <div class="el-input">
                                                            <!-- input -->
                                                            <!-- prepend slot -->

                                                            <div class="el-input__wrapper" role="button"
                                                                tabindex="-1">
                                                                <!-- prefix slot -->
                                                                <input class="el-input__inner" type="number"
                                                                    v-model="Wthdrawal.number" autocomplete="off"
                                                                    tabindex="0" :placeholder="local.public.number"
                                                                    id="el-id-1087-187">
                                                                <!-- suffix slot -->

                                                            </div><!-- append slot -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-180"
                                                        for="el-id-1087-188" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.bank.remark }}</label>
                                                    <div class="el-form-item__content">
                                                        <div class="el-textarea">
                                                            <!-- input -->
                                                            <!-- textarea --><textarea class="el-textarea__inner"
                                                                rows="1" tabindex="0" autocomplete="off"
                                                                :placeholder="local.bank.remark" id="el-id-1087-188"
                                                                v-model="Wthdrawal.memo"
                                                                style="min-height: 31px; height: 31px;"></textarea>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left" role="group"
                                                    aria-labelledby="el-id-1087-181">
                                                    <div id="el-id-1087-181" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.order.handle_fee }}</div>
                                                    <div class="el-form-item__content">
                                                        <template v-if="Wthdrawal.freeType == 0">
                                                            <div>
                                                                {{
                                                                    Wthdrawal.number ? Wthdrawal.number *
                                                                        Wthdrawal.withdrawalRate : 0
                                                                }}
                                                            </div>
                                                        </template>
                                                        <template v-if="Wthdrawal.freeType == 1">
                                                            <div>
                                                                {{
                                                                    Wthdrawal.withdrawalRate ?
                                                                        Wthdrawal.withdrawalRate
                                                                        : 0
                                                                }}
                                                            </div>
                                                        </template>

                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left" role="group"
                                                    aria-labelledby="el-id-1087-182">
                                                    <div id="el-id-1087-182" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.withdraw.calc_get }}</div>
                                                    <div class="el-form-item__content">
                                                        <template v-if="Wthdrawal.freeType == 0">
                                                            <div>
                                                                {{
                                                                    Wthdrawal.number ? Wthdrawal.number /
                                                                        Wthdrawal.usdRate - (Wthdrawal.number ?
                                                                            Wthdrawal.number *
                                                                            Wthdrawal.withdrawalRate / Wthdrawal.usdRate : 0) :
                                                                        0
                                                                }}
                                                                {{ Wthdrawal.currencyType }}</div>
                                                        </template>
                                                        <template v-if="Wthdrawal.freeType == 1">
                                                            <div>
                                                                {{
                                                                    Wthdrawal.number ? Wthdrawal.number /
                                                                        Wthdrawal.usdRate - (Wthdrawal.withdrawalRate ?
                                                                            Wthdrawal.withdrawalRate / Wthdrawal.usdRate : 0) :
                                                                        0
                                                                }}
                                                                {{ Wthdrawal.currencyType }}</div>
                                                        </template>

                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left" role="group"
                                                    aria-labelledby="el-id-1087-183">
                                                    <div id="el-id-1087-183" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.order.balance }}</div>
                                                    <div class="el-form-item__content">
                                                        <div>{{ user_balance }} USD</div>
                                                    </div>
                                                </div>
                                            </form><button aria-disabled="false" type="button"
                                                @click="submitWthdrawal()"
                                                class="el-button el-button--primary w-full border-0 bg-kline-up rounded-xl text-white h-40">
                                                <span class="">{{ local.public.submit }}</span></button>
                                            <div class="mt-10 mx-10 text-18 font-bold">{{ local.withdraw.record }}
                                            </div>
                                            <div v-if="withdrawalRecord.length > 0"
                                                class="px-10 pt-10 max-h-150 overflow-auto"
                                                infinite-scroll-distance="50" infinite-scroll-immediate="false"
                                                infinite-scroll-disabled="true">
                                                <div v-for="item in withdrawalRecord" :key="item.id">
                                                    <div class="flex justify-between">
                                                        <div class="flex-1">
                                                            <div class="text-main-gray">{{ local.withdraw.amount }}
                                                            </div>
                                                            <div>{{ item.count }}</div>
                                                        </div>
                                                        <div class="flex-1 text-center">
                                                            <div class="text-main-gray">
                                                                {{ local.withdraw.send_amount }}</div>
                                                            <div>{{ item.num }}</div>
                                                        </div>
                                                        <div class="flex-1 text-right">
                                                            <div class="text-main-gray">{{ local.withdraw.unit }}
                                                            </div>
                                                            <div>{{ item.unit }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="flex justify-between mt-4">
                                                        <div class="flex-1">
                                                            <div class="text-main-gray">{{ local.order.handle_fee }}
                                                            </div>
                                                            <div>{{ item.free }}</div>
                                                        </div>
                                                        <div class="flex-1 text-center">
                                                            <div class="text-main-gray">{{ local.public.status }}
                                                            </div>
                                                            <div>{{
                                                                item.status == 1 ? local.financial.uncheck :
                                                                    item.status == 4 ? local.financial.isfinish :
                                                                        local.financial.unuseful
                                                            }}</div>
                                                        </div>
                                                        <div class="flex-1 text-right">
                                                            <div class="text-main-gray">{{ local.trade.time }}</div>
                                                            <div>{{ item.createTime }}</div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="text-main-gray">
                                                            {{ local.withdraw.withdraw_address }}</div>
                                                        <div>{{ item.address }}</div>
                                                    </div>
                                                    <div class="mt-4">
                                                        <div class="text-main-gray">{{ local.bank.remark }}</div>
                                                        <div>{{ item.remark }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="el-empty" v-else>
                                                <el-empty :description="local.public.no_data"></el-empty>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 5" class="box-shadow w-500 rounded-10 p-10">
                                        <div class="">
                                            <div class="flex text-center text-white p-6 mb-10">
                                                <div class="flex-1 rounded-xl py-10 mr-1 bg-main-gray"
                                                    @click="active = 4">
                                                    {{ local.financial.coin }}</div>
                                                <div class="flex-1 rounded-xl py-10 ml-1 bg-kline-up"
                                                    @click="active = 5">
                                                    {{ local.financial.bank }}
                                                </div>
                                            </div>
                                            <form class="el-form el-form--default el-form--label-right">
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-173"
                                                        for="el-id-1087-184" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.withdraw.symbol }}</label>
                                                    <div class="el-form-item__content">
                                                        <el-select v-model="bankWthdrawal1" value-key="id"
                                                            class="el-select w-full" @change="bankWthdrawal1Change">

                                                            <el-option v-for="item in currencyList" :key="item.id"
                                                                :value="item" :label="item.name">
                                                            </el-option>

                                                        </el-select>
                                                    </div>
                                                </div>

                                                <div class="el-form-item asterisk-left" style=""><label
                                                        id="el-id-1087-177" for="el-id-1087-186"
                                                        class="el-form-item__label" style="width: 120px;">{{
                                                            local.bank.account
                                                        }}</label>
                                                    <div class="el-form-item__content">
                                                        <el-select v-model="bankWthdrawal" value-key="id"
                                                            class="el-select w-full">

                                                            <el-option v-for="item in walletListTop" :key="item.id"
                                                                :label="item.account" :value="item">
                                                            </el-option>

                                                        </el-select>
                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-179"
                                                        for="el-id-1087-187" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.public.number }}(USD)</label>
                                                    <div class="el-form-item__content">
                                                        <div class="el-input">

                                                            <div class="el-input__wrapper" role="button"
                                                                tabindex="-1">
                                                                <input v-model="bankWthdrawal.number"
                                                                    class="el-input__inner" type="number"
                                                                    autocomplete="off" tabindex="0"
                                                                    :placeholder="local.public.number"
                                                                    id="el-id-1087-187">

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-180"
                                                        for="el-id-1087-188" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.bank.remark }}</label>
                                                    <div class="el-form-item__content">
                                                        <div class="el-textarea">
                                                            <textarea class="el-textarea__inner" rows="1"
                                                                tabindex="0" autocomplete="off"
                                                                :placeholder="local.bank.remark" id="el-id-1087-188"
                                                                v-model="bankWthdrawal.memo"
                                                                style="min-height: 31px; height: 31px;"></textarea>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="el-form-item asterisk-left" role="group"
                                                    aria-labelledby="el-id-1087-181">
                                                    <div id="el-id-1087-181" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.order.handle_fee }}</div>
                                                    <div class="el-form-item__content">
                                                        <template v-if="bankWthdrawal1.freeType == 1">
                                                            <div>
                                                                {{
                                                                    bankWthdrawal.number ? bankWthdrawal1.free : 0
                                                                }}
                                                            </div>
                                                        </template>
                                                        <template v-if="bankWthdrawal1.freeType == 2">
                                                            <div>
                                                                {{
                                                                    bankWthdrawal.number ? bankWthdrawal.number *
                                                                        bankWthdrawal1.free : 0
                                                                }}
                                                            </div>
                                                        </template>

                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left" role="group"
                                                    aria-labelledby="el-id-1087-182">
                                                    <div id="el-id-1087-182" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.withdraw.calc_get }}</div>
                                                    <div class="el-form-item__content">
                                                        <template v-if="bankWthdrawal1.freeType == 1">
                                                            <div>
                                                                {{
                                                                    bankWthdrawal.number ? bankWthdrawal.number /
                                                                        bankWthdrawal1.usdFree - bankWthdrawal1.free /
                                                                        bankWthdrawal1.usdFree : 0
                                                                }}
                                                                {{ bankWthdrawal1.name }}</div>
                                                        </template>
                                                        <template v-if="bankWthdrawal1.freeType == 2">
                                                            <div>
                                                                {{
                                                                    bankWthdrawal.number ? bankWthdrawal.number /
                                                                        bankWthdrawal1.usdFree - bankWthdrawal.number *
                                                                        bankWthdrawal1.free / bankWthdrawal1.usdFree
                                                                        : 0
                                                                }}
                                                                {{ bankWthdrawal1.name }}</div>
                                                        </template>

                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left" role="group"
                                                    aria-labelledby="el-id-1087-183">
                                                    <div id="el-id-1087-183" class="el-form-item__label"
                                                        style="width: 120px;">{{ local.order.balance }}</div>
                                                    <div class="el-form-item__content">
                                                        <div>{{ user_balance }} USD</div>
                                                    </div>
                                                </div>
                                            </form><button aria-disabled="false" type="button"
                                                @click="submitbankWthdrawal()"
                                                class="el-button el-button--primary w-full border-0 bg-kline-up rounded-xl text-white h-40">
                                                <span class="">{{ local.public.submit }}</span></button>
                                            <div class="mt-10 mx-10 text-18 font-bold">{{ local.withdraw.record }}
                                            </div>
                                            <div v-if="withdrawalbankRecord.length > 0"
                                                class="px-10 pt-10 max-h-150 overflow-auto"
                                                infinite-scroll-distance="50" infinite-scroll-immediate="false"
                                                infinite-scroll-disabled="true">
                                                <div v-for="item in withdrawalbankRecord" :key="item.id">
                                                    <div class="flex justify-between">
                                                        <div class="flex-1">
                                                            <div class="text-main-gray">{{ local.withdraw.amount }}
                                                            </div>
                                                            <div>{{ item.count }}</div>
                                                        </div>
                                                        <div class="flex-1 text-center">
                                                            <div class="text-main-gray">
                                                                {{ local.withdraw.send_amount }}</div>
                                                            <div>{{ item.num }}</div>
                                                        </div>
                                                        <div class="flex-1 text-right">
                                                            <div class="text-main-gray">{{ local.withdraw.unit }}
                                                            </div>
                                                            <div>{{ item.unit }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="flex justify-between mt-4">
                                                        <div class="flex-1">
                                                            <div class="text-main-gray">{{ local.order.handle_fee }}
                                                            </div>
                                                            <div>{{ item.free }}</div>
                                                        </div>
                                                        <div class="flex-1 text-center">
                                                            <div class="text-main-gray">{{ local.public.status }}
                                                            </div>
                                                            <div>{{
                                                                item.status == 1 ? local.financial.uncheck :
                                                                    item.status == 4 ? local.financial.isfinish :
                                                                        local.financial.unuseful
                                                            }}</div>
                                                        </div>
                                                        <div class="flex-1 text-right">
                                                            <div class="text-main-gray">{{ local.trade.time }}</div>
                                                            <div>{{ item.createTime }}</div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="text-main-gray">
                                                            {{ local.withdraw.withdraw_address }}</div>
                                                        <div>{{ item.address }}</div>
                                                    </div>
                                                    <div class="mt-4">
                                                        <div class="text-main-gray">{{ local.bank.remark }}</div>
                                                        <div>{{ item.remark }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="el-empty" v-else>
                                                <el-empty :description="local.public.no_data"></el-empty>
                                            </div>

                                        </div>
                                    </div>
                                    <div v-if="active == 6" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <div class="wallet-list px-20">
                                                <div class="py-10">
                                                    <div class="font-bold text-main-black">{{ local.order.balance }}
                                                    </div>
                                                    <div class="font-extrabold text-primary text-16">
                                                        {{ user_balance }}</div>
                                                </div>
                                                <div>
                                                    <div class="font-bold text-main-black">{{
                                                        local.financial.bank
                                                    }}
                                                    </div>
                                                    <div class="flex overflow-auto mt-10">

                                                        <div v-for="item in walletListTop" :key="item.id"
                                                            class="el-card is-always-shadow w-180 min-w-180 mr-20">
                                                            <div class="el-card__header">
                                                                <div class="flex justify-end"><i
                                                                        class="el-icon cursor-pointer"
                                                                        @click="cancelCurrencyTop(item.id)"
                                                                        style="font-size: 20px;"><svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 1024 1024">
                                                                            <path fill="currentColor"
                                                                                d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z">
                                                                            </path>
                                                                        </svg></i></div>
                                                            </div>
                                                            <div class="el-card__body" style="">
                                                                <div>
                                                                    <div class="flex justify-between">
                                                                        <div class="title">
                                                                            {{ local.financial.collect_coin_type }}:
                                                                        </div>
                                                                        <div class="content">{{ item.currency }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="flex justify-between">
                                                                        <div class="title">{{ local.bank.name }}:
                                                                        </div>
                                                                        <div class="content">{{ item.name }}</div>
                                                                    </div>
                                                                    <div class="flex justify-between">
                                                                        <div class="title">{{ local.bank.account }}:
                                                                        </div>
                                                                        <div class="content">{{ item.account }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="flex justify-between">
                                                                        <div class="title">{{
                                                                            local.bank.username
                                                                        }}:
                                                                        </div>
                                                                        <div class="content">{{ item.payee }}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!---->
                                                        <div @click="active = 21"
                                                            class="add flex items-center justify-center"><i
                                                                class="el-icon cursor-pointer"
                                                                style="font-size: 40px;"><svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 1024 1024">
                                                                    <path fill="currentColor"
                                                                        d="M480 480V128a32 32 0 0 1 64 0v352h352a32 32 0 1 1 0 64H544v352a32 32 0 1 1-64 0V544H128a32 32 0 0 1 0-64h352z">
                                                                    </path>
                                                                </svg></i></div>
                                                    </div>
                                                    <div class="font-bold text-main-black mt-20">
                                                        {{ local.financial.coin }}
                                                    </div>
                                                    <div class="flex overflow-auto my-10">

                                                        <div v-for="item in walletListBottom" :key="item.id"
                                                            class="el-card is-always-shadow w-180 min-w-180 mr-20">
                                                            <div class="el-card__header">
                                                                <div class="flex justify-end"><i
                                                                        @click="cancelCurrencyButtom(item.id)"
                                                                        class="el-icon cursor-pointer"
                                                                        style="font-size: 20px;"><svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 1024 1024">
                                                                            <path fill="currentColor"
                                                                                d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z">
                                                                            </path>
                                                                        </svg></i></div>
                                                            </div>
                                                            <div class="el-card__body" style="">
                                                                <div>
                                                                    <div class="flex justify-between">
                                                                        <div class="title">
                                                                            {{ local.withdraw.symbol }}:</div>
                                                                        <div class="content">
                                                                            {{ item.currencyType }}-{{
                                                                                item.protocol
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="flex justify-between">
                                                                        <div class="title">
                                                                            {{ local.withdraw.withdraw_address }}:
                                                                        </div>
                                                                        <div class="content">{{ item.address }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!---->


                                                        <div @click="active = 22"
                                                            class="add flex items-center justify-center"><i
                                                                class="el-icon cursor-pointer"
                                                                style="font-size: 40px;"><svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 1024 1024">
                                                                    <path fill="currentColor"
                                                                        d="M480 480V128a32 32 0 0 1 64 0v352h352a32 32 0 1 1 0 64H544v352a32 32 0 1 1-64 0V544H128a32 32 0 0 1 0-64h352z">
                                                                    </path>
                                                                </svg></i></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!---->
                                            <!---->
                                        </div>
                                    </div>
                                    <div v-if="active == 7" class="box-shadow w-500 rounded-10 p-10 identity">
                                        <div v-if="centerData.review_status == 0" class="">
                                            <div class="auth-page p-16 mt-8">
                                                <div class="text-12 text-main-black pl-10 mb-10">
                                                    {{ local.auth.upload_idcard }}</div>
                                                <div class="bg-white rounded-10 p-10 base-shadow">
                                                    <div
                                                        class="flex items-center justify-between bg-[#F8F8F8] rounded-4 p-10">
                                                        <div class="pl-8">
                                                            <div class="text-18 text-main-black mb-6">
                                                                {{ local.auth.front }}</div>
                                                            <div class="text-12 text-[#CBCBCB]">
                                                                {{ local.auth.upload_front }}</div>
                                                        </div>
                                                        <div class="w-186 h-122">

                                                            <el-upload
                                                                :on-success="res => identity.front_pic = res.data.fileUrl"
                                                                drag :headers="headers" :action="upload_url">
                                                                <div class="el-upload el-upload--text" tabindex="0">
                                                                    <img v-if="identity.front_pic"
                                                                        :src="identity.front_pic" alt="">
                                                                    <img v-else
                                                                        src="data:image/png;base64,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"><input
                                                                        class="el-upload__input" name="file"
                                                                        accept="" type="file">
                                                                </div>
                                                            </el-upload>

                                                        </div>
                                                    </div>
                                                    <div
                                                        class="flex items-center justify-between bg-[#F8F8F8] rounded-4 p-10 mt-10">
                                                        <div class="pl-8">
                                                            <div class="text-18 text-main-black mb-6">
                                                                {{ local.auth.back }}</div>
                                                            <div class="text-12 text-[#CBCBCB]">
                                                                {{ local.auth.upload_back }}</div>
                                                        </div>
                                                        <div class="w-186 h-122">
                                                            <el-upload
                                                                :on-success="res => identity.reverse_pic = res.data.fileUrl"
                                                                drag :headers="headers" :action="upload_url">
                                                                <div class="el-upload el-upload--text" tabindex="0">
                                                                    <img v-if="identity.reverse_pic"
                                                                        :src="identity.reverse_pic" alt="">
                                                                    <img v-else
                                                                        src="data:image/png;base64,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"><input
                                                                        class="el-upload__input" name="file"
                                                                        accept="" type="file">
                                                                </div>
                                                            </el-upload>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="bg-white rounded-10 mt-10 base-shadow">
                                                    <div class="p-10 text-12">{{ local.auth.input_info }}</div>
                                                    <form class="el-form el-form--default el-form--label-right">
                                                        <div class="el-form-item asterisk-left"><label
                                                                id="el-id-1087-195" for="el-id-1087-197"
                                                                class="el-form-item__label" style="width: 120px;">{{
                                                                    local.auth.name
                                                                }}</label>
                                                            <div class="el-form-item__content">
                                                                <div class="el-input">

                                                                    <div class="el-input__wrapper" role="button"
                                                                        tabindex="-1">
                                                                        <input class="el-input__inner"
                                                                            v-model="identity.name" type="text"
                                                                            autocomplete="off" tabindex="0"
                                                                            :placeholder="local.auth.input_name"
                                                                            id="el-id-1087-197">

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="el-form-item asterisk-left"><label
                                                                id="el-id-1087-196" for="el-id-1087-198"
                                                                class="el-form-item__label" style="width: 120px;">{{
                                                                    local.auth.id_number
                                                                }}</label>
                                                            <div class="el-form-item__content">
                                                                <div class="el-input">
                                                                    <!-- input -->
                                                                    <!-- prepend slot -->

                                                                    <div class="el-input__wrapper" role="button"
                                                                        tabindex="-1">
                                                                        <!-- prefix slot -->
                                                                        <input class="el-input__inner"
                                                                            v-model="identity.card_id" type="text"
                                                                            autocomplete="off" tabindex="0"
                                                                            :placeholder="local.auth.input_id_num"
                                                                            id="el-id-1087-198">
                                                                        <!-- suffix slot -->

                                                                    </div><!-- append slot -->

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div><button aria-disabled="false" @click="submitreal_name()"
                                                    type="button"
                                                    class="el-button is-round w-full mt-14 border-0 bg-kline-up text-white h-40"
                                                    block="">
                                                    <span class="">確認</span></button>
                                            </div>
                                        </div>
                                        <div v-if="centerData.review_status == 1" class="">
                                            <div class="text-center text-xl my-40"><i class="el-icon"
                                                    style="font-size: 60px; --color: #0166fc;"><svg
                                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                                        <path fill="currentColor"
                                                            d="M160 224a32 32 0 0 0-32 32v512a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V256a32 32 0 0 0-32-32H160zm0-64h704a96 96 0 0 1 96 96v512a96 96 0 0 1-96 96H160a96 96 0 0 1-96-96V256a96 96 0 0 1 96-96z">
                                                        </path>
                                                        <path fill="currentColor"
                                                            d="M704 320a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM288 448h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32zm0 128h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32z">
                                                        </path>
                                                    </svg></i>
                                                <div>審核中</div>
                                            </div>
                                        </div>

                                        <div v-if="centerData.review_status == 2" class="">
                                            <div class="text-center text-xl my-40">
                                                <div><i class="el-icon"
                                                        style="font-size: 60px; --color: #0166fc;"><svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 1024 1024">
                                                            <path fill="currentColor"
                                                                d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z">
                                                            </path>
                                                        </svg></i></div>
                                                <div class="mt-10">{{ local.auth.finish }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 8" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <div class="bg-white m-10 rounded-10 text-center py-10"
                                                style="box-shadow: rgba(161, 161, 161, 0.09) 0px 0px 24px 0px;">
                                                <div class="text-main-gray text-12 text-center">
                                                    {{ local.user.invite_code }}</div>
                                                <div class="my-10 text-kline-up text-16">{{
                                                    userInfo.user.inviteCode
                                                }}</div>
                                                <div class="text-center"
                                                    style="display: flex;justify-content: center;">
                                                    <img :src="inviteImg" alt="" srcset=""
                                                        style="width: 160px; height: 160px;">
                                                </div>
                                                <div class="text-center text-12 my-10 px-20">
                                                    {{
                                                    `${host}/#/?invite_code=${userInfo.user.inviteCode}`
                                                    }}</div><button aria-disabled="false" type="button"
                                                    class="el-button h-36 text-white flex-1 bg-kline-up rounded-xl mr-8 border-0"
                                                    @click="copy(inviteAddress)">
                                                    <span class="">{{
                                                        local.user.copy_invite_link
                                                    }}</span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 9" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <form class="el-form el-form--default el-form--label-top">
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-199"
                                                        for="el-id-1087-202" class="el-form-item__label">{{
                                                            local.user.input_password
                                                        }}</label>
                                                    <div class="el-form-item__content">
                                                        <div class="el-input">
                                                            <!-- input -->
                                                            <!-- prepend slot -->

                                                            <div class="el-input__wrapper" role="button"
                                                                tabindex="-1">
                                                                <!-- prefix slot -->
                                                                <input v-model="resert.password"
                                                                    class="el-input__inner" type="password"
                                                                    autocomplete="off" tabindex="0"
                                                                    :placeholder="local.user.input_password"
                                                                    id="el-id-1087-202"><!-- suffix slot -->

                                                            </div><!-- append slot -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="el-form-item asterisk-left"><label id="el-id-1087-200"
                                                        for="el-id-1087-203" class="el-form-item__label">{{
                                                            local.user.re_input_pass
                                                        }}</label>
                                                    <div class="el-form-item__content">
                                                        <div class="el-input">
                                                            <!-- input -->
                                                            <!-- prepend slot -->

                                                            <div class="el-input__wrapper" role="button"
                                                                tabindex="-1">
                                                                <!-- prefix slot -->
                                                                <input v-model="resert.confirmPassword"
                                                                    class="el-input__inner" type="password"
                                                                    autocomplete="off" tabindex="0"
                                                                    :placeholder="local.user.re_input_pass"
                                                                    id="el-id-1087-203"><!-- suffix slot -->

                                                            </div><!-- append slot -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="el-form-item asterisk-left"><label id="el-id-1087-201"
                                                for="el-id-1087-204" class="el-form-item__label">請輸入驗證碼</label>
                                            <div class="el-form-item__content">
                                                <div class="el-input el-input--suffix">
                                                    
                                                    <div class="el-input__wrapper" role="button" tabindex="-1">
                                                        <input class="el-input__inner" type="text"
                                                            autocomplete="off" tabindex="0" placeholder="請輸入驗證碼"
                                                            id="el-id-1087-204"><span
                                                            class="el-input__suffix"><span
                                                                class="el-input__suffix-inner"><button
                                                                    aria-disabled="false" type="button"
                                                                    class="el-button el-button--primary bg-kline-up border-0">
                                                                    <span class="">發送</span></button>
                                                                </span></span></div>
                                                    
                                                </div>
                                            </div>
                                        </div> -->
                                            </form>
                                            <div class="text-center"><button @click="changeLoginPassword()"
                                                    aria-disabled="false" type="button"
                                                    class="el-button mx-auto w-[80%] border-0 bg-kline-up rounded-xl text-white h-40 my-20">
                                                    <span class="">{{
                                                        local.public.submit
                                                    }}</span></button></div>
                                        </div>
                                    </div>
                                    <div v-if="active == 10" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <div class="bg-white m-10 rounded-10 text-center py-10"
                                                style="box-shadow: rgba(161, 161, 161, 0.09) 0px 0px 24px 0px;">
                                                <div class="text-center text-16 my-10 px-20">{{ email }}</div>
                                                <button aria-disabled="false" type="button" @click="copy(email)"
                                                    class="el-button h-36 text-white flex-1 bg-kline-up rounded-10 mr-8 border-0">

                                                    <span class="">{{ local.public.copy }}</span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 11" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <div class="bg-white m-10 rounded-10 py-10"
                                                style="box-shadow: rgba(161, 161, 161, 0.09) 0px 0px 24px 0px;">
                                                <div class="text-18 my-10 px-20">{{ local.user.announ_text }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 100" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <div class="bg-white m-10 rounded-10 text-center py-10"
                                                style="box-shadow: rgba(161, 161, 161, 0.09) 0px 0px 24px 0px;"
                                                v-for="item in onlineList" :key="item.id">
                                                <div class="text-center text-16 my-10 px-20">
                                                    {{ item.customerServiceAddress }}</div>
                                                <button aria-disabled="false" type="button"
                                                    @click="serviceClick(item.customerServiceAddress)"
                                                    class="el-button h-36 text-white flex-1 bg-kline-up rounded-10 mr-8 border-0">
                                                    <span class="">{{ local.public.tocust }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="active == 21" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <!---->
                                            <div class="p-20">
                                                <div class="el-breadcrumb" aria-label="Breadcrumb"
                                                    role="navigation"><span
                                                        class="el-breadcrumb__item cursor-pointer"><span
                                                            class="el-breadcrumb__inner" role="link">{{
                                                                local.func.wallet
                                                            }}</span><span class="el-breadcrumb__separator"
                                                            role="presentation">/</span></span><span
                                                        class="el-breadcrumb__item" aria-current="page"><span
                                                            class="el-breadcrumb__inner" role="link">{{
                                                                local.financial.bank
                                                            }}</span><span class="el-breadcrumb__separator"
                                                            role="presentation">/</span></span></div>
                                                <form class="el-form el-form--default el-form--label-right mt-30">
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-4579-335" for="el-id-4579-342"
                                                            class="el-form-item__label" style="width: 100px;">{{
                                                                local.withdraw.symbol
                                                            }}</label>
                                                        <div class="el-form-item__content">

                                                            <el-select value-key="id" v-model="currency"
                                                                class="el-select w-full">
                                                                <el-option v-for="item in currencyList"
                                                                    :value="item" :label="item.name"></el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-4579-337" for="el-id-4579-343"
                                                            class="el-form-item__label" style="width: 100px;">{{
                                                                local.bank.name
                                                            }}</label>
                                                        <div class="el-form-item__content">
                                                            <div class="el-input">
                                                                <!-- input -->
                                                                <!-- prepend slot -->

                                                                <div class="el-input__wrapper" role="button"
                                                                    tabindex="-1">
                                                                    <!-- prefix slot -->
                                                                    <input class="el-input__inner" type="text"
                                                                        v-model="currency.bank_name"
                                                                        autocomplete="off" tabindex="0"
                                                                        :placeholder="local.bank.name"
                                                                        id="el-id-4579-343">
                                                                    <!-- suffix slot -->

                                                                </div><!-- append slot -->

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-4579-338" for="el-id-4579-344"
                                                            class="el-form-item__label" style="width: 100px;">{{
                                                                local.bank.address
                                                            }}</label>
                                                        <div class="el-form-item__content">
                                                            <div class="el-input">
                                                                <!-- input -->
                                                                <!-- prepend slot -->

                                                                <div class="el-input__wrapper" role="button"
                                                                    tabindex="-1">
                                                                    <!-- prefix slot -->
                                                                    <input v-model="currency.bank_address"
                                                                        class="el-input__inner" type="text"
                                                                        autocomplete="off" tabindex="0"
                                                                        :placeholder="local.bank.address"
                                                                        id="el-id-4579-344"><!-- suffix slot -->

                                                                </div><!-- append slot -->

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-4579-339" for="el-id-4579-345"
                                                            class="el-form-item__label" style="width: 100px;">{{
                                                                local.bank.SWIFT
                                                            }}</label>
                                                        <div class="el-form-item__content">
                                                            <div class="el-input">
                                                                <!-- input -->
                                                                <!-- prepend slot -->

                                                                <div class="el-input__wrapper" role="button"
                                                                    tabindex="-1">
                                                                    <!-- prefix slot -->
                                                                    <input class="el-input__inner" type="text"
                                                                        v-model="currency.bank_swift"
                                                                        autocomplete="off" tabindex="0"
                                                                        placeholder="SWIFT"
                                                                        id="el-id-4579-345"><!-- suffix slot -->

                                                                </div><!-- append slot -->

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-4579-340" for="el-id-4579-346"
                                                            class="el-form-item__label" style="width: 100px;">{{
                                                                local.bank.username
                                                            }}</label>
                                                        <div class="el-form-item__content">
                                                            <div class="el-input">
                                                                <!-- input -->
                                                                <!-- prepend slot -->

                                                                <div class="el-input__wrapper" role="button"
                                                                    tabindex="-1">
                                                                    <!-- prefix slot -->
                                                                    <input class="el-input__inner" type="text"
                                                                        autocomplete="off" tabindex="0"
                                                                        :placeholder="local.bank.username"
                                                                        v-model="currency.payee_name"
                                                                        id="el-id-4579-346">
                                                                    <!-- suffix slot -->

                                                                </div><!-- append slot -->

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-4579-341" for="el-id-4579-347"
                                                            class="el-form-item__label" style="width: 100px;">{{
                                                                local.bank.account
                                                            }}</label>
                                                        <div class="el-form-item__content">
                                                            <div class="el-input">
                                                                <!-- input -->
                                                                <!-- prepend slot -->

                                                                <div class="el-input__wrapper" role="button"
                                                                    tabindex="-1">
                                                                    <!-- prefix slot -->
                                                                    <input class="el-input__inner" type="text"
                                                                        autocomplete="off" tabindex="0"
                                                                        :placeholder="local.bank.account"
                                                                        v-model="currency.payee_account"
                                                                        id="el-id-4579-347"><!-- suffix slot -->

                                                                </div><!-- append slot -->

                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                                <div class="text-center"><button aria-disabled="false" type="button"
                                                        @click="submitCurrency()"
                                                        class="el-button mx-auto w-[80%] border-0 bg-kline-up rounded-xl text-white h-40 my-20">
                                                        <span class="">{{
                                                            local.public.submit
                                                        }}</span></button></div>
                                            </div>
                                            <!---->
                                        </div>
                                    </div>
                                    <div v-if="active == 22" class="box-shadow w-500 rounded-10 p-10">
                                        <div>
                                            <!---->
                                            <!---->
                                            <div class="p-20">
                                                <div class="el-breadcrumb" aria-label="Breadcrumb"
                                                    role="navigation"><span
                                                        class="el-breadcrumb__item cursor-pointer"><span
                                                            class="el-breadcrumb__inner" role="link">{{
                                                                local.func.wallet
                                                            }}</span><span class="el-breadcrumb__separator"
                                                            role="presentation">/</span></span><span
                                                        class="el-breadcrumb__item" aria-current="page"><span
                                                            class="el-breadcrumb__inner" role="link">{{
                                                                local.financial.coin
                                                            }}</span><span class="el-breadcrumb__separator"
                                                            role="presentation">/</span></span></div>
                                                <form class="el-form el-form--default el-form--label-right mt-30">
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-4579-352" for="el-id-4579-355"
                                                            class="el-form-item__label" style="width: 100px;">{{
                                                                local.withdraw.symbol
                                                            }}</label>
                                                        <div class="el-form-item__content">

                                                            <el-select v-model="digital" value-key="id"
                                                                class="el-select w-full">
                                                                <el-option v-for="item in digitalList"
                                                                    :key="item.id"
                                                                    :label="item.currencyType + '-' + item.protocol"
                                                                    :value="item">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                    <div class="el-form-item asterisk-left"><label
                                                            id="el-id-4579-354" for="el-id-4579-356"
                                                            class="el-form-item__label" style="width: 100px;">{{
                                                                local.financial.wallet_address
                                                            }}</label>
                                                        <div class="el-form-item__content">
                                                            <div class="el-input">
                                                                <!-- input -->
                                                                <!-- prepend slot -->

                                                                <div class="el-input__wrapper" role="button"
                                                                    tabindex="-1">
                                                                    <!-- prefix slot -->
                                                                    <input v-model="digital.dc_address"
                                                                        class="el-input__inner" type="text"
                                                                        autocomplete="off" tabindex="0"
                                                                        :placeholder="local.financial.wallet_address"
                                                                        id="el-id-4579-356"><!-- suffix slot -->

                                                                </div><!-- append slot -->

                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                                <div class="text-center"><button aria-disabled="false" type="button"
                                                        @click="submitDigital()"
                                                        class="el-button mx-auto w-[80%] border-0 bg-kline-up rounded-xl text-white h-40 my-20">
                                                        <span class="">{{
                                                            local.public.submit
                                                        }}</span></button></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="el-overlay" style="z-index: 1007; display: none;">
                    <div role="dialog" aria-modal="true" aria-labelledby="el-id-1087-11"
                        aria-describedby="el-id-1087-12" class="el-overlay-dialog"></div>
                </div>
            </div>

            <footer class="el-footer my-20 footer" v-if="loginStaus" style="">
                <div class="bg-white dark:bg-[#202A39] rounded-10">

                    <div class="text-main-gray flex text-center px-20">
                        <div class="py-10 px-20 cursor-pointer border-b-2 border-solid text-center " 
                        :class="activeTabList === 'contract' ? 'text-primary border-primary' : 'border-transparent'"
                        @click="switchTabList('contract')">合約</div>
                        <div class="py-10 px-20 cursor-pointer border-b-2 border-solid text-center " 
                        :class="activeTabList === 'future' ? 'text-primary border-primary' : 'border-transparent'"
                        @click="switchTabList('future')">期限</div>
                    </div>

                    <div class="min-h-300" v-show="activeTabList == 'contract'">
                        <div class="flex items-center justify-between px-20">
                            <div class="text-main-gray flex text-center">
                                <div class="py-10 pr-20 cursor-pointer" :class="activeIndex == 1 ? 'text-primary' : ''"
                                    @click="activeIndex = 1; gettrade_list(1)">{{ local.order.holding }}</div>
                                <div class="py-10 px-20 cursor-pointer" :class="activeIndex == 0 ? 'text-primary' : ''"
                                    @click="activeIndex = 0; gettrade_list(0)">{{ local.order.un_deal_order }}</div>
                                <div class="py-10 px-20 cursor-pointer" :class="activeIndex == 3 ? 'text-primary' : ''"
                                    @click="activeIndex = 3; gettrade_list(3)">{{ local.order.history }}</div>
                            </div>
                            <div class="flex items-center text-main-gray">
                                <div>{{ local.order.total_ol }}: <span class="text-kline-up">{{
                                    getCautionMoneyAll(trade_list1)
                                }}</span>
                                </div>
                                <div class="mx-30" v-if="status != 3">{{ local.order.all_caution_money }}: <span
                                        class="text-main-black">{{
                                            CautionMoneyAll
                                        }}</span></div>
                            </div>
                        </div>
                        <div class="px-20 text-18 mb-10" infinite-scroll-immediate="false"
                            infinite-scroll-disabled="true">
                            <div class="flex justify-between items-center text-main-gray text-12">
                                <div class="flex-1 text-center"> {{ local.order.currency }}</div>
                                <div class="flex-2 text-center">{{ local.order.order_id }}</div>
                                <div class="flex-1 text-center">{{ local.order.order_type }}</div>
                                <div class="flex-1 text-center">{{ local.order.page }} </div>
                                <div class="flex-1 text-center">
                                    {{ local.order.order_price }}</div>
                                <div class="flex-1 text-center" v-if="activeIndex == 3">{{ local.order.close_price }}
                                </div>
                                <div class="flex-1 text-center" v-if="activeIndex == 1 || activeIndex == 0">
                                    {{ local.order.current_price }}</div>
                                <div class="flex-1 text-center">{{ local.order.stop_profit }}</div>
                                <div class="flex-1 text-center">{{ local.order.stop_loss }}</div>
                                <div class="flex-1 text-center">{{ local.order.handle_fee }}</div>
                                <div class="flex-1 text-center">{{ local.order.bond_fee }}</div>
                                <div class="flex-1 text-center">{{ local.order.income }}</div>
                                <div class="flex-1 text-center">{{ local.order.open_time }}</div>
                                <div v-if="activeIndex != 3" class="flex-2 text-center">{{ local.trade.operate }}</div>
                            </div>
                            <div class="flex justify-between py-10 text-main-black mt-10" v-if="trade_list.length > 0"
                                v-for="(item, index) in trade_list" :key="item.id">
                                <div class="flex-1 text-center">{{ item.name }}</div>
                                <div class="flex-2 text-center">#{{ item.orderNo }}</div>
                                <div class="flex-1 text-center"><span
                                        class="py-6 px-16 text-white rounded-xl bg-kline-up"
                                        v-if="item.direction == 'buy'">{{ local.order.buy_in }}</span>
                                    <span class="py-6 px-16 text-white rounded-xl bg-kline-down"
                                        v-if="item.direction == 'sell'">{{ local.trade.sell }}</span>
                                </div>
                                <div class="flex-1 text-center">{{ item.handCount }}</div>
                                <div class="flex-1 text-center">{{ item.price }}
                                </div>
                                <div class="flex-1 text-center" v-if="activeIndex == 3">{{ item.mark_price }}11</div>
                                <div class="flex-1 text-center" v-if="activeIndex == 1 || activeIndex == 0">
                                    {{ item.mark_price }}22</div>
                                <div class="flex-1 text-center">{{ item.stopPriceProfit ? item.stopPriceProfit : "--" }}
                                </div>
                                <div class="flex-1 text-center">{{ item.stopPriceLoss ? item.stopPriceLoss : "--" }}
                                </div>
                                <div class="flex-1 text-center">{{ item.fee }}</div>
                                <div class="flex-1 text-center">{{ item.deposit }}</div>
                                <div class="flex-1 text-center "
                                    :class="item.profit > 0 ? 'text-kline-up' : 'text-kline-down'">{{
                                        item.profit ?
                                            item.profit : "--"
                                    }}</div>
                                <div class="flex-1 text-center">{{ item.createTime }}</div>
                                <div v-if="activeIndex == 1" class="flex-2 text-center">
                                    <span
                                        @click="active = 16; stop.orderNo = item.orderNo; stop.index = index, stop.target_profit_price = item.stopPriceProfit, stop.stop_loss_price = item.stopPriceLoss "
                                        class="bg-[#e8f4ff] text-kline-up py-6 px-16 rounded-xl cursor-pointer mr-10 whitespace-nowrap">
                                        TP/SL </span>
                                    <span @click="ClosePosition(item)"
                                        class="bg-[#FFECE8] text-kline-down py-6 px-16 rounded-xl cursor-pointer whitespace-nowrap">{{
                                            local.order.close
                                        }}</span>
                                </div>
                                <div v-if="activeIndex == 0" class="flex-2 text-center">
                                    <span @click="CancelOrder(item)"
                                        class="bg-[#e8f4ff] text-kline-up py-6 px-16 rounded-xl cursor-pointer mr-10 whitespace-nowrap">
                                        {{
                                            local.order.cancel
                                        }}
                                    </span>

                                </div>

                            </div>


                            <div class="el-empty" v-else>
                                <el-empty :description="local.public.no_data"></el-empty>
                            </div>
                        </div>
                    </div>

                    <div class="min-h-300" v-show="activeTabList == 'future'">
                        <div class="flex items-center justify-between px-20">
                            <div class="text-main-gray flex text-center">
                                <div class="py-10 pr-20 cursor-pointer" 
                                :class="activeTermItem === 'in_transaction' ? 'text-primary' : ''"
                                @click="activeTermItem = 'in_transaction',fetchUserTermData()">交易中</div>
                                <div class="py-10 px-20 cursor-pointer" 
                                :class="activeTermItem === 'closed_position' ? 'text-primary' : ''"
                                @click="activeTermItem = 'closed_position',fetchUserTermData()">已平倉</div>
                            </div>
                        </div>

                        <div class="px-20 text-14 mb-10">
                            <!-- 表头 -->
                            <div class="flex justify-between items-center text-main-gray text-12">
                            <div class="flex-1">{{local.micro.trading_pairs}}</div>
                            <div class="flex-1 text-center">{{local.loan.amount}}</div>
                            <div class="flex-1 text-center">{{local.micro.direction}}</div>
                            <div class="flex-1 text-center">{{local.micro.predict_profit}}</div>
                            <div class="w-100 text-center">{{local.micro.trade_time}}</div>
                            <div class="flex-1 text-center">{{local.micro.open_time}}</div>
                            </div>

                            <!-- 数据列表 -->
                            <div v-if="userTermList.length > 0">
                                <div 
                                    v-for="(item, index) in userTermList" 
                                    :key="index"
                                    class="flex justify-between items-center py-10 border-b border-gray-100 dark:border-gray-700"
                                >
                                    <div class="flex-1">{{ item.pair }}</div>
                                    <div class="flex-1 text-center">{{ item.amount }}</div>
                                    <div class="flex-1 text-center" :class="item.direction === '0' ? 'text-kline-up' : 'text-kline-down'">
                                    {{ item.direction === '0' ? 'local.order.buy_in' : 'local.order.sell_out' }}
                                    </div>
                                    <div class="flex-1 text-center" :class="item.profit >= 0 ? 'text-kline-up' : 'text-kline-down'">
                                    {{ item.profit }}
                                    </div>
                                    <div class="w-100 text-center">{{ item.duration }}</div>
                                    <div class="flex-1 text-center">{{ item.openTime }}</div>
                                </div>
                                </div>

                                <!-- 空状态 -->
                                <div v-else class="el-empty">
                                <div class="el-empty__image" style="width: 200px;">
                                    <svg viewBox="0 0 79 86" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <!-- SVG内容保持不变 -->
                                    </svg>
                                </div>
                                <div class="el-empty__description">
                                    <p>{{local.public.no_data}}</p>
                                </div>
                                </div>

                                <!-- Element Plus分页 -->
                                <div class="mt-20 flex justify-center">
                                <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :page-size="userTermPagination.pageSize"
                                    :total="userTermPagination.total"
                                    :current-page="userTermPagination.currentPage"
                                    @current-change="handleUserTermPageChange"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import obj from "../until/lauange.js";
import $ from "jquery";
import axios from "axios";
import { KLineChartPro, DefaultDatafeed } from "klinechartspro";
import QRCode from "qrcode";
import { debounce, throttle } from "@/until/index.js"

axios.interceptors.request.use(
    function (config) {
        if (!config.params) {
            config.params = {}
        }
        config.params['language'] = window.localStorage.getItem("language") || "en"
        if (window.localStorage.getItem("token")) {
            // 如果token不为null，否则传token给后台
            config.headers["Authorization"] = window.localStorage.getItem("token");
            //   config.headers["Location"] = "1";
        }
        return config;
    },
    function (error) {
        // Do something with request error

        return Promise.reject(error);
    }
);

// Add a response interceptor
import { ElNotification } from "element-plus";
import { t } from "element-plus/lib/locale/index.js";

axios.interceptors.response.use(
    (response) => {
        if (response.data.code == 500) {
            console.log(this);
            ElNotification({
                title: response.data.msg,
                type: "error",
            });
        }
        if (response.data.code == 401) {
            window.localStorage.removeItem('token')
        }
        if (response.data.code == 0) {
            console.log(response);
            ElNotification({
                title: response.data.msg,
                type: "error",
            });
        }
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);
// axios.defaults.baseURL = "http://127.0.0.1:9101";
axios.defaults.baseURL = "https://api.sccesiy.cyou";
export default {
    data: function () {
        return {
            isDark: false,
            bgColor: '#ffffff',
            textColor: '#000000',
            inviteImg: '',
            inviteAddress: '',
            host: window.location.host,
            onlineList: [],
            is_mock: window.localStorage.getItem("is_mock") || false,
            scrollTop: 0,
            currentSymbolTimer: null,
            timer: null,
            CategoriesList: {},
            loading: true,
            listLoading: false,
            finished: false,
            contury: [
            {
                    value: "en",
                    label: "English",
                    imgUrl: require("@/assets/DEMO_files/en140ceb36.png"),
                },
                {
                    value: "Japanese",
                    label: "日本語",
                    imgUrl:
                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAgEAYAAAAERCdfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAA4lJREFUaN7tmu9LE3Ecx99n5yZrux60zG2F0hCUNJcrzT2tZz00k2JQBBI9qCf1RKRn+QeEiILPksAoKBCfahCWJ+uc+ItmPxzSjznbdiN3jNvuenAcI5/MIL+fI/d6ck+Oe78/n/fte98f41KxVCwV29hwSS7JJTmdqMAERVIkRVIU3iW6RJd4+DAf5sN8+OhRamMHBYff4Xf4ZbmK2shBpxIAMZUAiKkEQAxPbWCv5HKx2MYGkM2+e7ewAOTz375tbQGArus6YLf7fMePA4LQ2dnWBjgcTU2nTlG7Lo8FAzAamkhMTExNAfH44ODoKLCzs7Kyvr73pzgczc1+P9DQMDBw5w5QW3vt2uXLAMdVVVVZ6HdvGSuqmkrJMhCNXrp08yawunr9+v37f994k1xube3TJ2B1NRx+8ACIRi9evHEDUNXt7XSautoS5AGo6s+fmQwgSaFQby+QTk9Pz839e51M5vXr+Xng/fuurt5eQFWTyVSKunrCAHRd0zQNWFnp6bl3D8jlPnz48mX/dRXl48d4HFhe7u6+exfQ9WKxWKTqAmEAicTTp5OTQDo9MyOK7PUzmTdvIhHgx48nT169ouoCYQDx+ODgyAhd4SUfjx5R+mAewM7O8vL6OrshpxyK8vnz5ibw61c0urbGXp95ALJszOOthizPzkoSe13mAeTzX78mEuwLLe/LXNixheAbYCy0rIcxK2MN8wDsdq+3tpZ9oeWw2Wh8MQ9AEDo6zpxhX2h5XxcuBALsdZkH4HQGAs3NQE1NQ4PPx77g3djtJ07U1QGCcO5cSwt7fYJvAMdxHFBf399/+zZ79d2UfBi+WEO2EPN4bt26coVuSHK5gsHTpwGvt6/v6lWqLhAGwHE8f+gQ0NLy8uXwcGko2G/MSUBrq6HLcdXVPOGmPPluqNmQYFAUnz8HBOH8+dbWf6/jdLa1NTUB7e1v3z57BtjtJ096PNTVWyAAEzOI9vbZ2YkJoLFxaOjhQ8Bm83iOHfv759lsdXVuN9DY+PjxwAAQDM7Pv3gB1NTU13u91NWW4NRxdVwdTyaN/wW53dSGdmNuW2ezc3OLi0A2K4qLi0A+v7n5/btxh3EkabzR5pGkIHR1BQLWOwEzKUaKkWJEli14JPknZgOPHAmFzp4tXf8XLPhuHCwqARBTCYCYSgDE8IWxwlhhTNeNWVChQG3ooKAtaUvakqb9BoETVLaXr6PcAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTEwLTI4VDE2OjA0OjAxKzA4OjAwQZiUSwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0xMC0yOFQxNjowNDowMSswODowMDDFLPcAAABMdEVYdHN2ZzpiYXNlLXVyaQBmaWxlOi8vL2hvbWUvYWRtaW4vaWNvbi1mb250L3RtcC9pY29uX3ZkdjgwZ2c4M3AvamFwYW5yaWJlbi5zdme8C6L4AAAAAElFTkSuQmCC",
                },
                {
                    value: "Korean",
                    label: "한국어",
                    imgUrl: require("@/assets/DEMO_files/name-65c1cb50.png"),
                },
                {
                    value: "CN",
                    label: "繁体中文",
                    imgUrl:
                        "data:image/png;base64,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",
                },
                {
                    value: "th",
                    label: "ไทย",
                    imgUrl:
                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAABVCAYAAABq+ldUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQ/SURBVHhe7ZzPa1RnFIZvnP4RzVqTjJuCQtUkKghZly4m4owgZFu68Me2XdV006VIbKK1JiJGi6JkYtTMiLa04KaEugkSA8VSSk3SDKTgj+b0e8+952M0N7p15rwvPGSYZK6L5+HebzYmssnW5hdlrnJCqkm3zCQ9cjdQS4pSJy0BXMEZ3MEhXMLp25Ybw9PRSakWinI7XCjvHyKtB1zCKdxutg0xLAyPyHQoaTbngqS1gVO4heO8vRYDqsEf83HQvsAtHOfdIWIMeJ7gNsI7QvsDx3D95hkixoADBs8IfoBrOG+exqB3hXDryPsQaV/gvPnuoDHgQIGvIHkfIO0LnDcfJjWGhwND+p007wOkfYFzuLdpDLOd/fwG4RA4h3ubxjD1QZfUOohH4N6WxvDhLql39hKHwL1NY5j/4hv546tTxCFwb9MYlht/yUtZIw6Be5vG0FhZEXn1ijhE3WfTGJ41GvI8/CT+gHubxrAS3gidEIfAvS19TCyHN16GF8Qd6j5bGsNSeONFeEHcoe6zaQxLjdXw/jpxCNzbNIbl8NzIuYMQB8C9LX1MrIY61teJQ9R9tiyG5fCL0Alxh7rPpjH8E54b/4XnB/EH3Ns0ht8eP5Mnfz4nDoF7m8bw2ZeX5OjJ68QhcG/TGHpLp2TvoTHiELi3aQy7ShPSW/6BOATubRrD7tK49JWvEofAvU1j6C+Nyf5DE8QhcG/LYhiV/eVx4hC4t6UHyMFwmKhMEIfAvY0xOIcxkAhjIBHGQCKMgUQYA4kwBhJhDCTCGEiEMZAIYyARxkAijIFEGAOJMAYSYQwkwhhIhDGQyIYY9pTOSn/5InEI3Ns0ht2l76WvPEkcAve29DFRGpW95XHiELi3aQx9g6dlX+UccQjc27ID5OlwmDhHHAL3tvTMMHhW+ioXiUPg3qYxfHzwvOw5fJk4BO5t6Znh4Ley7/AF4hC4t2kM5c+/kyPHLxGHwL1NY6j9vCi/zP1NHAL3No2hsdoQWQ8viDvUfbY0hqb/GJLztWb3jMH5GAMXxxi4OMbAxTEGLo4xcHGMgYtjDFwcY+DiNsSwdG1GXtx6QBwC9zaNobrjE6nv/JQ4BO5tGkOt84DUk4/kHnEFnMO9TWP4dWBI7idF+SnZThwB53Bv0xgefz0iNwvdcqvQQxwB53Bv0xjW5p/IVMdWqXV0EUfAOdzbNAbsUeVYeIZskx+TLuIAuIbz5sUY/g2F3Am3jftJd/hj0s7AMVzDefNiDNjvY5NyY0u3zGwpym3SlsAtHMP1m3stBmxh+IxMJz0yG06bddJWwCncwnHeNsSAPR29ItOF7XInfPW4Fy5AWh+4hFO43Wy5MWBr84syVzkh1fB8mQk13Q3UwgXrpCWAKziDOziESzh92zaNwYYLLAyPyMOBIZnt7JdqoShT4eLk/QWO4ArO4O5dEdjeGQPnZSL/A4JuWUuLbtuBAAAAAElFTkSuQmCC",
                },
                {
                    value: "vi",
                    label: "Tiếng Việt",
                    imgUrl: require("@/assets/DEMO_files/vn1ebb558a.png"),
                },
                {
                    value: "fr",
                    label: "français",
                    imgUrl:
                        "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCADIASwDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAcIAgb/xAAfEAEAAQIHAQAAAAAAAAAAAAAAAgFxAwUIMTIzg8L/xAAZAQEAAwEBAAAAAAAAAAAAAAAABAYHBQP/xAAhEQEAAAILAAAAAAAAAAAAAAAAAYECAwQFBjM0QUOxwf/aAAwDAQACEQMRAD8AkoC8OOAAAAAAAAAAtmn7fP8Aw+1tRLT9vn/h9raqt5amlLqDpVGXAAQXsAAAAAAAA5xOuVqs0z5yvVpbE65WqzTPnK9US1bLXhjll65ARFrAAAAAAAAAAeAAacxEAAAAAAAAABbNP2+f+H2tqJaft8/8PtbVVvLU0pdQdKoy4ACC9gAAAAAAAHOJ1ytVmmfOV6tLYnXK1WaZ85XqiWrZa8McsvXICItYAAAAAAAAADwADTmIgAAAAAAAAALZp+3z/wAPtbUS0/b5/wCH2tqq3lqaUuoOlUZcABBewAAAAAAADnE65WqzTPnK9WlsTrlarNM+cr1RLVsteGOWXrkBEWsAAAAAAAAAB4ABpzEQAAAAAAAAAFs0/b5/4fa2olp+3z/w+1tVW8tTSl1B0qjLgAIL2AAAAAAAAc4nXK1WaZ85Xq0tidcrVZpnzleqJatlrwxyy9cgIi1gAAAAAAAAAPAANOYiAAAAAAAAAAtmn7fP/D7W1EtP2+f+H2tqq3lqaUuoOlUZcABBewAAAAAAADnE65WqzTPnK9WlsTrlarNM+cr1RLVsteGOWXrkBEWsAAAAAAAAAB4ABpzEQAAAAAAAAAFs0/b5/wCH2tqJaft8/wDD7W1Vby1NKXUHSqMuAAgvYAAAAAAABzidcrVZpnzlerS2J1ytVmmfOV6olq2WvDHLL1yAiLWAAAAAAAAAA8AA05iIAAAAAAAAAC2aft8/8PtbUS0/b5/4fa2qreWppS6g6VRlwAEF7AAAAAAAAOcTrlarNM+cr1aWxOuVqs0z5yvVEtWy14Y5ZeuQERawAAAAAAAAAHgAGnMRAAAAAAAAAAWzT9vn/h9raiWn7fP/AA+1tVW8tTSl1B0qjLgAIL2AAAAAAAAc4nXK1WaZ85Xq0tidcrVZpnzleqJatlrwxyy9cgIi1gAAAAAAAAAPAANOYiAAAAAAAAAAtmn7fP8Aw+1tRLT9vn/h9raqt5amlLqDpVGXAAQXsAAAAAAAA5xOuVqs0z5yvVpbE65WqzTPnK9US1bLXhjll65ARFrAAAAAAAAAAeAAacxEAAAAAAAAABbNP2+f+H2tqJaft8/8PtbVVvLU0pdQdKoy4ACC9gAAAAAAAHOJ1ytVmmfOV6tLYnXK1WaZ85XqiWrZa8McsvXICItYAAAAAAAAADwADTmIgAAAAAAAAALZp+3z/wAPtbUS0/b5/wCH2tqq3lqaUuoOlUZcABBewAAAAAAADnE65WqzTPnK9WlsTrlarNM+cr1RLVsteGOWXrkBEWsAAAAAAAAAB4ABpzEQAAAAAAAAAFs0/b5/4fa2olp+3z/w+1tVW8tTSl1B0qjLgAIL2AAAAAAAAc4nXK1WaZ85Xq0tidcrVZpnzleqJatlrwxyy9cgIi1gAAAAAAAAAPAANOYiAAAAAAAAAAtmn7fP/D7W0FVvLU0pdQdKoy4ACC9gAAAAAAAHOJ1ytVmmfOV6giWrZa8McsvXICItYAAAAAAAAAD/2Q==",
                },
                {
                    value: "de",
                    label: "Deutsche",
                    imgUrl:
                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAQCAYAAADj5tSrAAAAdElEQVQ4T2NUFhe59p+BQZOBRoCR4X8r46glxIYu/YKrW0vjGLKrGBkZ/hPrSmLUffn37xXjfUvzq/8ZGbSI0UCeGsa2UUtICDnGNsZHAQanSNCBVSkjA+7EwiT4+ynj71sMVxkYaBjxjAxto5YQH430Ci4ARzk+3uhNm+sAAAAASUVORK5CYII=",
                },
                {
                    value: "ru",
                    label: "Русский язык",
                    imgUrl: require("@/assets/DEMO_files/name-9776c19e.png"),
                },
                {
                    value: "esp",
                    label: "Español",
                    imgUrl: require("@/assets/DEMO_files/name-c9ebf635.png"),
                },
                {
                    value: "po",
                    label: "Português",
                    imgUrl: require("@/assets/DEMO_files/name-2d69992c.png"),
                },
                {
                    value: "Italy",
                    label: "Italiano",
                    imgUrl:
                        "data:image/png;base64,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",
                },
                {
                    value: "alb",
                    label: "عربي",
                    imgUrl: require("@/assets/DEMO_files/name-7c042e25.png"),
                },
                {
                    value: "tu",
                    label: "Türkçe",
                    imgUrl:require("@/assets/DEMO_files/name-a980693d.png"),
                },
                {
                    value: "yd",
                    label: "Indonesia",
                    imgUrl: require("@/assets/DEMO_files/name-4917741a.png"),
                },
                // {
                //     value: "md",
                //     label: "မြန်မာ",
                //     imgUrl: require("@/assets/DEMO_files/name-4290a0a4.png"),
                // },
                // {
                //     value: "lm",
                //     label: "हिन्दी或हिंदी",
                //     imgUrl: require("@/assets/DEMO_files/name-58747bf8.png"),
                // },
                // {
                //     value: "jk",
                //     label: "čeština",
                //     imgUrl: require("@/assets/DEMO_files/name-aa39a20b.png"),
                // },
            ],
            conturyValue: "en",
            language: "",
            options: [
                {
                    value: "选项1",
                    label: "Forex",
                },
                {
                    value: "选项2",
                    label: "Crypto",
                },
                {
                    value: "选项3",
                    label: "Oil",
                },
            ],
            value: "",
            page: {
                pageNum: 1,
                pageSize: 15
            },
            loopPage: 0,
            search_string: "",
            active: 0,
            dialogShow: false,
            loginStaus: false,
            local: null,
            user: {},
            forgot: {
                userName: null,
                password: null,
                confirmPassword: null,
                validCode: null,
            },
            order: {
                times: "1",
                market_price: "1",
                trade_amount: 0.1,
                target_price: ""
            },
            activeIndex: 1,
            search: {
                type: "",
            },
            financial: {},
            trade_list: [],
            trade_list1: [],
            status: 1,
            all_fact_profits: "",
            balance: "",
            pro_id: "",
            user_balance: "",
            smsImg: "",
            key: "",
            userInfo: "",
            billData: {},
            billList: {},
            NetworkList: [],
            depositList: [],
            bankcardList: [],
            financial: {
                proofImg: "",
            },
            identity: {
                front_pic: "",
                reverse_pic: "",
            },
            centerData: {
                review_status: 0,
            },
            currencyList: [],
            withdrawalRecord: [],
            withdrawalbankRecord: [],
            currency: {},
            walletListTop: [],
            walletListBottom: [],
            digital: {},
            digitalList: [],
            cur_id: "",
            Wthdrawal: {
                number: 0,

                draw_rate: 0,
            },
            bankWthdrawal: {
                draw_currency: {
                    draw_rate: 0,
                },

            },
            bankWthdrawal1: {},
            currencyRight: {},
            wireList: [],
            ewmImg: "",
            marketList: [],
            marketListAll: [],
            market: {
                item: {},
                leverList: [],
            },
            stop: {
                target_profit_price: 0,
                stop_loss_price: 0,
            },
            CautionMoneyAll: "",
            ProfitsTotal: "",
            HazardRate: "",
            ticker: "BTCUSD",
            marketStr: "ticker",
            resert: {},
            headers: { Authorization: `Bearer ${window.localStorage.getItem("token")}` },
            upload_url: 'https://api.sccesiy.cyou/file/uploadFile',
            orderListTimer: null,
            logo: '',
            flag: false,
            time: 60,
            code_timer: null,
            email: '',
            marketTermList: [],
            selectedMarketIndex: 0,
            loanTermList: [],
            myLoanList: [],
            loadingLoan: false,
            noMore: false,
            loanTerm: {
                id: null,
                loanTermDays: null,
                dailyInterestRate: null,
                interestFreeDays: null,
                loanTermType: null,
            },
            loanTermUser: {
                loanTermId: null,
                loanTermDays: null,
                dailyInterestRate: null,
                interestFreeDays: null,
                loanTermType: null,
                totalInterest: 0,
                amount:0,
                status: "0",
                language: this.language,
            },
            financialProducts:[],// 贷款产品
            isDrawing: false,
            lastX: 0,
            lastY: 0,
            isSigned: false,
            startLoanShow: true,
            loanNowShow:true,
            loanSgreementShow:false,
            loanSignShow:false,
            goMyLoanBtnShow :true,
            goBakBtnShow :false,
            myLoanShow:false, //我的借款
            selectedProducts:{

            },
            userProducts:{

            },
            expectedProfit:0,
            showfinancialProducts:false,
            showUserProducts:false,
            showMyProducts:false,
            purchaseList:[],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            loanPagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            activeTab: 'contract', // 当前激活的标签，contract或term
            activeTabList: 'contract', // 当前激活的标签，contract或term
            selectedMarketTerm:{},
            userTerm:{
                itemId:null,
                itemName: null,
                itemTermId:null,
                expirationDate: null,
                minTransactionQuantity: 0,
                estimatedRevenueRate : 0,
                transactionQuantity: 0,
                status: 0,
                buyType: 0,
            },
            userTermList: [], // 我的期限列表
            userTermPagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            userTermLoading: false, // 加载状态
            activeTermItem: 'in_transaction', // 当前激活的标签，in_transaction或closed_position
            userTermNoMore: false,
        };
    },

    watch: {
        financial: {
            handler() {
                QRCode.toDataURL(this.financial.address)
                    .then((url) => {
                        console.log(url);
                        this.ewmImg = url;
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            deep: true
        },

        active() {
            if (this.active == 13) {
                this.getSms();
                this.user.invite_code = window.location.href.split('invite_code=')[1] || ''
            }
            if (this.active == 1) {
                this.getBillInfo();
            }
            if (this.active == 2) {
                this.getDeposit();
                this.getbank();
                this.getquick_ist(0, 0);
            }
            if (this.active == 3) {
                this.getquick_ist(1, 0);
            }
            if (this.active == 7) {
                this.getCenter();
            }
            if (this.active == 21) {
                this.getCurrency();
            }
            if (this.active == 6) {
                this.getWallet();
            }
            if (this.active == 22) {
                this.getDigital();
            }
            if (this.active == 4) {
                // this.getDigital();
                this.getGoldOutAll()
                // this.getCurrency();
                // this.getWallet();

                // this.getWithdrawalRecord();
                this.getquick_ist(0, 1)
            }
            if (this.active == 5) {
                // this.getCurrency();
                this.getGoldOutBankInfo()
                this.getquick_ist(1, 1);
                // this.getWithdrawalbankRecord();
            }
            if (this.active == 100) {
                this.getOnline()
            }
            if (this.active == 10) {
                this.getEmail()
            }
            if (this.active == 8) {
                this.inviteAddress = `${window.location.host}/#/?invite_code=${this.userInfo.user.inviteCode}`
                QRCode.toDataURL(this.inviteAddress)
                    .then((url) => {
                        console.log(url);
                        this.inviteImg = url;
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }
            if(this.active == 18){
                this.mining()
            }
        },
    },
    mounted() {
        this.language = this.conturyValue = window.localStorage.getItem("language")
            ? window.localStorage.getItem("language")
            : "en";
        // this.DAY_MARKETWebSocket();
        // this.loginWebSocket();
        this.getMarket(true);
        this.getCategories();
        // this.initChart();

        setTimeout(() => {
            $(".klinecharts-pro-drawing-bar").after($(".leftbox"));
            $(".klinecharts-pro-widget").after($(".rightbox"));
            $(".klinecharts-pro-period-bar").append($(".rightfixed"));
            $(".symbol").after($(".order"));
            $(".symbol").after($(".list"));
            $(".list").click(() => {
                $(".leftbox").fadeToggle();
                $(".list").toggleClass("selected");
            });

            $(".order").click(() => {
                $(".rightbox").fadeToggle();
                $(".order").toggleClass("selected");
            });
        }, 0);
        this.local = obj[this.language];
        console.log("local", this.local);
        if (window.localStorage.getItem("token")) {
            this.loginStaus = true;
        } else {
            this.loginStaus = false;
        }
        if (window.localStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
        }
        if (this.loginStaus) {
            this.getBalance();
            this.gettrade_list(1);
        }
        this.$nextTick(() => {
            const el = document.getElementsByClassName('infinite-list')[0]
            el.addEventListener('scroll', this.scroll, true)
        })
        this.getLogo()
    },
    methods: {

        handleUserTermPageChange(page){
            this.userTermPagination.currentPage = page;
            this.fetchUserTermData();
        }, //分页
        async fetchUserTermData(){
            if (this.userTermLoading || this.userTermNoMore) return;
            this.userTermLoading = true;
            try {
                const params = {
                    currentPage: this.userTermPagination.currentPage,
                    pageSize: this.userTermPagination.pageSize,
                    status: this.activeTermItem==='in_transaction'?0:1
                };
                const response = await axios.post('/userTerm/getPage', params);
                
                const newLoans = response.data.data.list;
                
                if (newLoans.length === 0) {
                    this.userTermNoMore = true;
                    return;
                }
                
                if (this.userTermPagination.currentPage === 1) {
                    this.userTermList = newLoans;
                } else {
                    this.userTermList = [...this.userTermList, ...newLoans];
                }
                
                // 如果返回的数据少于请求的pageSize，说明没有更多数据了
                if (newLoans.length < this.userTermPagination.pageSize) {
                    this.userTermNoMore = true;
                } else {
                    this.userTermPagination.currentPage++;
                }
            } catch (error) {
                console.error('获取理财记录失败:', error);
            } finally {
                this.loadingLoan = false;
            }
        },
        async userTermAdd(buyType) {
            this.userTerm.buyType = buyType;
            this.pushUserTerm(); //添加用户交易条件
            if (this.userTerm.transactionQuantity === null || this.userTerm.transactionQuantity === 0) {
                return showFailToast("下单数量必須大於零")
            }
            if (this.userTerm.transactionQuantity < this.selectedMarketTerm.minTransactionQuantity) {
                return showFailToast("小於最低下單金額")
            }
            console.log(this.userTerm, 'this.userTerm');
            this.loading=true;
            axios({
                method: "post",
                url: `/userProducts/add`,
                data: this.userProducts
            }).then((res) => {
                console.log(res);
                if (res.data.code === 200) {
                    this.$notify({
                        title: res.data.msg,
                        type: "success",
                    });
                    this.userTerm = {
                        itemId: '',
                        itemName: '',
                        itemTermId: '',
                        expirationDate: '',
                    }
                    this.getMarket(true);
                    this.getCategories();
                }
            });
        },
        pushUserTerm(){
            console.log(this.selectedMarketTerm, 'this.selectedMarketTerm');
            this.userTerm.itemId = this.selectedMarketTerm.itemId
            this.userTerm.itemName = this.selectedMarketTerm.itemName
            this.userTerm.itemTermId = this.selectedMarketTerm.id
            this.userTerm.expirationDate = this.selectedMarketTerm.expirationDate
            this.userTerm.minTransactionQuantity = this.selectedMarketTerm.minTransactionQuantity
            this.userTerm.estimatedRevenueRate = this.selectedMarketTerm.estimatedRevenueRate
        }, // 添加用户交易
        calcIncome(){
            if(this.userTerm.transactionQuantity != null){
                this.userTerm.expectedRevenue = this.userTerm.transactionQuantity * this.selectedMarketTerm.estimatedRevenueRate / 100
            }
        }, // 计算收益
        selectedPush(marketTerm){
            this.selectedMarketTerm = marketTerm
            this.calcIncome()
        },
        // 切换合约/期限标签
        switchTab(tab) {
            this.activeTab = tab;
        },
        // 切换合约/期限标签
        switchTabList(tab) {
            this.activeTabList = tab;
            // 切换标签时重新获取数据
            if(tab === 'future'){
                this.fetchUserTermData(); 
            }
            if(tab === 'contract'){
                this.gettrade_list();
            }
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.goToPurchaseList();
        },
        
        // 当前页改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.goToPurchaseList();
        },
        // 获取我的申购列表数据
        goToPurchaseList(){
            this.showfinancialProducts = false;
            this.showUserProducts = false;
            this.showMyProducts = true;
            const params = {
                currentPage: this.pagination.currentPage,
                pageSize: this.pagination.pageSize
            };
            axios({
                method: "post",
                url: `userProducts/getMyUserProductsPage`, // 获取用户购买列表
                data:params,
            }).then((res) => {
                console.log(res);
                if (res.data.code === 200) {
                    this.purchaseList = res.data.data.list;
                    this.pagination.total = res.data.data.pagination.total;
                }
            });
        },
        handleApplySubmit(){
            axios({
                method: "post",
                url: `/userProducts/add`,
                data: this.userProducts
            }).then((res) => {
                console.log(res);
                if (res.data.code === 200) {
                    this.$notify({
                        title: res.data.msg,
                        type: "success",
                    });
                    this.mining();
                    this.showfinancialProducts = true;
                    this.showUserProducts = false;
                    this.showMyProducts = false;
                }
            });
        },
        handleSubscribe(product){
            this.active = 18;
            console.log("product",product);
            
            this.selectedProducts = product;
            this.userProducts = product;
            this.expectedProfit = this.selectedProducts.expectedNissan/100;
            this.userProducts.id = null; // 清空id
            this.showfinancialProducts = false;
            this.showUserProducts = true;
            this.showMyProducts = false;
        },
        loan() {
            if(!this.loginStaus){
                this.active = 12;
            }else{
                axios({
                    method: "get",
                    url: `/loanTerm/getList`,
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.loanTermList = res.data.data;
                    }
                });
                this.active = 17;
            }
        },
        mining() {
            if(!this.loginStaus){
                this.active = 12;
            }else{
                axios({
                    method: "get",
                    url: `/financialProducts/getList`,
                }).then((res) => {
                    if (res.data.code == 200) {
                        console.log(res,111111);
                        
                        this.financialProducts = res.data.data;
                    }
                });
                this.active = 18;
                this.showfinancialProducts=true;
                this.showUserProducts=false;
                this.showMyProducts = false;
            }
        },
        closeMiningDialog(){
            this.active = -1;
            this.dialogShow = false;
            this.loanReset();
        },
        closeLoanDialog(){
            this.active = -1;
            this.dialogShow = false;
            this.loanReset();
        },
        loanReset(){
            this.isDrawing=false;
            this.lastX=0;
            this.lastY=0;
            this.isSigned=false;
            this.startLoanShow=true;
            this.loanNowShow=true;
            this.loanSgreementShow=false;
            this.loanSignShow=false;
            this.goMyLoanBtnShow=true;
            this.goBakBtnShow=false;
            this.myLoanShow=false;
        },
        loanTermChange(item) {
            this.loanTerm = item;
            if(this.loanTermUser.amount == null || this.loanTermUser.amount == 0){
                this.loanTermUser.totalInterest = 0;
                this.totalInterest();
            }else{
                this.totalInterest();
            }
            

        },
        loanMaxAmount(){
            this.loanTermUser.amount = 100000;
            this.totalInterest();
        },
        totalInterest(){
            let loanTermDays = this.loanTerm.loanTermDays-this.loanTerm.interestFreeDays;
            this.loanTermUser.totalInterest = (this.loanTermUser.amount * this.loanTerm.dailyInterestRate)/100 * loanTermDays;
        },
        loanNow(){
            if(this.loanTermUser.amount == null || this.loanTermUser.amount == 0){
                this.$notify({
                        title: `${this.local.loan.input_amount}`,
                        type: "success",
                    });
                return;
            }
            if(this.loanTermUser.totalInterest == null || this.loanTermUser.totalInterest == 0){
                this.$notify({
                        title: "请选择贷款期限",
                        type: "success",
                    });
                return;
            }
            this.startLoanShow = false;
            this.loanNowShow = false;
            this.goBakBtnShow = true;
            this.goMyLoanBtnShow = false;
            this.loanSgreementShow = true; 
            this.myLoanShow=false;
        },
        goBakBtn(){
            this.startLoanShow=true;
            this.loanNowShow=true;
            this.loanSgreementShow=false;
            this.loanSignShow=false;
            this.goMyLoanBtnShow=true;
            this.goBakBtnShow=false;
            this.myLoanShow=false;
        },
        goMyLoanShow(){
            this.startLoanShow=false;
            this.loanNowShow=false;
            this.goBakBtnShow=true;
            this.goMyLoanBtnShow=false;
            this.myLoanShow=true;
            this.fetchLoans();
        },
        async fetchLoans() {
            if (this.loadingLoan || this.noMore) return;
            
            this.loadingLoan = true;
            try {
                const params = {
                    currentPage: this.loanPagination.currentPage,
                    pageSize: this.loanPagination.pageSize
                };
                const response = await axios.post('/userLoan/getMyLoanList', params);
                
                const newLoans = response.data.data.list;
                
                if (newLoans.length === 0) {
                    this.noMore = true;
                    return;
                }
                
                if (this.loanPagination.currentPage === 1) {
                    this.myLoanList = newLoans;
                } else {
                    this.myLoanList = [...this.myLoanList, ...newLoans];
                }
                
                // 如果返回的数据少于请求的pageSize，说明没有更多数据了
                if (newLoans.length < this.loanPagination.pageSize) {
                    this.noMore = true;
                } else {
                    this.loanPagination.currentPage++;
                }
            } catch (error) {
                console.error('获取贷款记录失败:', error);
            } finally {
                this.loadingLoan = false;
            }
        },
        loadMore() {
            this.fetchLoans();
        },
        toRepayment(item){
            let amount = item.repaymenAmount + item.remainingRepayment;
            if(amount>this.user_balance){
                this.$notify({
                        title: "可用资金不足，请充值再还款",
                        type: "success",
                    });
                return;
            }
            this.$confirm(
                `${this.local.loan.confirm_repay_tip}`,
                `${this.local.public.tip}`,
                {
                    confirmButtonText: `${this.local.public.confirm}`,
                    cancelButtonText: `${this.local.public.cancel}`,
                    type: "warning",
                }
            ).then(() => {
                axios({
                    url: "/userLoanRepayment/resetSimulationUser",
                    method: "POST",
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.$notify({
                            title: `${this.local.user.reset_success}`,
                            type: "success",
                        });
                        this.active = -1;
                        this.activeIndex = 1;
                        window.localStorage.setItem("is_mock", true);
                        this.is_mock = true
                        this.getBalance();
                        this.loginStaus = true;
                        this.gettrade_list(1);
                    }
                });
            }).catch(e => {

            })
        },
        getStatusText(status) {
            const statusMap = {
                '0': '待稽核',
                '2': '已批准',
                '1': '已駁回',
                '3': '已還款',
                '4': '已逾期'
            };
            return statusMap[status] || status;
        },
        // 重置分页并重新加载数据
        refreshLoans() {
            this.page = 1;
            this.noMore = false;
            this.loans = [];
            this.fetchLoans();
        },
        goLoanSign(){
            this.startLoanShow=false;
            this.loanNowShow=false;
            this.loanSgreementShow=false;
            this.loanSignShow=true;
            this.goMyLoanBtnShow=false;
            this.goBakBtnShow=true;
            this.initLoanCanvas();
        },
        initLoanCanvas(){
            const canvas = this.$refs.loanCanvas;
            // 设置 canvas 尺寸（避免模糊）
            canvas.width = canvas.offsetWidth * 2;
            canvas.height = canvas.offsetHeight * 2;
            canvas.style.width = '100%';
            canvas.style.height = '100%';
            this.ctx = canvas.getContext('2d');
            this.ctx.scale(2, 2); // 适配高清屏
            this.ctx.lineWidth = 2;
            this.ctx.lineCap = 'round';
            this.ctx.strokeStyle = '#000'; // 设置画笔颜色
        },
        startDrawing(e) {
            this.isDrawing = true;
            const pos = this.getPosition(e);
            [this.lastX, this.lastY] = [pos.x, pos.y];
        },
        draw(e) {
            if (!this.isDrawing) return;
            e.preventDefault();
            
            const pos = this.getPosition(e);
            this.ctx.beginPath();
            this.ctx.moveTo(this.lastX, this.lastY);
            this.ctx.lineTo(pos.x, pos.y);
            this.ctx.stroke();
            [this.lastX, this.lastY] = [pos.x, pos.y];
        },
        endDrawing() {
            this.isDrawing = false;
        },
        getPosition(e) {
            const canvas = this.$refs.loanCanvas;
            const rect = canvas.getBoundingClientRect();
            
            // 处理鼠标和触摸事件
            const clientX = e.clientX || e.touches[0].clientX;
            const clientY = e.clientY || e.touches[0].clientY;
            
            return {
                x: (clientX - rect.left) * (canvas.width / rect.width / 2),
                y: (clientY - rect.top) * (canvas.height / rect.height / 2)
            };
        },
        clearCanvas() {
            const canvas = this.$refs.loanCanvas;
            this.ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.signatureImage = null;
        },
        saveSignature() {
            const canvas = this.$refs.loanCanvas;
            this.signatureImage = canvas.toDataURL('image/png');
            // 可以在这里提交到服务器或进一步处理
            console.log('签名已保存:', this.signatureImage);
        },
        checkIfSigned() {
            const canvas = this.$refs.loanCanvas;
            const ctx = canvas.getContext("2d");
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            
            for (let i = 0; i < data.length; i += 4) {
                if (data[i] < 240 || data[i + 1] < 240 || data[i + 2] < 240) {
                this.isSigned = true;
                return;
                }
            }
            this.isSigned = false;
        },
        clearCanvas() {
            const canvas = this.$refs.loanCanvas;
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.isSigned = false;
        },
        loanOrderSave(){
            if(!this.loginStaus){
               this.active = 12;
               return;
            }
            // this.checkIfSigned();
            this.isSigned = true;
            this.loanTermUser.loanTermId = this.loanTerm.id;
            this.loanTermUser.dailyInterestRate =this.loanTerm.dailyInterestRate;
            this.loanTermUser.loanTermDays = this.loanTerm.loanTermDays;
            this.loanTermUser.interestFreeDays = this.loanTerm.interestFreeDays;
            this.loanTermUser.loanTermType = this.loanTerm.loanTermType;
            this.loanTermUser.language = this.language;
            // this.clearCanvas();
            axios({
                method: "post",
                url: `/userLoan/add`,
                data: this.loanTermUser
            }).then((res) => {
                console.log(res);
                if (res.data.code == 200) {
                    this.$notify({
                        title: res.data.msg,
                        type: "success",
                    });
                    this.loanReset();
                    this.loan();
                }
            });
        },
        follow() {
            if(!this.loginStaus){
                this.active = 12;
            }else{
                this.active = 19;
            }
        },
        toggleTheme(val) {
            const html = document.documentElement;
            if (val) {
                html.classList.add("dark"); // 添加 class
            } else {
                html.classList.remove("dark"); // 移除 class
            }
        },
        getLogo() {
            axios({
                url: "logo/getLogo",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.logo = res.data.data.logo
                    var link = document.querySelector('link[rel*="icon"]')
                    link.href = this.logo
                }
            });
        },
        scroll() {
            const element = document.getElementsByClassName("infinite-list")[0];
            const top = element.scrollTop;
            this.scrollTop = top
            const li = document.getElementsByClassName("symbol-item")[0];
            const height = li.getBoundingClientRect().height;
            const contain_height = document.getElementsByClassName("symbol-contain")[0].offsetHeight
            // console.log('--contain_height--', contain_height, '--top--', top, '--height--', height)
            this.loopPage = Math.ceil((top / height * -1) / this.page.pageSize) + 1
            console.log("滚动到第几页", this.loopPage)
            if (contain_height - top < 750) {
                this.throttleList()
            }
        },
        throttleList: throttle(function () {
            this.page.pageNum++
            this.getMarket(false)
        }, 500),
        getCautionMoneyAll(list) {
            let num = 0;
            list.forEach(item => {
                num = num + item.profit * 1
            })
            return num.toFixed(5)
        },
        initChart(init = false) {
            let logo = $(".customerlogo");
            let leftbox = $(".leftbox");
            let rightbox = $(".rightbox");
            let rightfixed = $(".rightfixed");
            let order = $(".order");
            let list = $(".list");
            $("#container").html(``);
            setTimeout(() => {
                $(".klinecharts-pro-drawing-bar").after(leftbox);
                $(".klinecharts-pro-widget").after(rightbox);
                $(".klinecharts-pro-period-bar").append(rightfixed);

                $(".symbol").after(order);
                $(".symbol").after(list);
                $(".symbol").after(logo);
                $(".list").click(() => {
                });

                $(".order").click(() => {
                });
                // setTimeout(()=>{
                $(".infinite-list").scrollTop(this.scrollTop)
                // },500)

                this.loading = false;
            }, 0);



            var locale = this.conturyValue == "hk" ? "zh-CN" : "en-US";
            this.chart = new KLineChartPro({
                container: document.getElementById("container"),
                locale,
                symbol: {
                    market: this.market
                },
                period: { multiplier: "1", timespan: "minute", text: "1m", dw: "1M" },
                subIndicators: [],
                tools: [],
                datafeed: new DefaultDatafeed("MYu8b_xIspp_dkgF7OtjlDY_qdaCrRNg"),
            });
            this.getMarketTermList(); //获取市场列表
        },
        loginWebSocket() {
            // if (window.localStorage.getItem("token")) {
            //   var ws1 = new WebSocket("wss://api.texttrademo.com/v1/ws");
            //   ws1.onopen = function () {
            //     ws1.send(
            //       JSON.stringify({
            //         params: window.localStorage.getItem("token"),
            //         type: "login",
            //       })
            //     );
            //     ws1.send(JSON.stringify({ params: "FOREX_TRADE", type: "sub" }));
            //   };
            //   ws1.onmessage = (evt) => {
            //     var blob = evt.data;
            //     var reader = new FileReader();
            //     reader.readAsText(blob, "utf-8");
            //     reader.onload = (e) => {
            //       //   console.log("login", reader.result);
            //       let arr = JSON.parse(reader.result).TransOrder || [];
            //       arr.forEach((item) => {
            //         this.trade_list.forEach((item1) => {
            //           if (item.Id == item1.Id) {
            //             item1.UpdatePrice = item.UpdatePrice;
            //             item1.profit = item.profit;
            //           }
            //         });
            //       });
            //       this.CautionMoneyAll = JSON.parse(reader.result).CautionMoneyAll;
            //       this.ProfitsTotal = JSON.parse(reader.result).ProfitsTotal;
            //       this.HazardRate = JSON.parse(reader.result).HazardRate;
            //     };
            //   };
            // }
        },
        DAY_MARKETWebSocket() {
            //    alert("您的浏览器支持 WebSocket!");
            // 打开一个 web socket
            //
            //
            //   ws.send("ping");
            //   alert("数据发送中...");
            // var ws6 = new WebSocket("wss://socket.polygon.io/crypto");
            // ws6.onopen = function () {
            //   ws6.send(JSON.stringify({"action":"auth","params":"MYu8b_xIspp_dkgF7OtjlDY_qdaCrRNg"}));
            //   ws6.send(JSON.stringify({"action":"subscribe","params":"XAS.X:BTC-USD,XAS.X:ETH-USD"}));
            //   // ws6.send(JSON.stringify({"action":"subscribe","params":"XT.X:ETH-USD"}));
            //   // ws6.send(JSON.stringify({"action":"subscribe","params":"C.C:EUR-USD,C.C:CZKMXN,C.C:UAHDKK,C.C:JPY-USD"}));
            // };
            // ws6.onmessage = (evt) => {
            //   console.log(evt)
            //   // var blob = evt.data;
            //   // var reader = new FileReader();
            //   // reader.readAsText(blob, "utf-8");
            //   // reader.onload = (e) => {
            //   //   console.log("FOREX_CLOSED", reader.result);
            //   // };
            // };
            // var ws = new WebSocket("wss://api.texttrademo.com/v1/ws");
            // ws.onopen = function () {
            //   ws.send(JSON.stringify({ params: "DAY_MARKET", type: "sub" }));
            // };
            // ws.onmessage = (evt) => {
            //   var blob = evt.data;
            //   var reader = new FileReader();
            //   reader.readAsText(blob, "utf-8");
            //   reader.onload = (e) => {
            //     this.marketList.forEach((item) => {
            //       if(JSON.parse(reader.result).quotation){
            //         if (item.Id == JSON.parse(reader.result).quotation.forex_id) {
            //         //   alert(1)
            //         item.ForexQuotations.Close = JSON.parse(
            //           reader.result
            //         ).quotation.close;
            //         item.ForexQuotations.Change = JSON.parse(
            //           reader.result
            //         ).quotation.change;
            //       }
            //       }
            //     });
            //     //   this.trade_list = JSON.parse(reader.result).TransOrder
            //   };
            // };
            //   var ws2 = new WebSocket("wss://api.texttrademo.com/v1/ws");
            //   ws2.onopen = function () {
            //     ws2.send(JSON.stringify({ params: "FOREX_TRADE", type: "sub" }));
            //   };
            //   ws2.onmessage = (evt) => {
            //     var blob = evt.data;
            //     var reader = new FileReader();
            //     reader.readAsText(blob, "utf-8");
            //     reader.onload = (e) => {
            //       console.log("FOREX_TRADE", reader.result);
            //     };
            //   };
            // var ws3 = new WebSocket("wss://api.texttrademo.com/v1/ws");
            // ws3.onopen = function () {
            //   ws3.send(JSON.stringify({ params: "FOREX_CLOSED", type: "sub" }));
            // };
            // ws3.onmessage = (evt) => {
            //   var blob = evt.data;
            //   var reader = new FileReader();
            //   reader.readAsText(blob, "utf-8");
            //   reader.onload = (e) => {
            //     console.log("FOREX_CLOSED", reader.result);
            //   };
            // };
            // var ws4 = new WebSocket("wss://api.texttrademo.com/v1/ws");
            // ws4.onopen = function () {
            //   ws4.send(JSON.stringify({ params: "KLINE.ETHUSDT", type: "sub" }));
            // };
            // ws4.onmessage = (evt) => {
            //   var blob = evt.data;
            //   var reader = new FileReader();
            //   reader.readAsText(blob, "utf-8");
            //   reader.onload = (e) => {
            //     // this.marketList.forEach(item => {
            //     //     if(item.ShowCode == JSON.parse(reader.result).symbol){
            //     //         item.ForexQuotations.Close = JSON.parse(reader.result).Close
            //     //         item.ForexQuotations.Change = JSON.parse(reader.result).Change
            //     //     }
            //     // })
            //     console.log("KLINE.ETHUSDT", reader.result);
            //   };
            // };
            // var ws5 = new WebSocket("wss://api.texttrademo.com/v1/ws");
            // ws5.onopen = function () {
            //   ws5.send("ping");
            // };
            // ws5.onmessage = (evt) => {
            //   var blob = evt.data;
            //   var reader = new FileReader();
            //   reader.readAsText(blob, "utf-8");
            //   reader.onload = (e) => {
            //     console.log("ping", reader.result);
            //   };
            // };
        },

        getWithdrawalRecord() {
            axios({
                url: "/api/goldDeposit/getRecordsList?pageNum=1&pageSize=100&type=0&type1=1",
                method: "GET",
            }).then((res) => {
                this.withdrawalRecord = res.data.rows;
            });
        },
        getCategories() {
            axios({
                url: "/trade/getCategoryList",
                method: "GET",
            }).then((res) => {
                this.CategoriesList = res.data.data;
            });
        },
        getMarket(isInit = false) {
            this.listLoading = true
            try {
                axios({
                    url: "/realtime/getAllTickRealtimePage",
                    method: "post",
                    params: {
                        pageNum: this.page.pageNum,
                        pageSize: this.page.pageSize,
                        type: this.search.type
                    }
                }).then(res => {
                    if (res.data.code == 200) {
                        this.marketList = this.marketList.concat(res.data.rows);
                        this.listLoading = false
                        if (this.marketList.length == res.data.total) {
                            this.finished = true
                        }
                        window.localStorage.setItem("market", JSON.stringify(this.market))
                        if (isInit) {
                            if (this.marketList.length) {
                                this.market = this.marketList[0];
                                this.ticker = this.marketList[0].symbol;
                                this.order.times = this.market?.leverList[0].times
                            }
                            this.initChart(true);
                            this.loading = false;
                            this.getLoop()
                            this.getCurrentSymbol()
                            $('.leftbox').css({ 'display': 'unset' })
                            $('.rightbox').css({ 'display': 'unset' })
                            $('.list').css({ 'display': 'unset' })
                            $('.order').css({ 'display': 'unset' })
                            $('.rightfixed').css({ 'display': 'flex' })
                        }
                    } else {
                        this.listLoading = false
                    }
                })
            } catch (error) {
                throw error
            }
        },
        getCurrentSymbol() {
            this.currentSymbolTimer && clearInterval(this.currentSymbolTimer)
            let { dw } = this.chart.getPeriod()
            let klineType = 1
            switch (dw) {
                case '1M':
                    klineType = 1
                    break;
                case '5M':
                    klineType = 2
                    break;
                case '15M':
                    klineType = 3
                    break;
                case '1H':
                    klineType = 5
                    break;
                case 'D':
                    klineType = 8
                    break;
                case 'W':
                    klineType = 9
                    break;
                case 'M':
                    klineType = 10
                    break;
                default:
                    break;
            }
            axios({
                url: "/realtime/getAllTickRealtimePage",
                method: "post",
                params: {
                    pageNum: 1,
                    pageSize: 15,
                    type: '',
                    symbol: this.market.symbol,
                    klineType
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.market = res.data.rows[0]
                    if (this.market.market == 'NYSE') {
                        let { dw } = this.chart.getPeriod()
                        let interval = 'amin'
                        switch (dw) {
                            case '1M':
                                interval = '1min'
                                break;
                            case '5M':
                                interval = '5min'
                                break;
                            case '15M':
                                interval = '15min'
                                break;
                            case '1H':
                                interval = 'h'
                                break;
                            case 'D':
                                interval = '1day'
                                break;
                            case 'W':
                                interval = '1week'
                                break;
                            case 'M':
                                interval = '1month'
                                break;
                            default:
                                break;
                        }
                        axios({
                            url: `/kline/getQQKline?market=${this.market.market}&interval=${interval}&symbol=${this.market.symbol}`,
                            method: "get",
                        }).then(result => {
                            if (result.data.code == 200) {
                                let kline = result.data.data
                                if (kline.length) {
                                    window.localStorage.setItem("market", JSON.stringify(kline[0]))
                                }
                            }
                        })
                    } else {
                        window.localStorage.setItem("market", JSON.stringify(res.data.rows[0]))
                        this.currentSymbolTimer = setInterval(() => {
                            this.getCurrentSymbol()
                        }, 4000)
                    }
                }
            })

        },
        async getLoop() {
            this.timer && clearInterval(this.timer)
            if (this.loopPage > 0) {
                axios({
                    url: "/realtime/getAllTickRealtimePage",
                    method: "post",
                    params: {
                        pageNum: this.loopPage,
                        pageSize: this.page.pageSize,
                        type: this.search.type
                    }
                }).then(res => {
                    if (res.data.code == 200) {
                        res.data.rows.forEach(item => {
                            let index = this.marketList.findIndex(el => {
                                return el.symbol == item.symbol
                            })
                            if (index != -1) {
                                this.marketList[index] = item
                            }
                        })
                    }
                })
            }


            if (this.page.pageNum >= this.loopPage + 1) {
                axios({
                    url: "/realtime/getAllTickRealtimePage",
                    method: "post",
                    params: {
                        pageNum: this.loopPage + 1,
                        pageSize: this.page.pageSize,
                        type: this.search.type
                    }
                }).then(res => {
                    if (res.data.code == 200) {
                        res.data.rows.forEach(item => {
                            let index = this.marketList.findIndex(el => {
                                return el.symbol == item.symbol
                            })
                            if (index != -1) {
                                this.marketList[index] = item
                            }
                        })
                    }
                })
            }

            this.timer = setInterval(() => {
                this.getLoop()
            }, 4000)
        },
        getWithdrawalbankRecord() {
            axios({
                url: "/api/goldDeposit/getRecordsList?pageNum=1&pageSize=100&type=1&type1=1",
                method: "GET",
            }).then((res) => {
                this.withdrawalbankRecord = res.data.rows;
            });
        },
        getCenter() {
            this.getBalance();

            // centerData: {
            //   review_status: 0,
            // },
            // axios({
            //   url: "/api/user_real/center",
            //   method: "GET",
            // }).then((res) => {
            //   if (res.data.code == 1) {
            //     this.centerData = res.data.data;
            //   }
            // });
        },
        getbank() {
            axios({
                url: "/api/goldDeposit/getBankInfo",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.bankcardList = res.data.data;
                    if (res.data.data.length > 0) {
                        this.currencyRight.id = this.bankcardList[0].id;

                        this.get_wire_info(0);
                    }
                }
            });
        },
        deepClone(obj, hash = new WeakMap()) {
            if (obj === null) return obj;
            if (obj instanceof Date) return new Date(obj);
            if (obj instanceof RegExp) return new RegExp(obj);
            if (typeof obj !== "object") return obj;
            if (hash.get(obj)) return hash.get(obj);
            let cloneObj = new obj.constructor();
            hash.set(obj, cloneObj);
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    cloneObj[key] = this.deepClone(obj[key], hash);
                }
            }
            return cloneObj
        },
        getDeposit() {
            axios({
                url: "api/goldDeposit/getNetwork",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.NetworkList = res.data.data;
                    if (this.NetworkList.length > 0) {
                        this.financial = this.deepClone(res.data.data[0]);
                    }

                }
            });
        },
        getquick_ist(type, type1) {
            axios({
                url: `/api/goldDeposit/getRecordsList?type=${type}&type1=${type1}&pageNum=1&pageSize=100`,
            }).then((res) => {
                if (res.data.code == 200) {
                    this.depositList = res.data.rows || [];
                    this.withdrawalRecord = res.data.rows || [];
                    this.withdrawalbankRecord = res.data.rows || [];
                }
            });
        },
        getBillInfo() {
            axios({
                url: "/system/user/getMoneyLogPage?pageNum=1&pageSize=100",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.billList = res.data.rows;
                }
            });
            return;


            axios({
                url: "/v1/api/main/accountLog/forexChange",
            }).then((res) => {
                if (res.data.code == 1) {
                    this.billList = res.data.data.list;
                }
            });
        },
        submitDeposit() {
            axios({
                url: `/api/goldDeposit/goldCommitAndBank`,
                method: "POST",
                data: {
                    payRemark: this.financial.proofImg,
                    address: this.financial.address,
                    addressId: this.financial.id,

                    num: this.financial.num,
                    currencyName: this.financial.currencyType + "-" + this.financial.protocol,
                    currencyType: this.financial.currencyType,
                    type: 0,
                    currencyId: this.financial.currencyId

                },
            }).then((res) => {
                if (res.data.code == 200) {
                    this.$notify({
                        title: res.data.msg,
                        type: "success",
                    });
                    this.financial = this.deepClone(this.NetworkList[0]);
                    this.getquick_ist(0, 0)
                }
            });
        },
        getSms() {
            axios({
                url: "/v1/api/main/basic/getB64s_code",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 1) {
                    this.smsImg = res.data.data.b64s;
                    this.key = res.data.data.id;
                }
            });
        },
        clickMarket(item) {
            this.order = {
                times: "",
                market_price: "1",
                trade_amount: 0.1,
                target_price: ""
            }
            if (item.leverList.length) {
                this.order.times = item.leverList[0].times
            }
            this.marketStr = "ticker";
            this.market = item;
            this.ticker = item.symbol;
            this.initChart();
            this.getCurrentSymbol();
        },
        //获取订单数据
        gettrade_list(status) {
            this.orderListTimer && clearInterval(this.orderListTimer)
            this.status = status;
            if (this.loginStaus) {
                let type = "";
                if (this.status == 1) {
                    type = "orders";
                    axios({
                        url: `/order/contractOrderList?type=${type}&pageNum=1&pageSize=9999`,
                        method: "GET",
                    }).then((res) => {
                        if (res.data.code == 200) {
                            this.trade_list = res.data.rows || [];
                            this.ProfitsTotal = res.data.data.profitSum;
                            this.CautionMoneyAll = res.data.data.depositSum;
                            this.trade_list1 = res.data.rows || [];
                        }
                    });
                }
                if (this.status == 0) {
                    type = "orders";
                    axios({
                        url: `/order/contractApplyOrderList?type=${type}&pageNum=1&pageSize=9999`,
                        method: "GET",
                    }).then((res) => {
                        if (res.data.code == 200) {
                            this.trade_list = res.data.rows || [];
                            this.ProfitsTotal = res.data.data.profitSum;
                            this.CautionMoneyAll = res.data.data.depositSum;
                        }
                    });
                }
                if (this.status == 3) {
                    type = "hisorders";
                    axios({
                        url: `/order/contractOrderList?type=${type}&pageNum=1&pageSize=9999`,
                        method: "GET",
                    }).then((res) => {
                        if (res.data.code == 200) {
                            this.trade_list = res.data.rows || [];
                            this.ProfitsTotal = res.data.data.profitSum;
                            this.CautionMoneyAll = res.data.data.depositSum;
                        }
                    });
                }
                this.orderListTimer = setInterval(() => {
                    this.gettrade_list(this.activeIndex)
                }, 4000);
            }
        },

        getBalance() {
            axios({
                url: "/getInfo",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    window.localStorage.setItem("userInfo", JSON.stringify(res.data));
                    this.userInfo = res.data;
                    this.centerData.review_status = this.userInfo.user.reviewStatus;
                    this.user_balance = this.userInfo.asset.balance
                } else if (res.data.code == 401) {
                    this.loginStaus = false
                }
            });
        },
        login() {
            axios({
                // url: "/user/login1",
                url: "/user/login",
                method: "POST",
                data: {
                    // "password": this.user.input_password,
                    // "username": this.user.input_email,
                    password: this.user.input_password,
                    username: this.user.input_email,
                    login_type: "email",
                },
            }).then((res) => {
                if (res.data.code == 200) {
                    this.$notify({
                        title: `${this.local.user.welcome_login}`,
                        type: "success",
                    });
                    this.active = -1;
                    this.activeIndex = 1;
                    this.is_mock = false
                    window.localStorage.setItem("token", res.data.token);
                    this.getBalance();
                    this.gettrade_list(1);
                    this.loginStaus = true;
                }
            });
        },
        mockLogin() {
            let uid = window.localStorage.getItem("uid") || ''
            axios({
                url: `/system/user/createSimulationUser?uid=${uid}`,
                method: "POST",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.$notify({
                        title: `${this.local.user.welcome_login}`,
                        type: "success",
                    });
                    this.active = -1;
                    this.activeIndex = 1;
                    window.localStorage.setItem("uid", res.data.uid);
                    window.localStorage.setItem("is_mock", false);
                    this.is_mock = true
                    window.localStorage.setItem("token", res.data.token);
                    this.getBalance();
                    this.loginStaus = true;
                    this.gettrade_list(1);
                }
            });
        },
        resetMock() {
            this.$confirm(
                `${this.local.user.confirm_reset}`,
                `${this.local.public.tip}`,
                {
                    confirmButtonText: `${this.local.public.confirm}`,
                    cancelButtonText: `${this.local.public.cancel}`,
                    type: "warning",
                }
            ).then(() => {
                axios({
                    url: "/system/user/resetSimulationUser",
                    method: "POST",
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.$notify({
                            title: `${this.local.user.reset_success}`,
                            type: "success",
                        });
                        this.active = -1;
                        this.activeIndex = 1;
                        window.localStorage.setItem("is_mock", true);
                        this.is_mock = true
                        this.getBalance();
                        this.loginStaus = true;
                        this.gettrade_list(1);
                    }
                });
            }).catch(e => {

            })
        },

        submitreal_name() {
            axios({
                method: "POST",
                url: "/system/user/submitUserAuth",
                data: {
                    cardNo: this.identity.card_id,
                    frontImg: this.identity.front_pic,
                    realName: this.identity.name,
                    backImg: this.identity.reverse_pic,
                },
            }).then((res) => {
                if (res.data.code == 200) {
                    this.$notify({
                        title: res.data.msg,

                        type: "success",
                    });
                    this.getBalance()
                }
            });
        },
        register() {
            axios({
                url: "/system/user/register",
                method: "POST",
                data: {
                    confirmPassword: this.user.re_input_pass,
                    inviteCode: this.user.invite_code,
                    password: this.user.input_password,
                    userName: this.user.input_email,
                    validCode: this.user.validCode
                },
            }).then((res) => {
                if (res.data.code == 200) {
                    this.$notify({
                        title: "成功",
                        message: "welcome_login",
                        type: "success",
                    });
                    this.active = 12;
                }
            });
        },
        changeType() {
            this.timer && clearInterval(this.timer)
            this.loopPage = 0
            this.page.pageNum = 1
            this.marketList = []
            this.getMarket(true)
            this.getLoop()
        },
        getMarketTermList(){
            axios({
                method: "get",
                url: `/itemTerm/getList?itemName=`+this.market.symbol,
            }).then((res) => {
                if (res.data.code == 200) {
                    this.marketTermList = res.data.data;
                    this.selectedMarketTerm = res.data.data[0];
                }
            });
        },
        operateClick(active) {
            if (this.is_mock) {
                this.$notify({
                    title: `${this.local.user.only_true_account}`,
                    type: "warning",
                });
            } else {
                this.active = active
            }
        },
        set_stop_price() {
            axios({
                method: "post",
                url: `/order/setStopPrice`,
                params: {
                    orderNo: this.stop.orderNo,
                    stop_price_profit: this.stop.target_profit_price || 0,
                    stop_price_loss: this.stop.stop_loss_price || 0,
                    price: this.trade_list[this.stop.index].mark_price,
                }
            }).then((res) => {
                if (res.data.code == 200) {
                    this.gettrade_list(1);
                    this.active = -1
                    this.stop = {
                        stop_price_profit: 0,
                        stop_price_loss: 0,
                    }
                    this.$notify({
                        type: "success",
                        title: res.data.msg,
                    });
                }
            });
        },
        submitOrder(type) {
            if (!this.order.stop_loss_status) {
                this.order.stop_loss = 0;
            }
            if (!this.order.stop_profit) {
                this.order.stop_profit = 0;
            }


            let str = `/order/open?direction=${type == "1" ? "buy" : "sell"
                }&handCount=${this.order.trade_amount}&lever_rate=${this.order.times
                }&price=${this.order.market_price == 2
                    ? this.order.target_price
                    : this.market.close
                }&amount=${this.order.trade_amount * this.market.item.unitAmount
                }&symbol=${this.market.symbol}&price_type=${this.order.market_price == 1 ? "opponent" : "limit"
                }`;
            if (this.order.stop_loss) {
                str += `&stop_price_loss=${this.order.stop_loss + ""
                    }`
            }

            if (this.order.stop_profit) {
                str += `&stop_price_profit=${this.order.stop_profit + ""}`
            }

            axios({
                url: str,
                method: "POST",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.gettrade_list(1);
                    this.getBalance();
                    this.$notify({
                        type: "success",
                        title: res.data.msg,
                    });
                }
            });
        },

        getWallet() {
            axios({
                url: "/api/agentBank/getMyBank",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.walletListTop = res.data.data;
                    if (this.walletListTop.length > 0) {
                        this.bankWthdrawal = this.walletListTop[0];
                    }
                }
            });
            axios({
                url: "/api/currencyAddress/getPage",
                method: "GET",
            }).then((res) => {
                console.log(res.data);
                if (res.data.code == 200) {
                    this.walletListBottom = res.data.data;
                    if (this.walletListBottom.length > 0) {
                        // this.Wthdrawal.draw_method_id = this.walletListBottom[0].id;
                    }
                }
            });
        },
        cancelCurrencyTop(id) {
            this.cur_id = id;
            this.$confirm(`確定刪除嗎？`, `${this.local.public.tip}`, {
                confirmButtonText: `${this.local.public.confirm}`,
                cancelButtonText: `${this.local.public.cancel}`,
                type: "warning",
            }).then(() => {
                axios({
                    url: `/api/agentBank/deleteById?id=${this.cur_id}`,
                    method: "DELETE",
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.getWallet();

                        this.$notify({
                            type: "success",
                            title: res.data.msg,
                        });
                    }
                });
            });
        },

        cancelCurrencyButtom(id) {
            this.cur_id = id;
            this.$confirm(`確定刪除嗎？`, `${this.local.public.tip}`, {
                confirmButtonText: `${this.local.public.confirm}`,
                cancelButtonText: `${this.local.public.cancel}`,
                type: "warning",
            }).then(() => {
                axios({
                    url: `/api/currencyAddress/deleteById?id=${this.cur_id}`,
                    method: "DELETE",
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.getWallet();
                        this.$notify({
                            type: "success",
                            title: res.data.msg,
                        });
                    }
                });
            });
        },

        get_wire_info(num) {
            // axios({
            //   method: "GET",
            //   url: `/api/quickCharge/wire_info?bank_coin=${this.currencyRight.id}`,
            // }).then((res) => {
            //   this.wireList = res.data.data;
            //   this.currencyRight.wire_id = this.wireList[0].id;
            // });
            this.wireList = this.bankcardList[num].bankInfo[0];

            console.log(this.currencyRight);

            this.currencyRight = this.bankcardList[num]
            this.currencyRight.wire_id = this.wireList[0]?.id;
        },

        getCurrency() {
            axios({
                url: "/api/currencySetting/getCurrency",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.currencyList = res.data.data;
                    if (this.currencyList.length > 0) {
                        // this.bankWthdrawal.draw_method_id = this.currencyList[0].id * 1;
                        this.bankWthdrawal1 = this.currencyList[0]
                    }
                }
            });
        },
        submitCurrency() {
            axios({
                url: "/api/agentBank/addMyBank",
                method: "POST",
                data: {
                    currencyId: this.currency.id,
                    type: this.currency.currency_type,
                    name: this.currency.bank_name,
                    address: this.currency.bank_address,
                    swift: this.currency.bank_swift,
                    payee: this.currency.payee_name,
                    account: this.currency.payee_account,
                },
            }).then((res) => {
                if (res.data.code == 200) {
                    this.active = 6;
                }
            });
        },
        // 获取出金数字货币地址
        getGoldOutAll() {
            axios({
                url: "/api/goldOut/getAll",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.digitalList = res.data.data;
                    if (this.digitalList.length > 0) {
                        this.Wthdrawal = this.digitalList[0];
                        this.walletListBottom = this.Wthdrawal.addresses
                    }
                }
            });
        },
        // 获取客服-
        getOnline() {
            axios({
                url: "api/getCustomerService",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.onlineList = res.data.data;
                }
            });
        },
        // 获取邮箱-
        getEmail() {
            axios({
                url: "/api/getEmail",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.email = res.data.data[0]?.emailAddress;
                }
            });
        },
        // 出金数字货币地址切换
        wthdrawalChage(item) {
            this.walletListBottom = item.addresses
        },
        // 获取出金银行卡地址
        getGoldOutBankInfo() {
            axios({
                url: "/api/goldOut/getBankInfo",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.currencyList = res.data.data;
                    if (this.currencyList.length > 0) {
                        this.bankWthdrawal1 = this.currencyList[0]
                        this.walletListTop = this.currencyList[0].bankInfo[0].length > 0 ? this.currencyList[0].bankInfo[0] : []
                    }
                }
            });
        },
        bankWthdrawal1Change(item) {
            this.bankWthdrawal = ''
            this.walletListTop = item.bankInfo.length > 0 ? item.bankInfo[0] : []
        },
        getDigital() {
            axios({
                url: "/api/currency/get",
                method: "GET",
            }).then((res) => {
                if (res.data.code == 200) {
                    this.digitalList = res.data.data;
                    console.log(this.digitalList);
                    if (this.digitalList.length > 0) {
                        this.Wthdrawal = this.digitalList[0];
                    }
                }
            });
        },
        submitDigital() {
            axios({
                url: "/api/currencyAddress/add",
                method: "POST",
                data: {
                    currencyId: this.digital.id,
                    type: this.digital.freeType,

                    address: this.digital.dc_address,
                },
            }).then((res) => {
                if (res.data.code == 200) {
                    this.active = 6;
                }
            });
        },

        // getBalance() {
        //   axios({
        //     url: "/v1/api/main/wallet/getBalance",
        //   }).then((res) => {
        //     console.log(res.data);
        //     if (res.data.code == 1) {
        //       this.user_balance = Number(res.data.data.balance).toFixed(2);
        //     }
        //   });
        // },

        CancelOrder(item) {
            this.pro_id = item.orderNo;
            this.$confirm(`是否撤单`, `${this.local.public.tip}`, {
                confirmButtonText: `${this.local.public.confirm}`,
                cancelButtonText: `${this.local.public.cancel}`,
                type: "warning",
            }).then(() => {
                axios({
                    url: `/order/cancel?orderNo=${this.pro_id}`,
                    method: "POST",
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.gettrade_list(0);
                        this.$notify({
                            type: "success",
                            title: res.data.msg,
                        });
                    }
                });
            });
        },
        submitbankWthdrawal() {
            let free = 0
            let lastNum = 0
            if (this.bankWthdrawal1.freeType == 1) {
                free = this.bankWthdrawal.number ? this.bankWthdrawal1.free : 0
                lastNum = this.bankWthdrawal.number ? this.bankWthdrawal.number /
                    this.bankWthdrawal1.usdFree - this.bankWthdrawal1.free /
                    this.bankWthdrawal1.usdFree : 0
            } else {
                free = this.bankWthdrawal.number ? this.bankWthdrawal.number *
                    this.bankWthdrawal1.free : 0
                lastNum = this.bankWthdrawal.number ? this.bankWthdrawal.number /
                    this.bankWthdrawal1.usdFree - this.bankWthdrawal.number *
                    this.bankWthdrawal1.free / this.bankWthdrawal1.usdFree
                    : 0
            }
            axios({
                method: "POST",
                url: "/api/goldOut/bankCommit",
                data: {
                    currencyId: this.bankWthdrawal1.id,
                    num: this.bankWthdrawal.number,
                    remark: this.bankWthdrawal.memo,
                    bankId: this.bankWthdrawal.id,
                    free: free,
                    lastNum: lastNum,
                },
            }).then((res) => {
                if (res.data.cpde == 200) {
                    this.$notify({
                        type: "success",
                        title: res.data.msg,
                    });
                    this.getquick_ist(1, 1);
                }
            });
        },

        submitWthdrawal() {
            let free = 0
            let lastNum = 0
            if (this.Wthdrawal.freeType == 0) {
                free = this.Wthdrawal.number ? this.Wthdrawal.number * this.Wthdrawal.withdrawalRate : 0
                lastNum = this.Wthdrawal.number ? this.Wthdrawal.number / this.Wthdrawal.usdRate - (this.Wthdrawal.number ? this.Wthdrawal.number *
                    this.Wthdrawal.withdrawalRate / this.Wthdrawal.usdRate : 0) : 0
            } else {
                free = this.Wthdrawal.withdrawalRate ? this.Wthdrawal.withdrawalRate : 0
                lastNum = this.Wthdrawal.number ? this.Wthdrawal.number /
                    this.Wthdrawal.usdRate - (this.Wthdrawal.withdrawalRate ?
                        this.Wthdrawal.withdrawalRate / this.Wthdrawal.usdRate : 0) : 0
            }
            axios({
                method: "POST",
                url: "/api/goldOut/currencyCommit",
                data: {
                    currencyId: this.Wthdrawal.id,
                    num: this.Wthdrawal.number,
                    remark: this.Wthdrawal.memo,
                    addressId: this.Wthdrawal.draw_method_id,
                    free: free,
                    lastNum: lastNum,

                },
            }).then(res => {
                if (res.data.code == 200) {
                    this.getquick_ist(0, 1);
                    this.$notify({
                        title: res.data.msg,
                        type: "success",
                    });
                }


            })
        },

        ClosePosition(item) {
            this.pro_id = item.orderNo;
            this.$confirm(
                `${this.local.order.confrim_close_order}`,
                `${this.local.public.tip}`,
                {
                    confirmButtonText: `${this.local.public.confirm}`,
                    cancelButtonText: `${this.local.public.cancel}`,
                    type: "warning",
                }
            ).then(() => {
                axios({
                    url: `/order/close?orderNo=${this.pro_id}`,
                    method: "POST",
                }).then((res) => {
                    if (res.data.code == 1) {
                        this.gettrade_list(1);
                        this.$notify({
                            type: "success",
                            title: res.data.msg,
                        });
                    }
                });
            });
        },

        changeCountry() {
            window.localStorage.setItem("language", this.conturyValue);
            this.language = this.conturyValue;
            this.local = obj[this.language];
            location.reload()
        },
        setWireid(item) {
            this.currencyRight.wire_id = item.id;
            // this.$set(this.currencyRight, "wire_id", item.id);
            // this.$set(this.currencyRight, "aaa", new Date().getTime());

            console.log(this.currencyRight);
            //
        },

        copy(copyText) {
            navigator.clipboard.writeText(copyText);
            this.$notify({
                title: this.local.public.copy_success,
                type: "success",
            });
            /* 弹出已复制的内容 */

        },

        changeLoginPassword() {
            axios({
                url: `/system/user/changeLoginPassword?password=${this.resert.password}&confirmPassword=${this.resert.confirmPassword}`,
                method: "POST",
            }).then((res) => {
                this.active = -1;
                this.dialogShow = false;
            });
        },
        writeSubmit() {
            axios({
                //url: `/api/quickCharge/wire_submit?number=${this.currencyRight.number}&proofImg=${this.currencyRight.proofImg}&wire_id=${this.currencyRight.wire_id}`,
                url: "/api/goldDeposit/goldCommitAndBank",
                method: "POST",
                data: {
                    currencyName: this.currencyRight.currencyName,
                    // currencyType:this.currencyRight.currencyType,
                    type: 1,
                    currencyId: this.currencyRight.currencyId,

                    bankId: this.currencyRight.wire_id,
                    num: this.currencyRight.number,
                    payRemark: this.currencyRight.proofImg,
                },
            }).then((res) => {
                if (res.data.code == 200) {
                    this.currencyRight.proofImg = "";
                    this.getquick_ist(1, 0);
                    this.$notify({
                        title: res.data.msg,
                        type: "success",
                    });
                }
            });
        },
        loginOut() {
            this.$confirm(
                `${this.local.user.confirm_logout}`,
                `${this.local.public.tip}`,
                {
                    confirmButtonText: `${this.local.public.confirm}`,
                    cancelButtonText: `${this.local.public.cancel}`,
                    type: "warning",
                }
            ).then(() => {
                this.$notify({
                    type: "success",
                    duration: 1000,
                    title: `${this.local.user.logout_success}`,
                });
                window.localStorage.removeItem("token");
                window.localStorage.removeItem("is_mock");
                this.loginStaus = false;
                this.active = 0;
                this.dialogShow = false;
            }).catch(e => {

            })
        },
        numChange() {
            this.getAddress()
        },
        netWorkChange(item) {
            this.financial = this.deepClone(item)
            this.getAddress()
        },
        getAddress() {
            let num = this.financial.num
            let currencyType = this.financial.currencyType
            if (!num || !currencyType) { return }
            // whiteFlag --1 白名单
            if (this.userInfo.user.whiteFlag != 1) {
                if (num && currencyType) {
                    debugger
                    let findObj = this.NetworkList.find(item => { return item.id == this.financial.id })
                    if (!!Number(findObj.thresholdPrice) && num * findObj.usdRate >= findObj.thresholdPrice) {
                        this.financial.address = findObj.adminAddress || findObj.address
                    } else {
                        this.financial.address = findObj.address
                    }
                }
            }
        },
        serviceClick(address) {
            window.open(address)
        },
        send(email) {
            if (email) {
                axios({
                    url: `/sendEmailCode?email=${email}`,
                    method: "POST",
                }).then((res) => {
                    this.flag = true
                    this.time = 60
                    this.code_timer = setInterval(() => {
                        this.time--;
                        if (this.time <= 0) {
                            clearInterval(this.code_timer);
                            this.flag = false
                        }
                    }, 1000)
                });
            }
        },
        //忘记密码
        forgetPassWord() {
            if (this.forgot.userName && this.forgot.password && this.forgot.confirmPassword && this.forgot.validCode) {
                axios({
                    url: `/system/user/forgetLoginPassword`,
                    method: "POST",
                    data: {
                        userName: this.forgot.userName,
                        password: this.forgot.password,
                        confirmPassword: this.forgot.confirmPassword,
                        validCode: this.forgot.validCode,
                    }
                }).then((res) => {
                    if (res.code == 200) {
                        this.$notify({
                            type: "success",
                            title: res.data.msg,
                        });
                    }
                });
            }
        }
    },
};
</script>


<style>
@import "@/assets/DEMO_files/home63023cc0.css";
@import "@/assets/DEMO_files/vendora3865e1a.css";
@import "@/assets/DEMO_files/vendor7efdaa27.css";
/* @import "@/assets/DEMO_files/index7236cd45.css"; */
@import "@/assets/DEMO_files/index.css";
@import "@/assets/DEMO_files/index6ab49916.css";




.symbol {
    display: none !important;
}

.klinecharts-pro-widget {
    flex: 1;
}

.leftbox,
.rightbox,
.list,
.order,
.rightfixed {
    display: none;
}

.bg-active {
    background: #ccc !important;
}

.sms_code_btn {
    min-height: unset !important;
    height: 30px;
    line-height: 30px;
    padding: 4px 20px !important;
    border-radius: 15px !important;
}

.sms_code {
    display: flex;
    justify-content: space-between;
}

.sms_code_input {
    width: 50% !important;
}
.min-w-\[1400px\] {
    min-width: 1400px !important;
    min-height: 50px; /* 可选的最小高度 */
    height: 200vh; /* 默认值，可不写 */
}
</style>
